import {
  IonFab,
  IonFabButton,
  IonModal,
  IonRefresher,
  IonRefresherContent,
  IonSearchbar,
  IonSpinner,
  IonTextarea,
  useIonToast,
} from "@ionic/react";
import {
  person,
  arrowBackOutline,
  arrowForwardOutline,
  searchSharp,
  close,
  pricetag,
  pencil,
  logoFacebook,
  logoInstagram,
  logoYoutube,
  logoLinkedin,
  trashBin,
  navigate,
  navigateSharp,
  enterOutline,
  grid,
  chevronUp,
  save,
  logoWhatsapp,
  menu,
  qrCodeOutline,
  settingsOutline,
  hammer,
  globe,
  analytics,
  arrowForward,
} from "ionicons/icons";
import { add } from "ionicons/icons";
import {
  IonButton,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonImg,
  IonInput,
  IonItem,
  IonLabel,
  IonPage,
  IonPopover,
  IonRow,
  IonAlert,
} from "@ionic/react";
import { useInView } from "react-intersection-observer";
import React, {
  useState,
  useEffect,
  useMemo,
  useRef,
  lazy,
  Suspense,
} from "react";
import {
  useAppDispatch,
  useAppSelector,
  useCustomToast,
  useModalController,
  useRecordUserInteractions,
  useSaveVcard,
  useStringToast,
  userActionsTable,
} from "../app/hooks";
import { cart, searchOutline, menuOutline } from "ionicons/icons";
import {
  SEPARATOR_MULTI_INPUT,
  mobileWidthBreakpoint,
} from "../types/form_table_data_types";
import deepCopy from "../common/deepcopy";
import { useHistory, useLocation } from "react-router";
import { useParams } from "react-router-dom";
import {
  getSessionDetails,
  storeSessionDetails,
  setCookie,
} from "../common/cookies";
import { Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import VypzeeFooter from "../components/VypzeeFooter";
import {
  API_SECURE_KEY,
  IDIGIZEN_BACKEND_URL,
  getCompanyDomainFromParamsDB,
  getBhpCompanyDetailsDB,
  getBhpProductDetailsDB,
  getFileThumbnailDB,
  knownDomains,
  userInfoRouter,
  contactSupport,
  getBhpMarketsDB,
  getTinyUrlDetailsDB,
  getBhpHotKeysDB,
  validateCouponDB,
  redeemCouponDB,
  IDIGIZEN_FRONTEND_URL,
  getLoyaltyProgramRulesDB,
  addRedeemLoyaltyPointsDB,
  whatsappMessage,
  getSetResetPasswordDB,
  getPageType,
  getBhpTestimonialsDetailsDB,
  bhpEditLinks,
  bhpEditLinksBNIChapter,
  bhpEditLinksBNIMember,
  associateShopWithUser,
  assignBhpStockImagesDB,
  saveShopChecklistDataDB,
  getShopChecklistDataDB,
  downloadRawQrForShop,
  sendQueryForProductInfo,
  UserInteractionRecordType,
  getVisitCountDB,
  getPrivilegeCardTypesDB,
  getFaqDB,
} from "../types/constants";
import axios from "axios";
import {
  getCurrentTime,
  getLogo,
  getParamsFromSearchString,
  goToGoogleMapsNav,
  fetchImgThumbnailData,
  downloadVCard,
  getSeoUrl,
  promptFileDownload,
  presentLocalStorageItem,
  setLocalStorageItem,
  getLocalStorageItem,
  isMalware,
  getPrintDateDDMMYYYY,
} from "../common/commonFunctions";
import { convertImgJsonToObj } from "../common/commonFunctions";

import {
  AlertWithExecTypes,
  AlertWithoutExecTypes,
  FileBundleType,
  PositionType,
  AdvertisingDetailsType,
  bhpRwaPersonalDetailsUrl,
  SubscriptionType,
  MapsGooglePromptType,
  CartItemTypes,
  AdvanceCustomizationType,
  BhpCampaignType,
} from "../types/data_types";
import ProductPageFooter from "../components/ProductPageFooter";
// import ViewImage from "./ViewImage";
import { BussinessCatalogueProducts } from "../types/data_types";

import "./../components/styles/ImageRotateStyle.css";
import BhpBizCard from "../components/BhpBizCard";
import LazyLoaderSpinner from "../components/LazyLoaderSpinner";
import {
  BhpMenuButton,
  BhpSearchIconButton,
} from "../components/BussinessHomeHeader";
import BhpAdBannerWrapper from "../components/BhpAdBannerWrapper";
import Card from "../UI/Card";
import { BhpCreateBizCardModal } from "../components/BhpRwaModeFaceButtons";
import BhpSearchModalWraper from "../components/BhpSearchModalWraper";
import { loginInfoActions } from "../store/login-info-slice";
// import BhpSubscribeModal from "../components/BhpSubscribeModal";
import "./styles/BussinessHomePage.css";
import BhpTrendsSection from "../components/BhpTrendsSection";
import BhpTestimonialModal from "../components/BhpTestimonialModal";
import {
  getBhpShareMessage,
  isMobileNumber,
} from "../types/bhp_common_function";
import BhpContactCard from "../components/BhpContactCard";
import BhpFirstFoldPage from "../components/BhpFirstFoldPage";
import store from "../store";
import { PrivilegeCardType } from "./BhpPrivilegePage";
import GlobalPageRefresher from "../UI/GlobalPageRefresher";
// const BhpHotOffers = lazy(() => import("../components/BhpHotOffers"));
const BhpFaq = lazy(() => import("../components/BhpFaq"));
const BhpLoyaltyCard = lazy(() => import("../components/BhpLoyaltyCard"));
const BhpOrderModal = lazy(() => import("../components/BhpOrderModal"));
const BhpRwaOfficeBearers = lazy(
  () => import("../components/BhpRwaOfficeBearers")
);
// import TranslateModal from "../components/GoogleTranslateModal";
// import { isMainThread } from "worker_threads";
const BussinessHomeHeader = lazy(
  () => import("../components/BussinessHomeHeader")
);
const BhpStoreOwnerDashboard = lazy(
  () => import("../components/BhpStoreOwnerDashboard")
);
const BhpOnlineHealth = lazy(() => import("../components/BhpOnlineHealth"));
const BhpHighlightProduct = lazy(
  () => import("../components/BhpHighlightProduct")
);
const OpenQrCode = lazy(() => import("../components/OpenQrCode"));
const BhpFloorSelector = lazy(() => import("../components/BhpFloorSelector"));
const BhpAdminShopChecklist = lazy(
  () => import("../components/BhpAdminShopChecklist")
);
const BhpAdvStoreIntroCard = lazy(
  () => import("../components/BhpAdvStoreIntroCard")
);
// const BhpMarketIntroCard = lazy(
//   () => import("../components/BhpMarketIntroCard")
// );
// const BhpPromoModal = lazy(() => import("../components/BhpPromoModal"));
const BhpPopoverCustom = lazy(() => import("../components/BhpPopoverCustom"));
const Testimonial = lazy(() => import("../components/Testimonials"));
const BhpSubscribeModal = lazy(() => import("../components/BhpSubscribeModal"));
const BhpViewExpandedProd = lazy(
  () => import("../components/BhpViewExpandedProd")
);
const TermsAndConditions = lazy(
  () => import("../components/TermsAndConditions")
);
const BhpCategoryCard = lazy(() => import("../components/BhpCategoryCard"));
const ContentWithBackground = lazy(() => import("../UI/ContentWithBackground"));
const BhpSearchModal = lazy(() => import("../components/BhpSearchModal"));
const TableBookingModal = lazy(() => import("../components/TableBookingModal"));
const BhpGenerateDiscount = lazy(
  () => import("../components/BhpGenerateDiscount")
);
const BhpChangePasswordModal = lazy(
  () => import("../components/BhpChangePasswordModal")
);
const BhpCategoriesSelection = lazy(
  () => import("../components/BhpCategoriesSelection")
);
const BhpResidentCardModal = lazy(
  () => import("../components/BhpResidentCardModal")
);
const CallWhatsappSelPrompt = lazy(
  () => import("../components/CallWhatsappSelPrompt")
);
const BhpMenuPopover = lazy(() => import("../components/BhpMenuPopover"));
const BhpSelectedShop = lazy(() => import("../components/BhpSelectedShop"));
const BhpSaveBusinessCardNotes = lazy(
  () => import("../components/BhpSaveBusinessCardNotes")
);
// const BhpSearchModalWraper = lazy(
//   () => import("../components/BhpSearchModalWraper")
// );
const BusinessCategorySection = lazy(
  () => import("../components/BusinessCategorySection")
);
const BhpRwaModeFaceButtons = lazy(
  () => import("../components/BhpRwaModeFaceButtons")
);

const BhpShowAllPromoModal = lazy(
  () => import("../components/BhpShowAllPromoModal")
);
const BhpCouponPromoModal = lazy(
  () => import("../components/BhpCouponPromoModal")
);
const BhpExpandCardView = lazy(() => import("../components/BhpExpandCardView"));
const AlertWithoutExec = lazy(() => import("../UI/AlertWithoutExec"));
const BhpCartModal = lazy(() => import("../components/BhpCartModal"));
const BhpAddToCartCard = lazy(() => import("../components/BhpAddToCartCard"));
const ViewImage = lazy(() => import("./ViewImage"));
const AlertWithExec = lazy(() => import("../UI/AlertWithExec"));
const SignInSignUpSelector = lazy(
  () => import("../components/SignInSignUpSelector")
);
const SignInSignUpModal = lazy(() => import("../components/SignInSignUpModal"));
const BhpRetargetBanner = lazy(() => import("../components/BhpRetargetBanner"));
// const SelectionList = lazy(() => import("../UI/SelectionList"));
// Params
// assignStockImg - To assign stock image to the shops
// adMarker - to got to mode which creates the link for adding ad
// navShopId - this is a shop id which will open the nav
// feedbackBtn - to paint feedback button or not
// openNav -  to open the navigation popup by default
// openAd - Open the 1st ad
// promptFeedbackNDirection - To open popover selection
// buildShoppingList - This when present will override the market feedback

type BhpShopStatusType =
  | "OPEN"
  | "REJECTED-VERIFICATION"
  | "REJECTED-PRODUCTS"
  | "REJECTED-QR"
  | "REVISIT-OWNER-NOT-FOUND"
  | "REVISIT-OWNER-BUSY"
  | "REVISIT-SHOP-CROWDED"
  | "REVISIT-FOLLOWUP-PROVIDED"
  | "NOT_FOUND-SHOP-SHIFTED"
  | "NOT_FOUND-SHOP-TEMP-CLOSED"
  | "NOT_FOUND-SHOP-NOT-IN-MARKET"
  | "NOT_FOUND-CANNOT-LOCATE"
  | "DELETE-SHOP-PERMANENTLY-CLOSED"
  | "DELETE-DUPLICATE-SHOP"
  | "DELETE-OWNER-NOT-INTERESTED"
  | "DELETE-SHOP"
  | "PHASE2-COMPLETE"
  | "NONE"
  | "OTHERS";

interface MarketShopStatusHistoryDataType {
  id: number;
  userName: string;
  userId: number;
  createdOn: string;
  followupDate?: string;
  followupTime?: string;
  notes?: string;
  status: BhpShopStatusType;
}

interface MarketShopStatusDataType {
  id: number;
  status: BhpShopStatusType;
  shopName: boolean;
  shopPhone: boolean;
  shopAddress: boolean;
  shopDealsIn: boolean;
  shopQr: boolean;
  phase2ForceDone?: boolean;
  phase3Prospect?: string;
  // notes?: string;
  waitingDate?: string;
  waitingTime?: string;
  history?: MarketShopStatusHistoryDataType[];
}

interface SubheaderButtonType {
  name: string;
  onClick: () => void;
  color: "primary" | "secondary" | "tertiary" | "medium" | "dark" | "none";
  fill: "clear" | "solid" | "outline";
  fontSize?: string;
}

const theme = {
  greyTheme: {
    defaultCardColor: "white",
    selectedCardColor: "rgba(var(--ion-color-primary-rgb),0.2)",
    specialCardColor: "var(--ion-color-bhp-footer)",
    prodImgBgColor: "var(--ion-color-light)",

    specialCardTextColor: "white",
    defaultCardtextColor: "black",
  },
  yellowTheme: {
    defaultCardColor: "white",
    selectedCardColor: "rgba(var(--ion-color-primary-rgb),0.2)",
    specialCardColor: "white",
    prodImgBgDefaultColor: "var(--ion-color-bhp-base)",
    prodImgBgSpecialColor: "#faf6e1",
    specialCardTextColor: "black",
    defaultCardtextColor: "black",
    catProdDefaultBg: "white",
    catProdSpecialBg: ["#f2f4cc", "#faf0de"],
  },
};

type OrderModeType = "booking" | "enquiry" | "itemized-order" | "cam-order";

interface ResidentDetailsType {
  open: boolean;
  address: string;
  name: string;
  id: string;
  catImg: string;
  profession: string;
  phones: string[];
  hasBusiness?: boolean;
}

interface ColorThemeInterface {
  defaultCardColor: string;
  selectedCardColor: string;
  specialCardColor: string;
  prodImgBgSpecialColor: string;
  prodImgBgDefaultColor: string;
  specialCardTextColor: string;
  defaultCardtextColor: string;
  catProdSpecialBg: string[];
}

interface SeoUrlDetailsType {
  stateUrl: string;
  cityUrl: string;
  marketUrl: string;
  shopUrl?: string;
  resolvedUrl?: string;
  title?: string;
}

type BhpMarketTypes = "RWA" | "MARKET" | "USER" | "VYPZEE" | "MARKET_CLUSTER";

interface PopoverPromoType {
  id: number;
  image: string;
  imageData?: string;
  enableSubscribe: boolean;
  thankYouMessage?: string;
}

interface BusinessDetailsType {
  id: string;
  name: string;
  banner: string;
  verified?: boolean;
  logo: string;
  logoImgObj?: { fileName: string; rotation: number };
  bannerText: string;
  tagline: string;
  description: string;
  shortDescription?: string;
  location?: PositionType;
  locationUrl?: string;
  images?: string[];
  isMarket: boolean;
  subType?: string;
  marketName?: string;
  marketDomain?: string;
  marketId?: string;
  marketLogo?: string;
  contactPersonPhoneNums?: string[];
  contactPersonEmail?: string;
  address?: string;
  domainName?: string;
  socialMedia?: {
    facebookLink?: string;
    instagramLink?: string;
    youtubeLink?: string;
    linkedinLink?: string;
  };
  website?: string;
  category?: string;
  categoryImg?: { fileName: string };
  orderMode?: "order" | "query" | "booking";
  enableQtyOrder?: boolean;
  enableTimeSel?: boolean;
  subscriptionType?: SubscriptionType;
  deliveryNotes?: string;
  vCardPromo?: string;
  listModeListing?: boolean;
  marketType?: BhpMarketTypes;
  seoUrlDetails?: SeoUrlDetailsType;
  orderingDetails?: {
    id: string | number;
    type:
      | "Zomato"
      | "Swiggy"
      | "Amazon"
      | "Meesho"
      | "Flipkart"
      | "Our Website"
      | "Others";
    othersSpecify: string;
    url: string;
  }[];
  floorId?: number;
  bhpEditLinks?: any;
  additionalReviewPath?: string; //support for store/makets to attach additional review form.
  maxDiscountAmt?: string;
  maxDiscountPerc?: string;
  reviewScore?: number;
  reviewNotAutoApprove?: boolean;
  websiteStrength?: number;
}

interface BusinessProductCategoryWithProducts {
  id: string | number;
  category: string;
  categoryDescription?: string;
  catImgObj?: { fileName: string; rotation: number; imgCss: string };
  catIconImgObj?: { fileName: string; rotation: number; imgCss: string };
  isMultiProd: boolean;
  isSpecial?: boolean;
  isNotListed?: boolean;
  products: BussinessCatalogueProducts[];
  numProducts: number;
  isFeatured?: boolean;
  directoryMode?: boolean;
  subHeaderPicMode?: boolean;
  domain?: string;
  defaultMaxListSize?: number;
  bannerText?: string;
  listModeListing?: boolean | number;
  seoUrlDetails?: SeoUrlDetailsType;
}

interface BhpHotKeysType {
  id: number;
  imgFileName: string;
  name: string;
  anchorTag?: string;
  functionName: string;
}

interface BussinessHomeCardData {
  advertising?: AdvertisingDetailsType[];
  id: string;
  imagePath: string[];
  stockImage?: string;
  imageData?: string[];
  title: string;
  subtitle?: string;
  text: string;
  productList: string;
  domain?: string;
  isSpecial: boolean;
  isNotListed?: boolean;
  variant: {
    option: string;
    price: number;
    unit: string;
    listPrice?: number;
  }[];
  subscriptionType?: SubscriptionType;
  seoUrlDetails?: SeoUrlDetailsType;
}

// const floorOrder = {
//   gf: 1,
//   ff: 2,
//   sf: 3,
//   "ground floor": 1,
//   "upper ground floor": 2,
//   "first floor": 3,
//   "second floor": 4,
//   basement: 5,
//   other: 100,
// };

// interface BusinessProductDetails {
//   id: string;
//   image: string[];
//   name: string;
//   category: string;
//   categoryDescription?: string;
//   catImgObj?: { fileName: string; rotation: number; imgCss: string };
//   catIconImgObj?: { fileName: string; rotation: number; imgCss: string };
//   isMultiProd: boolean;
//   description: string;
//   productList: string;
//   domain?: string;
//   advertising?: AdvertisingDetailsType[];
//   isSpecial?: boolean;
//   variant: {
//     option: string;
//     price: number;
//     listPrice?: number;
//     unit: string;
//   }[];
//   phoneNumbers?: string;
//   shortDescription?: string;
//   hasSpecials?: boolean;
//   subscriptionType?: SubscriptionType;
// }

interface BusinessTeamDetails {
  id: string;
  name: string;
  img: string;
  aboutme: string;
}

interface BusinessTestimonialDetails {
  id: string;
  customerName: string;
  customerPhone: string;
  rating: number;
  feedback: string;
  createdOn: string;
}

interface CustomerDetailsType {
  id: number;
  name: string;
  phone: number;
  email: string;
  address: string;
  couponCode?: string;
  merchantName?: string;
  couponDescription?: string;
}

interface StyleDataType {
  headerBg: string;
  headerFontColor: string;
  headerBaseColor: string;
  headerBaseColorHighlight: string;
  headerStyle: "CIRCLE_ICON" | "CARD_ICON";
  reducedDrawerMenu: "true" | "false";
  showFloorSelector: "true" | "false";
  showVypzeeFooter: "true" | "false";
  showVypzeeFooterOverride?: {
    image?: { fileName: string; rotation: number };
    url?: string;
    imagePosition?: string;
  };
  dontShowBanner: "true" | "false";
  dontShowBizCard: "true" | "false";
  headerLogoMode: "true" | "false";
  ctaBtnBg: string;
  ctaBtnColor: string;
  noBannerSubtext: "true" | "false";
  bannerCtaBtnDisable: "true" | "false";
  disableHeaderCta: "true" | "false";
}

interface TextCartItemType {
  img: FileBundleType;
  name: string;
  count: number;
  uid: string;
  unit?: string;
  price?: number;
  label?: string;
  notes: string;
  nameEditable?: boolean;
}

/**************************************************************************************
 * Name: BhpThemeHeaderWithBack
 * Description: Header component for the Business Home Page.
 **************************************************************************************/
const BhpThemeHeaderWithBack: React.FC<{
  title: string;
  subTitle?: string;
  onBack?: () => void;
  button?: { name: string; exec: () => void };
  img?: string;
  logo?: string;
  headerTextDisableBottom?: boolean;
}> = (props) => {
  const url = props.img
    ? `${IDIGIZEN_BACKEND_URL}/${getFileThumbnailDB}?fileName=${props.img}&percentage=40&Authorization=${API_SECURE_KEY}`
    : "";
  const logoUrl = props.logo
    ? `${IDIGIZEN_BACKEND_URL}/${getFileThumbnailDB}?fileName=${props.logo}&percentage=40&Authorization=${API_SECURE_KEY}`
    : "";
  return (
    <IonHeader>
      <div className={`bhp-header-top`}>
        <div
          className="bussiness-home-page-hdr-text"
          style={{
            padding: "10px",
            alignItems: "center",
            paddingBottom: props?.headerTextDisableBottom ? 0 : "10px",
          }}
        >
          <div
            className={`bussiness-home-page-hdr-mkt-name`}
            style={{
              display: "flex",
              alignItems: "center",
              color: "var(--ion-color-bhp-footer)",
            }}
          >
            {!!props.onBack && !url && (
              <IonButton
                size="small"
                fill="clear"
                color={"danger"}
                onClick={props.onBack}
              >
                <IonIcon icon={arrowBackOutline} />
              </IonButton>
            )}
            {!!url && (
              <div
                style={{
                  height: "75px",
                  width: "75px",
                  overflow: "hidden",
                  borderRadius: "50%",
                  marginRight: "10px",
                  border: "1px solid var(--ion-color-medium)",
                  flexShrink: 0,
                }}
              >
                <img
                  src={url}
                  alt=""
                  style={{ height: "100%", width: "100%", objectFit: "cover" }}
                />
              </div>
            )}
            <div>
              <div>{props.title}</div>
              {!!props.subTitle && (
                <div style={{ fontSize: "0.8rem", fontWeight: "normal" }}>
                  {props.subTitle}
                </div>
              )}
            </div>
          </div>
          {!!logoUrl && (
            <div
              style={{
                height: "50px",
                overflow: "hidden",
                marginRight: "10px",
                border: "1px solid var(--ion-color-medium)",
                borderRadius: "8px",
                flexShrink: 0,
              }}
            >
              <img
                src={logoUrl}
                alt=""
                style={{ height: "100%", width: "100%", objectFit: "contain" }}
              />
            </div>
          )}
          {!!props.button && (
            <div style={{ paddingLeft: "10px", flexShrink: "0" }}>
              <div
                style={{
                  background: "black",
                  padding: "5px 10px",
                  fontSize: ".8rem",
                  color: "white",
                  border: "1px solid var(--ion-color-light)",
                  borderRadius: "10px",
                }}
                onClick={props.button.exec}
              >
                {props.button.name}
              </div>
            </div>
          )}
        </div>
      </div>
      {props.children}
    </IonHeader>
  );
}; //End of BhpThemeHeaderWithBack

/**************************************************************************************
 * Name: BhpSearchButton
 * Description: Search Button which props up a search modal
 **************************************************************************************/
const BhpSearchButton: React.FC<{
  isMarket: boolean;
  onClick: () => void;
  isRWA: boolean;
  styleData?: StyleDataType;
}> = (props) => {
  const searchArr: string[] = [
    "Shop Name",
    "Categories",
    "Products",
    "Services",
    "Shop Number",
  ];
  const searchRwaArr: string[] = [
    "Name",
    "Profession",
    "Name",
    "Profession",
    "Name",
  ];
  const borderColorCss = `1px solid ${props.styleData.headerBaseColorHighlight}`;
  const bgColorCss = "white";
  const shadowCss = "0 4px 8px rgba(0, 0, 0, 0.1)";
  const iconColorCss = props.styleData.headerBaseColorHighlight;

  return (
    <div
      className="bhp-search-button-input-wrpr"
      style={{
        border: borderColorCss,
        background: bgColorCss,
        boxShadow: shadowCss,
      }}
      onClick={() => {
        props.onClick();
      }}
    >
      <div className="bhp-search-button-icon" style={{ color: iconColorCss }}>
        <IonIcon icon={searchSharp} />
      </div>
      <div className="bhp-search-button-input">
        <div>{props.isMarket ? "Search For" : "Search For Products"}</div>
        {props.isMarket && !props.isRWA && (
          <div className="bhp-search-placeholder-slider">
            {searchArr.map((el, idx) => {
              return (
                <div key={idx} className="bhp-search-placeholder-text">
                  '{el}'
                </div>
              );
            })}
          </div>
        )}
        {props.isMarket && props.isRWA && (
          <div className="bhp-search-placeholder-slider">
            {searchRwaArr.map((el, idx) => {
              return (
                <div key={idx} className="bhp-search-placeholder-text">
                  '{el}'
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}; //End of BhpSearchButton

/**************************************************************************************
 * Name: BusinessHomePageSection
 * Description:
 **************************************************************************************/
const BusinessHomePageSection: React.FC<{
  displayOff?: boolean;
  subHeaderText?: string;
  subHeaderNoBg?: boolean;
  bgStyle?: string;
  isSpecial?: boolean;
  enableSubheaderStickyScroll?: boolean;
  supressSubheader?: boolean;
  subheaderId?: string;
  subHeaderButtons?: SubheaderButtonType[];
  headingLine?: boolean;
  disableMargin?: { top?: boolean; bottom?: boolean };
  subheaderTopOffsetPx?: number;
  classNames?: string;
  description?: string;
  listModeListing?: boolean | number;
  img?: { fileName: string };
  disableBottomPadding?: boolean;
  disableBottomShadow?: boolean;
  subheaderColor?: string;
  subheaderWeight?: "normal" | "bold";
  darkMode?: boolean;
  rightJsx?: any;
  enableSearchBar?: {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
  };
}> = (props) => {
  return (
    <div
      className={`buying_page_main ${props?.classNames}`}
      style={{
        background: props?.bgStyle
          ? props.bgStyle
          : props.darkMode
          ? "var(--ion-color-bhp-hdr-dark)"
          : undefined,
        marginTop: `${props?.disableMargin?.top ? "0" : "10px"}`,
        marginBottom: `${props?.disableMargin?.bottom ? "0" : "10px"}`,
        display: props.displayOff ? "none" : undefined,
        paddingBottom: props.disableBottomPadding ? "0" : undefined,
        boxShadow: props.disableBottomShadow ? "none" : undefined,
      }}
    >
      {!props.supressSubheader && (
        <>
          {!!props.subheaderId && <div id={props.subheaderId}> </div>}
          <SubHeader
            darkMode={props.darkMode}
            noBg={props.subHeaderNoBg}
            text={props.subHeaderText}
            enableStickyScroll={props?.enableSubheaderStickyScroll}
            topOffsetPx={props.subheaderTopOffsetPx}
            isSpecial={props?.isSpecial}
            buttons={props?.subHeaderButtons}
            rightJsx={props?.rightJsx}
            headingLine={props?.headingLine}
            subheader={props.description}
            listModeListing={props.listModeListing}
            img={props.img}
            textColor={props.subheaderColor}
            textWeight={props.subheaderWeight}
            enableSearchBar={props.enableSearchBar}
          />
        </>
      )}

      {props.children}
    </div>
  );
}; //End of BusinessHomePageSection

/*******************************************************************************
 * Component Name: BussinessHomePage
 * Description: Top level Business Page.
 *******************************************************************************/
const BussinessHomePage: React.FC<{
  isInternal?: boolean;
  directoryMode?: boolean;
}> = (props) => {
  const productAds = ["Featured Products", "Specials"];
  let { id, token, email, schoolId, firstname, role, session } =
    getSessionDetails();
  // const [isLoggedIn, setIsLoggedIn] = useState<boolean>(!!id);
  const [advertisingBannerData, setAdvertisingBannerData] = useState<
    AdvertisingDetailsType[]
  >([]);
  const [trendsData, setTrendsData] = useState<AdvertisingDetailsType[]>([]);
  const [advDataLoaded, setAdvDataLoaded] = useState(false);
  // const [editMode, setEditMode] = useState(false);
  const editMode = useAppSelector(
    (state) => state.loginInfoSelection.bhpEditMode
  );
  const verifyMode = useAppSelector(
    (state) => state.loginInfoSelection.bhpVerify
  );
  const userInfo = useAppSelector((state) => state.teacherInfoSelection);
  //const [marketBlocks, setMarketBlocks] = useState<BhpMarketBlocksType[]>([]);
  //const [numMarketBlocks, setNumMarketBlocks] = useState<number>(0);

  const [bussinessDetailsDB, setBussinessDetailsDB] =
    useState<BusinessDetailsType>({
      id: "",
      banner: "",
      bannerText: "",
      description: "",
      logo: "",
      name: "",
      tagline: "",
      isMarket: false,
    });

  const [alert, setAlert] = useState<AlertWithoutExecTypes>({
    message: "",
    open: false,
  });
  const [hotKeys, setHotKeys] = useState<BhpHotKeysType[]>([]);
  const [prodCategories, setProdCategories] = useState<
    BusinessProductCategoryWithProducts[]
  >([]);
  const [floors, setFloors] = useState<string[]>([]);

  // const [selOrderType, setSelOrderType] = useState(false);
  const [promptContactSave, setPromptContactSave] = useState<boolean>(false);
  const [subscribePrompt, setSubscribePrompt] =
    useState<PopoverPromoType>(undefined);
  const [subscribePromptDone, setSubscribePromptDone] =
    useState<boolean>(false);
  const [promptedContactSave, setPromptedContactSave] =
    useState<boolean>(false);
  const [search, setSearch] = useState<string>("");
  const history = useHistory();
  // const [styleId, setStyleId] = useState(-1);
  const [styleData, setStyleData] = useState<StyleDataType>({
    headerBaseColor: "var(--ion-color-bhp-hdr-yellow)",
    headerBaseColorHighlight: "var(--ion-color-bhp-gray)",
    headerBg: "",
    headerFontColor: "var(--ion-color-bhp-vypzee-dark)",
    headerStyle: "CARD_ICON",
    reducedDrawerMenu: "false",
    showFloorSelector: "false",
    showVypzeeFooter: "true",
    dontShowBanner: "false",
    dontShowBizCard: "false",
    headerLogoMode: "false",
    ctaBtnBg: undefined,
    ctaBtnColor: undefined,
    noBannerSubtext: "false",
    bannerCtaBtnDisable: "false",
    disableHeaderCta: "false",
  });
  const [present] = useIonToast();
  const presentToast = useCustomToast();
  const stringToast = useStringToast();
  const [customerDetails, setCustomerDetails] = useState<CustomerDetailsType>({
    id: 0,
    address: "",
    email: "",
    name: "",
    phone: 0,
  });
  const [customerLoginDetails, setCustomerLoginDetails] = useState<{
    id: number;
    name: string;
    phone: number;
    email: string;
    address: string;
  }>({ id: 0, address: "", email: "", name: "", phone: 0 });
  const { company, state, city, market, shop, category } = useParams<{
    company: string;
    state: string;
    city: string;
    market: string;
    shop?: string;
    category?: string;
  }>();
  const [companyDomainFromParams, setCompanyDomainFromParams] =
    useState<string>("");
  const [companyStore, setCompanyStore] = useState("");
  const [couponId, setCouponId] = useState<string | number>("");
  const companyNameResolved = !!company
    ? company
    : !!companyDomainFromParams
    ? companyDomainFromParams
    : !!companyStore
    ? companyStore
    : "";
  const location = useLocation();
  const [signinupModal, setsigninupModal] = useState<{
    open: boolean;
    isSignup: boolean;
    msg?: string;
    changePassword?: boolean;
  }>({ open: false, isSignup: false });
  const [marketNotFound, setMarketNotFound] = useState(false);
  const vypzeePage = useMemo(() => {
    return (
      bussinessDetailsDB.isMarket && bussinessDetailsDB.marketType === "VYPZEE"
    );
  }, [bussinessDetailsDB]);
  // const [currentBannerIndex, setCurrentBannerIndex] = useState<number>(0);
  const [cityData, setCityData] = useState<{
    cityId: number;
    cityName: string;
    stateId: number;
    stateName: string;
    cityImage: string;
    cityImageObj?: { fileName: string };
  }>({ cityId: 0, cityImage: "", cityName: "", stateId: 0, stateName: "" });
  const [logoImgData, setLogoImgData] = useState(undefined);
  const [swiperRef, setSwiperRef] = useState(null);
  const [bookingModal, setBookingModal] = useState(false);
  const [discountModal, setDiscountModal] = useState(false);
  const [openBooking, closeBooking] = useModalController(
    "booking",
    setBookingModal,
    () => {
      setBookingModal(false);
    }
  );
  const saveVypzeeContact = () => {
    const downloadPopUp = downloadVCard(
      "VypZee",
      "9818783337*8448338565",
      "info@idigizen.com",
      "https://vypzee.com",
      "Local Markets Online"
    );
  };

  const saveVcardExec = (): void => {
    saveVcard(
      companyNameResolved,
      bussinessDetailsDB.isMarket && bussinessDetailsDB.marketType !== "USER",
      "",
      bussinessDetailsDB.marketType === "RWA",
      bussinessDetailsDB.marketType === "USER" ? bussinessDetailsDB.id : ""
    );
  };

  const [advanceCustomization, setAdvanceCustomization] =
    useState<AdvanceCustomizationType>({});

  const hotkeyUserInteraction = (
    action: string,
    notes: string = "",
    shopId: string | number = ""
  ) => {
    const value: UserInteractionRecordType = {
      action: action,
      pageId: bussinessDetailsDB.id,
      pageSection: "MAIN",
      pageType: getPageType(
        bussinessDetailsDB.isMarket,
        bussinessDetailsDB.marketType
      ),
      notes: `Hot Key. ${notes}`,
    };
    if (shopId) {
      value.popId = shopId;
      value.pageType = "SHOP";
    }
    recordAction(value);
  };

  const hotKeyFunctions: {
    [key: string]: (inp?: { [key: string]: any }) => void;
  } = {
    scrollToMembers: () => {
      handleScroll("Members");
    },
    saveContact: (inp: { [key: string]: any } = undefined) => {
      let notes = "";
      if (!!inp && !!inp.notes) notes = inp.notes;
      if (!inp || !inp.bypass)
        hotkeyUserInteraction(userActionsTable.save, notes);
      saveVcardExec();
      setAlert({
        open: true,
        header: `Save`,
        message:
          'Visit this page anytime from the "website" link in the contact.',
      });
    },
    saveVypzeeContact: (inp: { [key: string]: any } = undefined) => {
      if (!inp || !inp.bypass) hotkeyUserInteraction(userActionsTable.save);
      saveVypzeeContact();
    },
    openSearch: (inp: { [key: string]: any } = undefined) => {
      let notes = "";
      if (!!inp && !!inp.notes) notes = inp.notes;
      if (!inp || !inp.bypass)
        hotkeyUserInteraction(userActionsTable.search, notes);
      openSearchModal({ open: true });
    },
    backToMarket: () => {
      hotkeyUserInteraction(userActionsTable.backToMarket);
      window.location.assign(getSeoUrl(bussinessDetailsDB.seoUrlDetails, true));
      // openSearchModal({ open: true });
    },
    openVypzee: (inp: { [key: string]: any } = undefined) => {
      hotkeyUserInteraction(userActionsTable.localMarkets);
      window.location.assign("https://vypzee.com");
    },
    openAllPromo: (inp: { [key: string]: any } = undefined) => {
      hotkeyUserInteraction(userActionsTable.seeAll, "All Promo");
      openShowAllPromos(true);
      setShowAllPromosTrends(false);
    },
    openAllTrends: (inp: { [key: string]: any } = undefined) => {
      hotkeyUserInteraction(
        userActionsTable.seeAll,
        inp?.campaign ? inp.campaign : "All Trend"
      );
      openShowAllPromos(true);
      if (!inp) setShowAllPromosTrends(true);
      else setShowAllPromosTrends(false);
    },
    marketDirectory: (inp: { [key: string]: any } = undefined) => {
      hotkeyUserInteraction(userActionsTable.search, "Directory");
      if (bussinessDetailsDB.isMarket) {
        openSearchModal({ category: "", open: true, fullMarketDir: true });
      } else {
        openSearchModal({
          category: "",
          open: true,
          controls: {
            fetchMode: true,
            url: bussinessDetailsDB.marketDomain,
          },
          // fullMarketDir: true,
        });
      }
    },
    bookTable: (inp: { [key: string]: any } = undefined) => {
      hotkeyUserInteraction(userActionsTable.bookATable);
      openBooking(true);
    },
    customerLoyalty: () => {
      hotkeyUserInteraction(userActionsTable.customerLoyalty);
      let url = `${IDIGIZEN_FRONTEND_URL}/landing-page?type=LoyaltyProgram${getParamsUrlForHome(
        true
      )}`;
      if (!bussinessDetailsDB.isMarket) {
        url += `&shopId=${bussinessDetailsDB.id}&userId=${id ? id : 0}`;
      }
      // &shopId=263&userId=0
      window.location.assign(url);
    },
    pathFinder: (inp?: {
      shopId?: string;
      location?: { obj?: PositionType; url?: string };
      shopName?: string;
      notes?: string;
    }) => {
      let shopId = "";
      if (inp?.shopId) {
        shopId = inp?.shopId;
      } else if (!bussinessDetailsDB.isMarket && bussinessDetailsDB.floorId) {
        shopId = bussinessDetailsDB.id;
      }
      hotkeyUserInteraction(
        userActionsTable.pathFinder,
        inp?.notes ? inp.notes : "",
        !bussinessDetailsDB.marketId ? shopId : ""
      );

      if (!bussinessDetailsDB.floorId) {
        setAlert({ message: "Coming Soon!", open: true });
      } else {
        const mapsPrompt: MapsGooglePromptType = {};
        if (!bussinessDetailsDB.isMarket) {
          mapsPrompt.shopId = bussinessDetailsDB.id;
          mapsPrompt.shopName = bussinessDetailsDB.name;
          mapsPrompt.url = bussinessDetailsDB?.locationUrl;
          mapsPrompt.obj = bussinessDetailsDB?.location;
          mapsPrompt.marketId = bussinessDetailsDB.marketId;
          mapsPrompt.marketName = bussinessDetailsDB.marketName;
        } else {
          mapsPrompt.marketId = bussinessDetailsDB.id;
          mapsPrompt.marketName = bussinessDetailsDB.name;
          mapsPrompt.obj = inp?.location?.obj
            ? inp?.location?.obj
            : bussinessDetailsDB?.location;
          mapsPrompt.url = inp?.location?.url
            ? inp?.location?.url
            : bussinessDetailsDB?.locationUrl;
          if (inp?.shopId) mapsPrompt.shopId = inp?.shopId;
          if (inp?.shopName) mapsPrompt.shopName = inp?.shopName;
        }
        if (inp?.notes) mapsPrompt.notes = inp.notes;
        // dispatch(mapsGooglePromptInfoActions.update(mapsPrompt));
        history.push(
          `/maps?marketId=${
            bussinessDetailsDB.isMarket
              ? bussinessDetailsDB.id
              : bussinessDetailsDB.marketId
          }&floorId=${bussinessDetailsDB.floorId}${
            shopId ? `&shopId=${shopId}` : ""
          }&obj=${encodeURIComponent(JSON.stringify(mapsPrompt))}`
        );
      }
      // window.location.assign(
      //   `${IDIGIZEN_FRONTEND_URL}/navigation?marketId=${bussinessDetailsDB.id}`
      // );
    },
    share: (inp: { [key: string]: any } = undefined) => {
      hotkeyUserInteraction(userActionsTable.share);
      whatsappMessage(
        getBhpShareMessage(
          bussinessDetailsDB.isMarket,
          bussinessDetailsDB.marketDomain,
          bussinessDetailsDB.domainName,
          bussinessDetailsDB.name,
          bussinessDetailsDB.marketType,
          bussinessDetailsDB.seoUrlDetails
        )
      );
    },
    direction: (inp?: {
      location: { obj?: PositionType; url?: string };
      storeId?: number | string;
      notes?: string;
    }) => {
      let position: { obj?: PositionType; url?: string } = {
        obj: bussinessDetailsDB.location,
        url: bussinessDetailsDB.locationUrl,
      };
      console.log("Called direction ", inp);
      // return;
      hotkeyUserInteraction(
        userActionsTable.direction,
        inp?.notes ? inp.notes : "",
        inp?.storeId
      );
      if (inp && inp?.location) {
        position = inp.location;
      }
      if (position?.url) {
        window.location.assign(position.url);
        return;
      }
      if (!position.obj) {
        setAlert({
          message: `Google location is not set for ${bussinessDetailsDB.name}`,
          open: true,
        });
        return;
      }
      goToGoogleMapsNav(
        position.obj.coordinate.latitude,
        position.obj.coordinate.longitude
      );
    },
    contact: (inp: { [key: string]: any } = undefined) => {
      hotkeyUserInteraction(userActionsTable.contact);
      setOpenContactMe(true);
    },
    query: (inp: { [key: string]: any } = undefined) => {
      hotkeyUserInteraction(userActionsTable.whatsapp);
      whatsappMessage(
        "Hello, I found your business on VypZee",
        bussinessDetailsDB.contactPersonPhoneNums[0]
      );
    },
    aboutUs: (inp: { [key: string]: any } = undefined) => {
      hotkeyUserInteraction(userActionsTable.aboutUs);
      handleScroll("bhp-footer-id");
    },
    combinedDirection: (inp?: {
      location?: { obj?: PositionType; url?: string };
      shopId?: string;
      shopName?: string;
      notes?: string;
    }) => {
      // This is the case when as a market the navigation button is clicked for a specific shop
      // The shopId and location is preloaded with the message subtitle
      console.log("Called combined direction ", inp);
      // As a market the block of code below is to ensure two cases
      // 1. If the google location is set and the floor Id is not set then directly go to location in gmaps
      // 2. If both floor id is not set (internal navigation is not there) and location is also missing give alert not supported
      // If both are there then go ahead to open the popup for the selection
      if (bussinessDetailsDB.isMarket) {
        let location: { obj?: PositionType; url?: string } = undefined;
        let shopId: string = "";
        let shopName: string = "";
        if (inp) {
          if (inp?.location) location = inp.location;
          if (inp?.shopId) shopId = inp.shopId;
          if (inp?.shopName) shopName = inp.shopName;
        }
        if (!!bussinessDetailsDB.floorId) {
          hotKeyFunctions["pathFinder"]({
            shopId,
            location,
            shopName,
            notes: inp?.notes,
          });
          return;
        } else {
          hotKeyFunctions["direction"]({
            location,
            storeId: shopId,
            notes: inp?.notes,
          });
          return;
        }
        // As a shop there are 2 cases. If floor Id is not set then directly call gmaps
        // If both are set then call message not supported
      } else {
        if (!!bussinessDetailsDB.floorId) {
          hotKeyFunctions["pathFinder"]({ notes: inp?.notes });
        } else {
          hotKeyFunctions["direction"]({ notes: inp?.notes });
          return;
        }
      }
      // hotkeyUserInteraction(userActionsTable.combinedDirection);
      // setOpenCompositeNav(true);
      // setOpenCompositeNav({
      // header: bussinessDetailsDB.isMarket ? "Directions" : "Reach Store",
      // cssClass: "bhp-popup-search-class",
      // subTitle: subTitle ? subTitle : "",
      // buttons: [
      // {
      // execFunction: () => {
      // hotKeyFunctions["pathFinder"]({ shopId });
      // },
      // subtitle: "Navigate within the market",
      // title: "Open Shop Navigation!",
      // backgroundColor: "var(--ion-color-dark)",
      // borderColor: "var(--ion-color-light)",
      // fontColor: "white",
      // },
      // {
      // execFunction: () => {
      // hotKeyFunctions["direction"]({ location });
      // },
      // subtitle: `Navigate to market`,
      // title: "Open Google Maps!",
      // backgroundColor: "var(--ion-color-light)",
      // borderColor: "var(--ion-color-medium)",
      // fontColor: "var(--ion-color-dark)",
      // },
      // ],
      // });
    },
    openSocialHandle: () => {
      hotkeyUserInteraction(userActionsTable.openSocialHandles);
      setOpenSocialHandle(true);
    },
    leasing: () => {
      // openSearchModal({ category: "", open: true, onlineOnly: true });
      // setAlert({ message: "Coming soon!", open: true });
      const item = prodCategories.find(
        (el) => el.category.toLowerCase() === "open for leasing"
      );

      if (!item) {
        setAlert({
          message: `No leasing options listed at ${bussinessDetailsDB.name} at the moment.`,
          open: true,
        });
        return;
      }

      openSearchModal({
        category: item.category,
        open: true,
      });
    },
    orderOnline: () => {},

    switchToUserPage: () => {
      //find the members category
      const memberCategory = prodCategories.find(
        (el) => el.category.toLowerCase() === "members"
      );
      if (!memberCategory) {
        setAlert({
          message: "No members listed at the moment",
          open: true,
        });
        return;
      }
      const { schoolId } = getSessionDetails();
      //find the member in the category.
      const member = memberCategory.products.find((el) => el.id == schoolId);
      let url = getSeoUrl(member.seoUrlDetails, false);
      window.location.assign(url);
    },

    triggerBNIVisitorInvite: async () => {
      let url = `https://vypzee.com/tables?type=Table&id=354&singleCellEdit=1`;
      window.location.assign(url);
    },
  }; //End of hotKeyFunctions

  const [merchantPhone, setMerchantPhone] = useState<string>("");
  const [openAllPromoParam, setOpenAllPromoParam] = useState<number>(0);
  const [searchPopTimeout, setSearchPopTimeout] = useState(undefined);
  const [searchModal, setSearchModal] = useState<{
    open: boolean;
    category: string;
    onlineOnly?: boolean;
    controls?: { fetchMode: boolean; url?: string };
    fullMarketDir?: boolean;
    floor?: string;
    disableKeyboard?: boolean;
    searchText?: string;
  }>({ open: false, category: "" });
  const [openSearchModal, closeSearchModal] = useModalController(
    "dirModal",
    setSearchModal,
    () => {
      setSearchModal({ open: false, category: "" });
    }
  );

  const [searchOpened, setSearchOpened] = useState(false);
  const [campaign, setCampaign] = useState<BhpCampaignType>({
    id: 0,
    campaignName: "",
  });

  // When the search modal is opened and search is executed the results are overwritten on the
  // single product category state. This user effect is responsible for calling and refreshing
  // the product state to its default view by refetching the products from backend
  // Once problem is if the call is on !searchModal.open then on the initial pull the product was
  // getting called twice, once from the core pull and then from here.
  // So a guard of searchOpened is present to make sure that this pull is triggered only post the
  // search modal is opened once
  useEffect(() => {
    if (!searchModal.open && searchOpened) {
      console.log("Called from here!");
      getProductDetails(undefined, "", true);
    } else if (searchModal.open && !searchOpened) {
      setSearchOpened(true);
    }
  }, [searchModal.open]);

  // useEffect(() => {
  //   if (bussinessDetailsDB.isMarket) {
  //     if (!searchPopTimeout && !openCompositeNav) {
  //       const id = setTimeout(() => {
  //         setOpenCompositeNav({
  //           cssClass: "bhp-popup-search-class",
  //           subTitleFontSize: "1.3rem",
  //           // header: "Need Help?",
  //           header: `Looking for something in ${bussinessDetailsDB.name}?`,
  //           inputBox: {
  //             enable: true,
  //             text: "",
  //             placeholder: "Enter Product or Shop Name ...",
  //             fontSize: "1.5rem",
  //             padding: "10px 15px",
  //             margin: "10px 0",
  //           },
  //           buttons: [
  //             {
  //               execFunction: (text?: string) => {
  //                 console.log("Search ", text);
  //                 openSearchModal({
  //                   category: "",
  //                   open: true,
  //                   fullMarketDir: true,
  //                   searchText: text,
  //                 });
  //               },
  //               title: "Search",
  //               icon: searchSharp,
  //               padding: "10px",
  //               fontSize: "1.5rem",
  //             },
  //             {
  //               execFunction: (text?: string) => {
  //                 setOpenCompositeNav(undefined);
  //               },
  //               title: "Dismiss",
  //               icon: close,
  //               backgroundColor: "none",
  //               fontColor: "red",
  //               borderColor: "transparent",
  //               fontSize: "1rem",
  //               disableBoxShadow: true,
  //             },
  //           ],
  //         });
  //       }, 5000);
  //       setSearchPopTimeout(id);
  //     } else if (searchPopTimeout && searchModal.open) {
  //       clearTimeout(searchPopTimeout);
  //     }
  //   }
  // }, [bussinessDetailsDB, searchModal]);

  useEffect(() => {
    console.log("Triggered ", openAllPromoParam, advertisingBannerData);
    if (openAllPromoParam === 1 && advertisingBannerData.length) {
      openShowAllPromos(true);
    }
  }, [openAllPromoParam, advertisingBannerData]);

  const [openNotes, setOpenNotes] = useState(false);
  const [customMsgDone, setCustomMsgDone] = useState(false);
  const [adMaker, setAdMaker] = useState(false);
  const [openAdMode, setOpenAdMode] = useState(false);
  const [checklistNotes, setChecklistNotes] = useState(false);
  const [checkList, setCheckList] = useState<MarketShopStatusDataType>({
    id: 0,
    status: "NONE",
    shopAddress: false,
    shopDealsIn: false,
    shopName: false,
    shopPhone: false,
    shopQr: false,
  });
  // const [shopVerified, setShopVerified] = useState(false);

  const [refreshChecklist, setRefreshChecklist] = useState(false);
  // const [checklistNotes, setChecklistNotes] = useState('')

  const saveDataToBackend = (
    status: "OPEN" | "DONE" | "WAITING" | "REJECTED" | "PHASE3" = undefined,
    checklistInp: { key: string; val: boolean } = undefined
  ) => {
    const checkListCopy = deepCopy(checkList);
    if (status) checkListCopy.status = status;
    console.log("Send data to send ", checkListCopy);
    if (checklistInp) {
      checkListCopy[checklistInp.key] = checklistInp.val;
    }
    console.log("Send data to send ", checkListCopy);
    axios
      .post(
        `${IDIGIZEN_BACKEND_URL}/${saveShopChecklistDataDB}`,
        checkListCopy,
        {
          headers: { Authorization: API_SECURE_KEY },
          params: {
            storeId: bussinessDetailsDB.id,
            userId: id,
            src: "saveDataToBackend",
          },
        }
      )
      .then((res) => {
        // stringToast("Saved");
        setRefreshChecklist((val) => !val);
      })
      .catch((e) => {
        stringToast("Could not save data");
      });
  };

  // const saveNotes = () => {
  //   axios
  //     .post(
  //       `${IDIGIZEN_BACKEND_URL}/${saveShopChecklistDataDB}`,
  //       { notes: checklistNotes },
  //       {
  //         headers: { Authorization: API_SECURE_KEY },
  //         params: {
  //           storeId: bussinessDetailsDB.id,
  //           isNotesUpdate: true,
  //           userId: id,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       stringToast("Saved");
  //       setRefreshChecklist((val) => !val);
  //     })
  //     .catch((e) => {
  //       stringToast("Could not save data");
  //     });
  //   setOpenNotes(false);
  // };

  const updateChecklist = (
    key:
      | "shopName"
      | "shopPhone"
      | "shopAddress"
      | "shopDealsIn"
      | "shopQr"
      | "phase3Prospect",
    val: boolean
  ) => {
    setCheckList((prevState) => {
      const retVal = deepCopy(prevState);
      retVal[key] = val;
      return retVal;
    });
    saveDataToBackend(undefined, { key, val });
  };

  const getCheckListData = () => {
    axios
      .get(`${IDIGIZEN_BACKEND_URL}/${getShopChecklistDataDB}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: API_SECURE_KEY,
        },
        params: {
          storeId: bussinessDetailsDB.id,
        },
      })
      .then((res) => {
        console.log("Get response checklist ", res);
        setCheckList(res.data.data);
        // setNotes(res.data.data.notes);
      })
      .catch((e) => {
        stringToast("Could not get shop checklist data");
      });
  };

  const superEditor = useMemo(() => {
    if (
      role === "IDIGIZENSUPERADMIN" ||
      role === "MARKETSUPERADMIN" ||
      role === "TECH_ADMIN"
    )
      return true;

    //access for specific market only if the role is MAREKTADMIN
    let { schoolId, marketId } = getSessionDetails();
    if (role === "MARKETADMIN") {
      if (bussinessDetailsDB.isMarket && bussinessDetailsDB.id == schoolId)
        return true;
      if (
        !bussinessDetailsDB.isMarket &&
        bussinessDetailsDB.marketId == schoolId
      )
        return true;
      return false;
    }
    // if (role === "MARKETADMIN" && schoolId === marketId) {
    //   return true;
    // }
    // else if (role === "MARKETSUPERADMIN") {
    //   if (!bussinessDetailsDB.id) return false;
    //   if (bussinessDetailsDB.isMarket && bussinessDetailsDB.id == schoolId)
    //     return true;
    //   if (
    //     !bussinessDetailsDB.isMarket &&
    //     bussinessDetailsDB.marketId == schoolId
    //   )
    //     return true;
    //   return false;
    // } else
    return false;
  }, [bussinessDetailsDB, role]);

  console.log("Super Editor MOde ", superEditor);
  const [noPageFound, setNoPageFound] = useState(false);

  useEffect(() => {
    if (superEditor) getCheckListData();
  }, [refreshChecklist, superEditor, bussinessDetailsDB.id]);

  const getCompanyDomain = async () => {
    try {
      if (
        state === "delhi" &&
        city === "new-delhi" &&
        market === "chawri-bazar"
      ) {
        window.location.assign(
          `https://vypzee.com/delhi/delhi/chawri-bazar/${shop ? shop : ""}`
        );
      }
      const res = await axios.get(
        `${IDIGIZEN_BACKEND_URL}/${getCompanyDomainFromParamsDB}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: API_SECURE_KEY,
          },
          params: {
            state,
            city,
            market,
            shop,
            category,
          },
        }
      );
      console.log("Get data company domain ", res);
      if (res.data.data.noPageFound) {
        setLoadingCompany(false);
        setLoadingProducts(false);
        setNoPageFound(true);
        setAlert({
          message: `No page found for this url`,
          open: true,
        });
        return;
      }
      setCompanyDomainFromParams(res.data.data.domainName);
    } catch (e) {
      presentToast(e);
    }
  }; //End of getCompanyDomain

  const reviewStore = (notes: string = "") => {
    recordAction({
      action: userActionsTable.reviewStore,
      pageId: bussinessDetailsDB.id,
      pageSection: "MAIN",
      pageType: getPageType(
        bussinessDetailsDB.isMarket,
        bussinessDetailsDB.marketType
      ),
    });
    feedbackOpen(true);
  };

  const [openPromptFeedbackNDirection, setOpenPromptFeedbackNDirection] =
    useState(false);
  const promptFeedbackNDirectionDone = useAppSelector(
    (state) => state.loginInfoSelection.promptFeedbackNDirectionDone
  );

  // useEffect(() => {
  // if (
  // !promptFeedbackNDirectionDone &&
  // openPromptFeedbackNDirection &&
  // bussinessDetailsDB.id
  // ) {
  // dispatch(
  // loginInfoActions.updatePromptFeedbackNDirectionDone({ val: true })
  // );
  // setOpenCompositeNav({
  // enableSkip: true,
  // header: `${bussinessDetailsDB.name}!`,
  // cssClass: "bhp-popup-search-class",
  // title: `Welcome! How can we assist you today?`,
  // title: `Are you in ${
  //   bussinessDetailsDB.isMarket
  //     ? bussinessDetailsDB.name
  //     : bussinessDetailsDB.marketName
  // }?`,
  // buttons: [
  // {
  // execFunction: () => {
  // hotKeyFunctions["pathFinder"]();
  // },
  // subtitle: "Open in-market navigation",
  // title: "Find Your Way!",
  // backgroundColor: "var(--ion-color-dark)",
  // borderColor: "var(--ion-color-light)",
  // fontColor: "white",
  // },
  // {
  // execFunction: () => {
  // reviewStore("Popup");
  // },
  // subtitle: `Help us get better.`,
  // title: "Share Your Feedback!",
  // backgroundColor: "var(--ion-color-light)",
  // borderColor: "var(--ion-color-medium)",
  // fontColor: "var(--ion-color-dark)",
  // },
  // ],
  // });
  // }
  // }, [
  // openPromptFeedbackNDirection,
  // bussinessDetailsDB,
  // promptFeedbackNDirectionDone,
  // ]);

  //location change useEffect. Extracts the domain aka store name from location
  useEffect(() => {
    const setCompanyName = async (domain: string) => {
      try {
        const subdomains = domain.split(".");
        console.log("Called setCompanyName ", subdomains);
        if (domain === "vypzee.com") {
          setCompanyStore("vypzee");
        } else {
          for (const domainL of knownDomains) {
            if (
              subdomains.length >= 2 &&
              subdomains[1] === domainL.domain &&
              subdomains[0] !== domainL.subdomain
            ) {
              console.log("Set subdomain ", subdomains[0]);
              const res = await axios.get(
                `${IDIGIZEN_BACKEND_URL}/${getTinyUrlDetailsDB}`,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: API_SECURE_KEY,
                  },
                  params: {
                    tinyurl: subdomains[0],
                  },
                }
              );
              console.log("Got response for tinyurl ", res);
              if (res.data.data.success) {
                let url: string = res.data.data.url;
                if (
                  !(
                    url.includes("?physicalScan=1") ||
                    url.includes("&physicalScan=1")
                  )
                ) {
                  if (url.includes("?")) {
                    url += "&physicalScan=1";
                  } else {
                    url += "?physicalScan=1";
                  }
                }
                url += `&tinyUrl=${encodeURIComponent(subdomains[0])}`;
                window.location.assign(url);
                // setCompanyStore(res.data.data.url);
              } else {
                setCompanyStore(subdomains[0]);
              }
              break;
            }
          }
        }
      } catch (e) {
        console.log("Error ", e);
        presentToast(e);
      }
    };
    const params = getParamsFromSearchString(location.search);
    if (
      params.promptContactSave &&
      !!bussinessDetailsDB.id &&
      !promptedContactSave
    ) {
      setPromptContactSave(true);
    } else {
      setPromptContactSave(false);
    }

    if (!id && params.signIn) {
      setsigninupModal({ isSignup: false, open: true });
    }

    if (params.openAd) {
      setOpenAdMode(true);
    }

    if (params.promptFeedbackNDirection) {
      setOpenPromptFeedbackNDirection(true);
    }

    if (params.adMaker) {
      setAdMaker(true);
    } else {
      setAdMaker(false);
    }

    if (params.merchantTNC) {
      setOpenTerms({ open: true });
      setMerchantPhone(params.merchantPhone);
      setTermsMerchantMode(true);
    } else {
      setOpenTerms({ open: false });
      setTermsMerchantMode(false);
    }

    if (params.openAllAds) {
      if (openAllPromoParam === 0) {
        setOpenAllPromoParam(1);
      } else if (showAllPromos) setOpenAllPromoParam(2);
    }

    if (params.customMsg && !customMsgDone) {
      setAlert({
        message: decodeURIComponent(params.customMsg),
        open: true,
        header: "Thank You!",
      });
      setCustomMsgDone(true);
    }
    // if (params.loyaltyPrompt) {
    //   setOpenCustomerLoyalty(true);
    // } else {
    //   setOpenCustomerLoyalty(false);
    // }

    if (bussinessDetailsDB.id && params.tableBooking && !bookingModal) {
      openBooking(true);
    }

    // if (bussinessDetailsDB.id && params.generateDiscount && !discountModal) {
    //   setDiscountModal(true);
    // }
    if (bussinessDetailsDB.id && params.reviewStore && !openFeedback) {
      reviewStore();
      // setOpenFeedback(true);
    }

    if (params.generateDiscountNow) {
      setDiscountModal(true);
    }

    //add the coupon Code to customer details, if present.
    if (params.couponCode) {
      setCustomerDetails((prevState) => {
        return {
          ...prevState,
          couponCode: params.couponCode,
          merchantName: params.merchantName,
          couponDescription: params.couponDescription,
          merchantDomain: params.merchantDomain,
        };
      });
    }

    if (params.bookingCouponId) {
      setCouponId(params.bookingCouponId);
    }
    if (
      location.pathname === "/" ||
      location.pathname === "/home-page" ||
      location.pathname === "/directory-page"
    ) {
      let domain = window.location.hostname;
      if (domain.includes("localhost")) {
        domain = "vypzee.com";
      }
      setCompanyName(domain);
    }

    // if (location) {
    //   if (params.styleId) {
    //     setStyleId(parseInt(params.styleId));
    //   } else {
    //     setStyleId(-1);
    //   }
    // }
  }, [location, bussinessDetailsDB]);

  useEffect(() => {
    if (openAdMode && advertisingBannerData.length && !editMode) {
      openShowAllPromos(true);
    }
  }, [openAdMode, advertisingBannerData]);

  const [highlightProduct, setHighlightProduct] = useState<string[]>([]);
  const [refreshPage, setRefreshPage] = useState(false);
  // storeSessionDetails({ session: 1 }, 1);

  // useEffect(() => {
  //   const params = getParamsFromSearchString(location.search);
  //   if (params.couponId && advertisingBannerData.length && !couponIdShown) {
  //     const ad = advertisingBannerData.find((el) => el.id == params.couponId);
  //     if (ad) {
  //       setDownloadCoupon(ad);
  //     }
  //     setCouponIdShown(true);
  //   }
  // }, [location, advertisingBannerData]);

  // Setup the trackers
  // let session = getSessionDetails()
  // useEffect(() => {
  //   const generateUniqueId = (): string => {
  //     const timestamp = new Date().getTime(); // current time in milliseconds
  //     const randomComponent = Math.random().toString(36).substring(2, 9); // random string
  //     return `${timestamp}-${randomComponent}`;
  //   };
  //   const { id } = getSessionDetails();
  //   if (!presentLocalStorageItem(userUIDKey)) {
  //     setLocalStorageItem(userUIDKey, generateUniqueId(), true);
  //   }
  //   if (!session) {
  //     session = generateUniqueId();
  //     storeSessionDetails({ session: session }, 60);
  //   }
  // }, []);

  //useEffect to fetch the details of the business page
  useEffect(() => {
    // console.log(
    //   `XXXAG: useEffect 1699: companyNameResolved = ${companyNameResolved} :: isLoggedIn = ${isLoggedIn} :: refreshPage = ${refreshPage}`
    // );
    // if (isMalware()) {
    //   recordAction({
    //     action: userActionsTable.accessDenied,
    //     pageId: 1,
    //     pageSection: "MAIN",
    //     pageType: "VYPZEE",
    //   });
    //   history.push("/access-denied");
    //   return;
    // }

    const validState = !!state && state != "undefined";
    const validCity = !!city && city != "undefined";
    const validMarket = !!market && market != "undefined";
    // console.log(
    //   `XXXAG: useEffect : 1702 --> state : ${state} :: city : ${city} :: market : ${market}, companyNameResolved : ${companyNameResolved}, styleId : ${styleId}`
    // );
    if (!!validState && !!validCity && !!validMarket && !companyNameResolved)
      getCompanyDomain();
    if (!!companyNameResolved) getDetails(editMode);
  }, [
    companyNameResolved,
    userInfo.id,
    refreshPage,
    editMode,
    city,
    market,
    shop,
    state,
    id,
  ]);

  //useEffect to trigger the periodic updates for the banner data
  useEffect(() => {
    let interval;
    if (interval) {
      clearInterval(interval);
    }
    if (displayAdData.length) {
      const timeout = 4000;
      interval = setInterval(async () => {
        if (swiperRef) {
          //console.log("Swiper ref ", swiperRef);
          let nextIdx = 0;
          if (swiperRef.activeIndex === displayAdData.length - 1) nextIdx = 0;
          else nextIdx = swiperRef.activeIndex + 1;
          // console.log("Current Idx ", currentBannerIndex, " ", nextIdx);
          swiperRef.slideTo(nextIdx);
          //  swiperRef.slideNext();
        }
      }, timeout);

      return () => clearInterval(interval);
    }
  }, [advDataLoaded]);
  // console.log("Current index for ad ", currentBannerIndex);

  useEffect(() => {
    const getLogoImg = async () => {
      try {
        const data = await fetchImgThumbnailData(
          bussinessDetailsDB.logo,
          false
        );
        setLogoImgData(data);
      } catch (e) {
        presentToast(e);
      }
    };
    if (!!bussinessDetailsDB.logo) getLogoImg();
  }, [bussinessDetailsDB.logo]);

  // useEffect(() => {
  //   const getAllImages = async () => {
  //     try {
  //       if (advertisingBannerData.length) {
  //         for (let i = 0; i < advertisingBannerData.length; i++) {
  //           await fetchImgDataForBanner(i);
  //         }
  //       }
  //     } catch (e) {
  //       presentToast(e);
  //     }
  //   };
  //   getAllImages();
  // }, [advDataLoaded]);

  // console.log("Final Ad data ", advertisingBannerData);

  /**********************************************************************************
   * Function Name: fetchImgDataForBanner
   * Description: Function to fetch the image thumbnail data from the backend for the
   *              given banner index. It prefetches all the images associated with
   *              the banner
   **********************************************************************************/
  // const fetchImgDataForBanner = async (bannerIdx: number) => {
  //   try {
  //     //prefetch the images for the current banner if needed.
  //     if (!advertisingBannerData) return;

  //     let currAdvtData = advertisingBannerData[bannerIdx];
  //     //fetch the backgrouund images. assumption if one image data is present then all are present
  //     let bgImgData = "";
  //     if (
  //       currAdvtData.bgImg &&
  //       currAdvtData.bgImg.imgName &&
  //       !currAdvtData.bgImg.imgData
  //     ) {
  //       bgImgData = await fetchImgThumbnailData(
  //         currAdvtData.bgImg.imgName,
  //         false
  //       );

  //       setAdvertisingBannerData((prevState) => {
  //         const retVal: AdvertisingDetailsType[] = deepCopy(prevState);
  //         if (!retVal.length || !retVal[bannerIdx]) return retVal;
  //         retVal[bannerIdx].bgImg.imgData = bgImgData;
  //         // console.log("Write image array buffer ", retVal);
  //         return retVal;
  //       });
  //     }

  //     //fetch the sale images. assumption if one image data is present then all are present
  //     if (
  //       currAdvtData.saleImg[0] &&
  //       currAdvtData.saleImg[0].imgData &&
  //       currAdvtData.saleImg[0].imgData.length !== 0
  //     ) {
  //       //imgData exists nothing more to do.
  //       return;
  //     }

  //     //fetch the saleImages
  //     const imgData: string[] = [];
  //     for (let i = 0; i < currAdvtData.saleImg.length; i++) {
  //       //XXXAG: This has become blocking now which can cause latency. FIXME
  //       imgData.push(
  //         await fetchImgThumbnailData(currAdvtData.saleImg[i].imgName)
  //       );
  //     }

  //     //Update the imgData into the advertisingBannerData
  //     setAdvertisingBannerData((prevState) => {
  //       const retVal: AdvertisingDetailsType[] = deepCopy(prevState);

  //       for (let i = 0; i < retVal[bannerIdx].saleImg.length; i++) {
  //         retVal[bannerIdx].saleImg[i].imgData = imgData[i];
  //       }

  //       return retVal;
  //     });
  //   } catch (err) {
  //     console.log("fetchImgDataForBanner failed. Error =", err);
  //   }
  // };

  //Function to fetch the company and product details
  // const bussinessSocialMediaData = {
  //   facebookLink: "facebook.com",
  //   instagramLink: "instagram.com",
  //   youtubeLink: "youtube.com",
  //   linkdenLink: "linkden.com",
  // };

  // const variantData = [
  //   {
  //     option: "Hybride Tomato",
  //     price: 2000,
  //     unit: "kg",
  //     listPrice: 1500,
  //   },
  //   {
  //     option: "Desi Tomato",
  //     price: 3000,
  //     unit: "kg",
  //     listPrice: 1500,
  //   },
  //   {
  //     option: "Italian Tomato",
  //     price: 4000,
  //     unit: "kg",
  //     listPrice: 1500,
  //   },
  //   {
  //     option: "yellow Tomato",
  //     price: 500,
  //     unit: "kg",
  //     listPrice: 1500,
  //   },
  //   {
  //     option: "Desi Tomato",
  //     price: 3000,
  //     unit: "kg",
  //     listPrice: 1500,
  //   },
  //   {
  //     option: "Italian Tomato",
  //     price: 4000,
  //     unit: "kg",
  //     listPrice: 1500,
  //   },
  //   {
  //     option: "yellow Tomato",
  //     price: 500,
  //     unit: "kg",
  //     listPrice: 1500,
  //   },
  //   {
  //     option: "Desi Tomato",
  //     price: 3000,
  //     unit: "kg",
  //     listPrice: 1500,
  //   },
  //   {
  //     option: "Italian Tomato",
  //     price: 4000,
  //     unit: "kg",
  //     listPrice: 1500,
  //   },
  //   {
  //     option: "yellow Tomato",
  //     price: 500,
  //     unit: "kg",
  //     listPrice: 1500,
  //   },
  //   {
  //     option: "Desi Tomato",
  //     price: 3000,
  //     unit: "kg",
  //     listPrice: 1500,
  //   },
  //   {
  //     option: "Italian Tomato",
  //     price: 4000,
  //     unit: "kg",
  //     listPrice: 1500,
  //   },
  //   {
  //     option: "yellow Tomato",
  //     price: 500,
  //     unit: "kg",
  //     listPrice: 1500,
  //   },
  // ];

  // const getProductDetails = async () => {
  //   try {} catch(e) {
  //     throw e
  //   }
  // }
  const subheaderTopOffset = 59;
  const [openQr, setOpenQr] = useState(false);
  const [qrOpen, qrClose] = useModalController("qr", setOpenQr, () => {
    setOpenQr(false);
  });

  const businessContacts: { name: string; phones: string[] }[] = useMemo(() => {
    if (
      !(bussinessDetailsDB.isMarket && bussinessDetailsDB.marketType === "USER")
    )
      return [];
    if (!prodCategories.length) return [];
    return prodCategories[0].products.map((el) => {
      return {
        name: el.name,
        phones: !el.phoneNumbers
          ? []
          : el.phoneNumbers?.split(",").map((item) => item.trim()),
      };
    });
  }, [bussinessDetailsDB, prodCategories]);

  const [openContactMe, setOpenContactMe] = useState(false);
  const contactCardJsx = (
    <BhpContactCard
      dismiss={() => {
        setOpenContactMe(false);
      }}
      open={openContactMe}
      phones={bussinessDetailsDB.contactPersonPhoneNums}
      extraPhones={businessContacts}
      isMarket={bussinessDetailsDB.isMarket}
      marketType={bussinessDetailsDB.marketType}
      pageId={bussinessDetailsDB.id}
      recordUserInteraction={true}
      pageSection="MAIN"
      name={bussinessDetailsDB.name}
      save={() => {
        hotKeyFunctions["saveContact"]({ notes: "From Call hotkey" });
      }}
    />
  );
  // const marketCategoryHighlightsJsx = (
  //   <>
  //     <BusinessCategorySection
  //       onStockPhotoUpdate={() => {
  //         setRefreshPage((val) => !val);
  //       }}
  //       startingIndex={-1}
  //       endingIndex={-1}
  //       header="What's Hot"
  //       marketDomain={bussinessDetailsDB.marketDomain}
  //       onSeeAllClick={(category: string) => {
  //         openSearchModal({
  //           category: category,
  //           open: true,
  //           disableKeyboard: true,
  //         });
  //       }}
  //       prodCategories={prodCategories.filter((el) => el.isFeatured)}
  //       subheaderTopOffsetPx={subheaderTopOffset}
  //       marketType={bussinessDetailsDB.marketType}
  //       pageId={bussinessDetailsDB.id}
  //       pageSection={"MAIN"}
  //       recordUserActions={true}
  //     />
  //   </>
  // );
  const marketDirectoryHeaderJsx = (
    <div
      style={{
        width: "100%",
        height: "80px",
        position: "relative",
      }}
    >
      <img
        src={logoImgData}
        alt={`${bussinessDetailsDB.name} directory`}
        style={{
          height: "100%",
          width: "100%",
          objectFit: "cover",
        }}
        loading="lazy"
      />
      <div
        style={{
          position: "absolute",
          height: "100%",
          width: "100%",
          top: 0,
          left: 0,
          zIndex: 2,
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
          background:
            "linear-gradient(to right, #d3d3d3 40%, transparent 100%)",
        }}
      >
        <h3
          style={{
            fontSize: "1.2rem",
            fontWeight: "bold",
            color: "var(--ion-color-bhp-footer)",
            margin: 0,
            marginLeft: "15px",
            width: "70%",
            lineHeight: "1.5rem",
          }}
        >
          {bussinessDetailsDB.name} Directory
        </h3>
      </div>
    </div>
  );
  const marketCategoryRestJsx = (
    <>
      {/* <Suspense fallback={<LazyLoaderSpinner />}>
        {!!marketBlocks?.length && (
          <BhpMarketBlocks
            marketId={bussinessDetailsDB.id}
            numBlocks={numMarketBlocks}
            marketBlocks={marketBlocks}
            logoImg={bussinessDetailsDB.logo}
          />
        )}
      </Suspense> */}
      {
        <BusinessCategorySection
          onStockPhotoUpdate={() => {
            setRefreshPage((val) => !val);
          }}
          startingIndex={-1}
          endingIndex={-1}
          header={`Stores in ${bussinessDetailsDB.name}...`}
          marketDomain={bussinessDetailsDB.marketDomain}
          onSeeAllClick={(category: string) => {
            openSearchModal({
              category: category,
              open: true,
              disableKeyboard: true,
            });
          }}
          prodCategories={
            prodCategories &&
            prodCategories.length &&
            prodCategories.sort((a, b) => (!a.isFeatured ? 1 : -1))
          }
          subheaderTopOffsetPx={subheaderTopOffset}
          marketType={bussinessDetailsDB.marketType}
          pageId={bussinessDetailsDB.id}
          pageSection={"MAIN"}
          recordUserActions={true}
        />
      }
    </>
  );

  const [loadingCompany, setLoadingCompany] = useState(true);
  const [loadingProducts, setLoadingProducts] = useState(true);
  const recordAction = useRecordUserInteractions();
  // const [openNavRedirect, setOpenNavRedirect] = useState<{
  //   open: boolean;
  //   shopName?: string;
  //   shopId?: number | string;
  // }>({ open: false });

  useEffect(() => {
    // if (!!bussinessDetailsDB.id) {
    // const searchParams = getParamsFromSearchString(window.location.search);
    // if (searchParams.openNav) {
    //   setOpenNavRedirect({ open: true });
    //   // hotKeyFunctions["combinedDirection"]();
    // }

    // if (searchParams.navShopId) {
    //   setOpenNavRedirect({
    //     open: true,
    //     shopName: searchParams.navShopName,
    //     shopId: searchParams.navShopId,
    //   });
    // }
    // }

    switch (bussinessDetailsDB?.subType) {
      case "BNI-CHAPTER":
        bussinessDetailsDB.bhpEditLinks = bhpEditLinksBNIChapter;
        break;

      case "BNI-CHAPTER-MEMBER":
        bussinessDetailsDB.bhpEditLinks = bhpEditLinksBNIMember;
        break;

      default:
        bussinessDetailsDB.bhpEditLinks = bhpEditLinks;
    }
  }, [bussinessDetailsDB]);

  const getCompanyDetails = async () => {
    const searchParams = getParamsFromSearchString(window.location.search);
    setLoadingCompany(true);

    //non-blocking fetch of company details
    const companyDetailsPromise = axios.get(
      `${IDIGIZEN_BACKEND_URL}/${getBhpCompanyDetailsDB}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: API_SECURE_KEY,
        },
        params: {
          schoolIdQ: isInternal ? schoolId : 0,
          domainName: companyNameResolved,
          Authorization: API_SECURE_KEY,
          state,
          city,
          market,
          shop,
          id,
        },
      }
    );

    //attach the processing function to be executed on completion of the promise
    companyDetailsPromise
      .then(async (res) => {
        const businessDetailsL = res.data.data.data;
        setFloors(businessDetailsL.floorData);
        if (businessDetailsL.campaignData) {
          setCampaign(businessDetailsL.campaignData);
        }
        setAdvanceCustomization(businessDetailsL.styleData);
        // setMarketBlocks(businessDetailsL.blockData);
        // setNumMarketBlocks(businessDetailsL.numBlocks);
        setMarketNotFound(false);
        if (!processCompanyDetails(businessDetailsL, searchParams)) {
          return; //failure in processing company details abort further processing
        }

        //popover to prompt the user to subscribe. XXXAG: Shouldn't there be a timeout here?
        if (businessDetailsL.popoverPromo && !subscribePromptDone) {
          const url = `${IDIGIZEN_BACKEND_URL}/${getFileThumbnailDB}?fileName=${
            JSON.parse(businessDetailsL.popoverPromo.image).fileName
          }&percentage=100&Authorization=${API_SECURE_KEY}&`;
          //non-blocking fetch of image thumbnail data
          fetchImgThumbnailData(url, true, 40)
            .then((imageData) => {
              businessDetailsL.popoverPromo.imageData = imageData;
              setSubscribePrompt(businessDetailsL.popoverPromo);
              setSubscribePromptDone(true);
            })
            .catch((error) => {
              console.error("Error fetching image thumbnail data:", error);
            });
        } else {
          setSubscribePrompt(undefined);
        }

        setTimeout(() => {
          setLoadingCompany(false);
        }, 200);

        //XXXAG: VYPZEE market type specific processing will impact home page load times,
        //as it incurs additional round - tripping.See how to optimize
        // if (
        //   businessDetailsL.isMarket &&
        //   businessDetailsL.marketType === "VYPZEE"
        // ) {
        //   const res = await axios.get(
        //     `${IDIGIZEN_BACKEND_URL}/${getBhpMarketsDB}`,
        //     {
        //       headers: {
        //         "Content-Type": "application/json",
        //         Authorization: API_SECURE_KEY,
        //       },
        //       params: {
        //         Authorization: API_SECURE_KEY,
        //       },
        //     }
        //   );
        //   console.log("Got markets ", res);
        //   setProdCategories(res.data.data.prodKey);
        //   setLoadingCompany(false);
        //   setLoadingProducts(false);
        //   return;
        // }
      }) //End of companyDetailsPromise.then(async (res)
      .catch((err) => {
        setLoadingCompany(false);
        setLoadingProducts(false);
        console.log("Error : ", err);
        presentToast(err);
      }); //End of companyDetailsPromise.catch( (err)
  };

  const getHotkeys = async () => {
    //non-blocking fetch of hot keys
    const hotKeysPromise = axios.get(
      `${IDIGIZEN_BACKEND_URL}/${getBhpHotKeysDB}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: API_SECURE_KEY,
        },
        params: {
          Authorization: API_SECURE_KEY,
          styleId: 1,
          schoolIdQ: isInternal ? schoolId : 0,
          domainName: companyNameResolved,
          state,
          city,
          market,
          shop,
          id,
        },
      }
    );

    //processing callback for hot keys
    hotKeysPromise
      .then(async (res) => {
        //process hot keys
        const hotKeysL = [];
        for (const icon of res.data.data.data) {
          hotKeysL.push({
            id: icon.id,
            name: icon.name,
            imgFileName: convertImgJsonToObj(icon.iconImg).fileName,
            functionName: icon.functionName,
            anchorTag: icon.anchorTag,
          });
        }
        console.log("Set hot keys ", hotKeysL);
        setHotKeys(hotKeysL);
      }) //End of hotKeysPromise.then(async (res)
      .catch((err) => {
        console.log("Failed to get hot keys. Error =", err);
        setLoadingCompany(false);
        setLoadingProducts(false);
      }); //End of hotKeysPromise.catch((err)
  };

  const getProductDetails = (
    catDescs: {
      id: string;
      index: number;
      maxElements: number;
    }[] = undefined,
    block: string = "",
    forceOverride: boolean = false
  ) => {
    const searchParams = getParamsFromSearchString(window.location.search);
    //non-blocking fetch of product details
    // Force override is true for cases where the block of the market is getting changed
    // Category length is 0 for case where the product is getting loaded the 1st time
    // Rest of the cases are to load the remaining shop where the product load spinner is not needed
    if (forceOverride || !prodCategories.length) setLoadingProducts(true);
    const catDescJson = !!catDescs ? JSON.stringify(catDescs) : "";
    console.log("Cat Desc JSON ", catDescJson, " source ", catDescs);

    const productDetailsPromise = axios.get(
      `${IDIGIZEN_BACKEND_URL}/${getBhpProductDetailsDB}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: API_SECURE_KEY,
        },
        params: {
          schoolIdQ: isInternal ? schoolId : 0,
          domainName: companyNameResolved,
          Authorization: API_SECURE_KEY,
          state,
          city,
          market,
          shop,
          id,
          searchParams,
          editMode,
          catDescs: catDescJson,
          block,
          category,
        },
      }
    );

    //processing callback for product details
    productDetailsPromise
      .then((productData) => {
        processProductsData(productData, forceOverride);
        if (productData.data.data.highlightProductIds) {
          setHighlightProduct(productData.data.data.highlightProductIds);
        }
        setAdvDataLoaded((val) => !val);
        setLoadingProducts(false);
      })
      .catch((err) => {
        console.log("Failed to get product details. Error =", err);
        setLoadingCompany(false);
        setLoadingProducts(false);
      }); //End of productDetailsPromise.catch((err)
  };

  /******************************************************************************************
   * Name        : getDetails
   * Description : Fetch all the details of the company page. This is the main function that
   *               is triggered to get all the company, hotkeys & product data from backend
   *****************************************************************************************/
  const getDetails = async (editMode: boolean) => {
    try {
      getCompanyDetails();
      getHotkeys();
      console.log("Called from here!");
      getProductDetails(undefined, "", editMode);
    } catch (e) {
      setLoadingCompany(false);
      setLoadingProducts(false);
      console.log("Error e ", e);
      presentToast(e);
    }
  }; //End re-factored code for parallelizing axios calls.

  /***********************************************************************************
   * Name:processCompanyDetails
   * Description: Helper function to transform the business data received from the
   *              API to appropriate front end data structures.
   ***********************************************************************************/
  const processCompanyDetails = (businessDetailsL, searchParams) => {
    try {
      console.log("Get company data ", businessDetailsL);
      if (businessDetailsL.styleData) {
        setStyleData((prevState) => {
          const retVal: StyleDataType = deepCopy(prevState);
          for (const key of Object.keys(businessDetailsL.styleData)) {
            retVal[key] = businessDetailsL.styleData[key];
          }
          console.log("Style data ", retVal);
          return retVal;
        });
      }

      //this is a non-blocking hook. XXXAG:
      recordAction({
        action: userActionsTable.visitPage,
        pageId: businessDetailsL.id ? businessDetailsL.id : 1,
        pageSection: "MAIN",
        pageType: getPageType(
          businessDetailsL.isMarket,
          businessDetailsL.marketType
        ),
        notes: searchParams.couponId
          ? "AD scan"
          : searchParams.physicalScan
          ? "Physical Scan"
          : searchParams.phoneNumber
          ? `Physical Scan: Linked Phone: ${searchParams.phoneNumber}`
          : "Direct",
      });

      //show the page but block any kind of data rendering other than standard styling
      if (businessDetailsL.unauthorized) {
        if (!id) {
          setsigninupModal({
            isSignup: false,
            open: true,
            msg: "Please sign in to view this page",
          });
        } else {
          setAlert({
            message: "You are not authorized to view this page.",
            open: true,
          });
        }
        setLoadingCompany(false);
        setLoadingProducts(false);
        return false;
      }

      if (
        businessDetailsL.locationJson &&
        businessDetailsL.locationJson !== "undefined"
      ) {
        businessDetailsL.location = JSON.parse(businessDetailsL.locationJson);
      }

      if (!!businessDetailsL.logo) {
        const images = businessDetailsL.logo.split("|");
        businessDetailsL.logo = images[0];
        businessDetailsL.images = images.filter((el) => {
          return el !== "undefined" && el !== "";
        });
      } else {
        businessDetailsL.images = [];
      }
      if (businessDetailsL.contactPersonPhone) {
        businessDetailsL.contactPersonPhoneNums =
          businessDetailsL.contactPersonPhone.split(SEPARATOR_MULTI_INPUT);
      }
      if (!businessDetailsL.orderMode) businessDetailsL.orderMode = "order";

      if (
        (businessDetailsL.isMarket && businessDetailsL.marketType === "RWA") ||
        businessDetailsL.catalogueListMode ||
        (!businessDetailsL.isMarket &&
          businessDetailsL.subscriptionType === "PHYSICAL-MENU")
      )
        businessDetailsL.listModeListing = true;
      if (businessDetailsL.cityData) setCityData(businessDetailsL.cityData);

      const isVypzee =
        businessDetailsL.isMarket && businessDetailsL.marketType === "VYPZEE";

      if (!isVypzee) {
        const seoUrlDetails = businessDetailsL.seoUrlDetails;
        if (
          seoUrlDetails.stateUrl &&
          seoUrlDetails.cityUrl &&
          seoUrlDetails.marketUrl
        ) {
          let newUrl = "";

          if (seoUrlDetails.resolvedUrl) {
            newUrl = seoUrlDetails.resolvedUrl;
          } else {
            newUrl = `/${seoUrlDetails.stateUrl}/${seoUrlDetails.cityUrl}/${seoUrlDetails.marketUrl}`;
            newUrl += seoUrlDetails.shopUrl ? `/${seoUrlDetails.shopUrl}` : "";
          }
          // history.replace(newUrl);
        }
      }

      setBussinessDetailsDB(businessDetailsL);
      setCookie("businessId", businessDetailsL.id, "");
      setCookie(
        "marketId",
        businessDetailsL.isMarket
          ? businessDetailsL.id
          : businessDetailsL?.marketId,
        ""
      );
      //update the bhpEditDetails if the business is a BNI chapter
      if (businessDetailsL?.subType?.startsWith("BNI-CHAPTER")) {
        bussinessDetailsDB.bhpEditLinks = bhpEditLinksBNIChapter;

        if (businessDetailsL?.subType === "BNI-CHAPTER-MEMBER") {
          let { schoolId } = getSessionDetails();
          if (schoolId === businessDetailsL.id) {
            bussinessDetailsDB.bhpEditLinks = bhpEditLinksBNIChapter;
            dispatch(
              loginInfoActions.updateBhpEditMode({
                loaded: true,
              })
            );
          }
        }
      }

      return true;
    } catch (err) {
      console.log("Error in processCompanyDetails ", err);
      setLoadingCompany(false);
      setLoadingProducts(false);
      return false;
    }
  }; //End of processCompanyDetails

  /***********************************************************************************
   * Name: processProductsData
   * Description: Helper function to transform the products data received from the
   *              API to appropriate front end data structures.
   ***********************************************************************************/
  const processProductsData = (
    productData: any,
    forceOverride: boolean = false
  ) => {
    try {
      const productsL = productData.data.data.data;
      console.log(
        "Products in data ",
        productsL,
        " force override ",
        forceOverride
      );
      if (prodCategories.length && !forceOverride) {
        // console.log("Got data ", productsL, ' current prod ', prod);
        setProdCategories((prevState) => {
          const retVal: BusinessProductCategoryWithProducts[] =
            deepCopy(prevState);
          for (const prod of productsL) {
            retVal[prod.index] = prod;
          }
          return retVal;
        });
      } else {
        console.log("Set products in data ", productsL);
        setProdCategories(productsL);
      }

      let advertisingDataL: AdvertisingDetailsType[] = productData.data.data
        .promotions
        ? productData.data.data.promotions
        : undefined;
      if (advertisingDataL) {
        for (let i = advertisingDataL.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [advertisingDataL[i], advertisingDataL[j]] = [
            advertisingDataL[j],
            advertisingDataL[i],
          ];
        }
        console.log("Promotions ", advertisingDataL);
        // setAdvertisingBannerData(
        //   advertisingDataL.filter(
        //     (el) => !el.promoType || el.promoType === "PROMO"
        //   )
        // );
        const shuffleArray = (arr) => {
          const shuffled = [...arr]; // make a copy to avoid mutating original
          for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1)); // random index from 0 to i
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]; // swap
          }
          return shuffled;
        };

        advertisingDataL = shuffleArray(advertisingDataL);
        setAdvertisingBannerData(advertisingDataL);
      }
    } catch (err) {
      console.log("Error in processProductsData ", err);
      return false;
    }
  }; //End of processProductsData

  //append the search params to the new url.
  //A utility function to append missing search params to slug coming from backend
  const appendCurrentSearchParams = (newUrl: string) => {
    let newUrlSearchParamsStr = newUrl.split("?")[1];
    let currSearchParam = window.location.search.split("?")[1];
    if (!currSearchParam) {
      return newUrl;
    }

    //convert the newUrlSearchParams into key value pairs
    let newUrlSearchParams = {};
    if (newUrlSearchParamsStr) {
      for (const param of newUrlSearchParamsStr?.split("&")) {
        const [key, value] = param.split("=");
        newUrlSearchParams[key] = value;
      }
    }

    //create a list of currentSearchParams that are missing
    const addSearchParams = {};
    for (const param of currSearchParam.split("&")) {
      const [key, value] = param.split("=");
      if (value && !newUrlSearchParams[key]) addSearchParams[key] = value;
    }
    //append the missing searchParams to newUrl
    for (const key of Object.keys(addSearchParams)) {
      newUrl += `&${key}=${addSearchParams[key]}`;
    }
    return newUrl;
  }; //appendCurrentSearchParams

  //Callback to update the customerDetails local data structure
  const writeToCustomerData = (key: string, value: string) => {
    setCustomerDetails((prevState) => {
      const retVal = deepCopy(prevState);
      retVal[key] = key === "phone" ? parseInt(value) : value;

      return retVal;
    });
  };
  const isInternal = !!props.isInternal;

  // const itemCard = products.find((el) => el.id === openDetails.id);
  const [openExpandImg, setOpenExpandImg] = useState<{
    open: boolean;
    fileName: string[];
    index: number;
  }>({ fileName: [""], index: 0, open: false });
  const [expandingImgOpen, expandingImgClose] = useModalController(
    "expndImg",
    setOpenExpandImg,
    () => {
      setOpenExpandImg({ fileName: [""], index: 0, open: false });
    }
  );
  const [cartItems, setCartItems] = useState<CartItemTypes[]>([]);
  const [textCartItems, setTextCartItems] = useState<TextCartItemType[]>([]);
  const [loading, setLoading] = useState(false);
  const [openSignInSignUpModal, setOpenSignInSignUpModal] =
    useState<boolean>(false);
  const total = useMemo(() => {
    let total = 0;
    for (const item of cartItems) {
      total = total + item.count;
    }
    for (const item of textCartItems) {
      total = total + item.count;
    }
    // let total = cartItems.length + textCartItems.length;
    return total;
  }, [cartItems, textCartItems]);

  const [userDetailsAreValid, setUserDetailsAreValid] = useState(false);
  const [checkout, setCheckout] = useState<{
    open: boolean;
    mode: OrderModeType;
    filter?: string;
  }>({ mode: "itemized-order", open: false });
  const [checkoutOpen, checkoutClose] = useModalController(
    "chkout",
    setCheckout,
    () => {
      setCheckout({ mode: "itemized-order", open: false });
    }
  );
  const [customerEmail, setCustomerEmail] = useState("");

  const handleCheckoutOpen = () => {
    checkoutOpen({ mode: "itemized-order", open: true });
  };
  // const [currentCat, setCurrentCat] = useState("All");
  const isMobile =
    useAppSelector((state) => state.screenWidth).width < mobileWidthBreakpoint;
  const [execAlert, setExecAlert] = useState<AlertWithExecTypes>({
    executeFunc: undefined,
    funcInputs: undefined,
    message: "",
    open: false,
  });
  const dispatch = useAppDispatch();

  const addItemizedFromText = (
    name: string,
    hasEntry: boolean,
    cardData: BussinessHomeCardData
  ) => {
    setOpenAddItem({
      open: true,
      count: 1,
      details: "",
      item: `${cardData.title} - ${name}`,
      img: {
        id: "",
        name: "",
        type: undefined,
      },
      addMode: !hasEntry,
      nameEditable: false,
      qty: "",
    });
  };

  const addOrderItemized = (name: string) => {
    setOpenAddItem({
      open: true,
      count: 1,
      details: "",
      item: name,
      img: {
        id: "",
        name: "",
        type: undefined,
      },
      addMode: true,
      nameEditable: false,
      qty: "",
    });
  };

  // console.log("Prod cat ", prod);
  const [openSocialHandle, setOpenSocialHandle] = useState(false);

  const deleteCartItem = (inp: { [key: string]: any }) => {
    const { isTextCart, idx } = inp;
    if (!isTextCart) {
      recordAction({
        action: userActionsTable.delProd,
        pageId: bussinessDetailsDB.id,
        pageSection: "MAIN",
        pageType: getPageType(
          bussinessDetailsDB.isMarket,
          bussinessDetailsDB.marketType
        ),
        popId: cartItems[idx].id,
        popType: "PROD",
      });
      setCartItems((prevState) => {
        const retVal = deepCopy(prevState);
        retVal.splice(idx, 1);
        return retVal;
      });
    } else {
      setTextCartItems((prevState) => {
        const retVal: TextCartItemType[] = deepCopy(prevState);
        retVal.splice(idx, 1);
        return retVal;
      });
    }
  };

  const [openCouponRedeem, setOpenCouponRedeem] = useState<{
    open: boolean;
    loading: boolean;
    message?: string;
    couponCode?: string;
    merchantId?: number;
    amount?: string;
    supportsLoyalty?: boolean;
  }>({ open: false, loading: false });

  const redeemCoupon = async (
    couponCode,
    merchantId,
    amount,
    supportsLoyalty
  ) => {
    const { schoolId } = getSessionDetails();
    let amountNum = 0;
    let userId = 0;
    let userName = "";
    let userPhone = "";
    if (supportsLoyalty) {
      if (!amount) {
        setAlert({
          message: "Please enter a valid amount to redeem",
          open: true,
        });
        return;
      }
      try {
        amountNum = parseFloat(amount);
      } catch (e) {
        return;
      }
    }
    try {
      setOpenCouponRedeem((prevState) => {
        const retVal = deepCopy(prevState);
        retVal.loading = true;
        return retVal;
      });
      // Validate
      let res = await axios.get(`${IDIGIZEN_BACKEND_URL}/${validateCouponDB}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: API_SECURE_KEY,
        },
        params: {
          Authorization: API_SECURE_KEY,
          couponCode,
          merchantId,
          id: schoolId,
        },
      });
      let status = res.data.data.status;
      if (status !== "success") {
        // setOpenCouponRedeem({
        //   open: true,
        //   stage: "invalid",
        //   message: status,
        // });
        setAlert({ message: status, open: true });
        setOpenCouponRedeem({ open: false, loading: false });
        return;
      } else {
        userId = res.data.data.userId;
        userName = res.data.data.userName;
        userPhone = res.data.data.userPhone;
      }
      // redeem
      res = await axios.get(`${IDIGIZEN_BACKEND_URL}/${redeemCouponDB}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: API_SECURE_KEY,
        },
        params: {
          Authorization: API_SECURE_KEY,
          couponCode,
        },
      });
      status = res.data.data.status;
      if (status !== "success") {
        setAlert({ message: status, open: true });
      } else {
        // Add to loyalty
        const req = {
          shopid: schoolId,
          userid: userId,
          isAdd: true,
          amount: amountNum,
        };
        const res = await axios.post(
          `${IDIGIZEN_BACKEND_URL}/${addRedeemLoyaltyPointsDB}`,
          req,
          {
            headers: { Authorization: API_SECURE_KEY },
            params: {
              access_token: token,
              token,
              schoolId,
            },
          }
        );
        let msg = "";
        msg = `Greetings ${userName}, You've earned ${res.data.data.coins} loyalty points. Thanks for being a valued customer! Redeem on your next purchase. \nAccess Your Loyalty Points: ${IDIGIZEN_FRONTEND_URL}/landing-page?type=LoyaltyProgram`;
        whatsappMessage(msg, userPhone);

        setAlert({
          message: `Coupon code ${couponCode} redeemed.`,
          open: true,
        });
      }
      setOpenCouponRedeem({ open: false, loading: false });
    } catch (e) {
      presentToast(e);
    }
  };
  const [selCallWhatsapp, setSelCallWhatsapp] = useState(false);

  const [residentDetails, setResidentDetails] = useState<ResidentDetailsType>({
    open: false,
    address: "",
    catImg: "",
    id: "",
    name: "",
    profession: "",
    phones: [],
  });

  const openResidentDetails = (id: string | number) => {
    // const resident = products.find((el) => el.id === id);
    let resident: BussinessCatalogueProducts = undefined;
    let catImg = "";
    let categoryStr = "";
    for (const category of prodCategories) {
      resident = category.products.find((el) => el.id === id);
      catImg = category.catImgObj.fileName;
      categoryStr = category.category;
      if (resident) break;
    }
    setResidentDetails({
      address: resident.shortDescription,
      catImg: catImg,
      id: resident.id,
      name: resident.name,
      open: true,
      phones: [resident.phoneNumbers],
      hasBusiness: resident.hasSpecials,
      profession: `${categoryStr}${
        resident.description ? `, ${resident.description}` : ""
      }`,
    });
  };

  const closeResidentDetails = () => {
    setResidentDetails({
      open: false,
      address: "",
      catImg: "",
      id: "",
      name: "",
      profession: "",
      phones: [],
    });
  };

  const [changePassword, setChangePassword] = useState(false);

  useEffect(() => {
    const getResetPasswordVal = async () => {
      try {
        const res = await axios.get(
          `${IDIGIZEN_BACKEND_URL}/${getSetResetPasswordDB}`,
          {
            headers: { Authorization: API_SECURE_KEY },
            params: {
              access_token: token,
              token,
              id,
            },
          }
        );
        console.log("getResetPasswordVal :: Response reset password ", res);
        setChangePassword(!!res.data.data.resetPassword);
      } catch (e) {
        presentToast(e);
      }
    };
    if (
      !!id &&
      bussinessDetailsDB.isMarket &&
      bussinessDetailsDB.marketType === "RWA"
    )
      getResetPasswordVal();
  }, [id, bussinessDetailsDB]);

  const changePasswordJsx = (
    <BhpChangePasswordModal
      open={changePassword}
      onDidDismiss={() => {
        setChangePassword(false);
      }}
    />
  );

  const residentCardJsx = (
    <BhpResidentCardModal
      open={residentDetails.open}
      onDidDismiss={closeResidentDetails}
      marketName={bussinessDetailsDB.marketName}
      residentDetails={residentDetails}
    />
  );

  useEffect(() => {
    const checkForCouponRedeem = async () => {
      try {
        const params = getParamsFromSearchString(location.search);
        if (params.couponCode && params.merchantId) {
          // if (!id) {
          // setOpenCouponRedeem({ open: true, stage: "sign-in", message: msg });
          // validateCoupon(parseInt(params.couponCode));
          // } else {
          // validateCoupon(parseInt(params.couponCode));
          const res = await axios.get(
            `${IDIGIZEN_BACKEND_URL}/${getLoyaltyProgramRulesDB}`,
            {
              headers: { Authorization: API_SECURE_KEY },
              params: {
                access_token: token,
                token,
                schoolId,
              },
            }
          );
          console.log("Received response ", res);

          setOpenCouponRedeem({
            open: true,
            loading: false,
            message: `${params.couponCode}`,
            couponCode: params.couponCode,
            merchantId: parseInt(params.merchantId),
            supportsLoyalty: res.data.data.success,
          });
          // }
        } else {
          setOpenCouponRedeem({ open: false, loading: false });
        }
      } catch (e) {
        presentToast(e);
      }
    };
    checkForCouponRedeem();
  }, [location]);

  const callWhatsappSelJsx = (
    <CallWhatsappSelPrompt
      open={selCallWhatsapp}
      onDidDismiss={() => {
        setSelCallWhatsapp(false);
      }}
      phone={
        bussinessDetailsDB.contactPersonPhoneNums?.length
          ? bussinessDetailsDB.contactPersonPhoneNums[0]
          : ""
      }
    />
  );

  const [selectFloors, setSelectFloors] = useState(false);
  const floorSelectorJsx = (
    <IonPopover
      // enterAnimation={enterAnimation}
      isOpen={selectFloors}
      onDidDismiss={() => {
        setSelectFloors(false);
        // setOpenCatSel(false);
        // closeCatSelection();
      }}
      dismissOnSelect={true}
      // className="bhp-categories-popover"
    >
      <BhpThemeHeaderWithBack
        // onBack={setOpenCouponRedeem.bind(this, -1)}
        title={"Select Floor"}
      />
      <ContentWithBackground>
        {floors?.map((el, idx) => {
          return (
            <IonItem
              key={idx}
              onClick={() => {
                openSearchModal({
                  category: "",
                  open: true,
                  floor: el,
                });
              }}
            >
              <IonLabel color={"tertiary"}>{el}</IonLabel>
            </IonItem>
          );
        })}
      </ContentWithBackground>
      <IonFooter>
        <div style={{ padding: "5px" }}>
          <IonButton
            expand="block"
            color={"danger"}
            onClick={() => {
              setSelectFloors(false);
            }}
          >
            <IonIcon icon={close} slot="start" />
            Dismiss
          </IonButton>
        </div>
      </IonFooter>
    </IonPopover>
  );

  // const redeemCouponJsx = (
  //   <IonPopover
  //     isOpen={openCouponRedeem.open}
  //     onDidDismiss={() => {
  //       setOpenCouponRedeem({ open: false, loading: false });
  //     }}
  //   >
  //     <BhpThemeHeaderWithBack
  //       title={"Redeem Coupon"}
  //     />
  //     <ContentWithBackground>
  //       <div style={{ padding: "5px" }}>
  //         {!!openCouponRedeem.message && (
  //           <IonItem>
  //             <IonLabel color={"tertiary"} position="stacked">
  //               Redeem Coupon ID
  //             </IonLabel>
  //             <IonInput value={openCouponRedeem?.message} readonly={true} />
  //           </IonItem>
  //         )}
  //         {!!openCouponRedeem.supportsLoyalty && (
  //           <IonItem>
  //             <IonLabel
  //               color={!openCouponRedeem.amount ? "danger" : "tertiary"}
  //               position="stacked"
  //             >
  //               Bill Amount (Add to loyalty)
  //             </IonLabel>
  //             <IonInput
  //               type="number"
  //               value={openCouponRedeem?.amount}
  //               onIonChange={(e) => {
  //                 setOpenCouponRedeem((prevState) => {
  //                   const retVal = deepCopy(prevState);
  //                   if (!retVal.amount) retVal.amount = "";
  //                   retVal.amount = e.detail.value;
  //                   return retVal;
  //                 });
  //               }}
  //             />
  //           </IonItem>
  //         )}

  //         {!!id && (
  //           <IonButton
  //             expand="block"
  //             color={"tertiary"}
  //             onClick={redeemCoupon.bind(
  //               this,
  //               openCouponRedeem.couponCode,
  //               openCouponRedeem.merchantId,
  //               openCouponRedeem.amount,
  //               openCouponRedeem.supportsLoyalty
  //             )}
  //           >
  //             {openCouponRedeem.loading && <IonSpinner color={"light"} />}
  //             {!openCouponRedeem.loading && (
  //               <>
  //                 <IonIcon icon={pricetag} slot="start" /> Redeem
  //               </>
  //             )}
  //           </IonButton>
  //         )}
  //         {!id && (
  //           <IonButton
  //             expand="block"
  //             color={"primary"}
  //             onClick={() => {
  //               setSigninSignUpSelectionCbk(
  //                 false,
  //                 "Sign in with your merchant credentials to redeem."
  //               );
  //             }}
  //           >
  //             <>
  //               <IonIcon icon={person} slot="start" /> Sign-in to Redeem
  //             </>
  //           </IonButton>
  //         )}
  //         <IonButton
  //           expand="block"
  //           color={"danger"}
  //           fill="clear"
  //           onClick={() => {
  //             setOpenCouponRedeem({ open: false, loading: false });
  //           }}
  //         >
  //           <IonIcon icon={close} slot="start" /> Dismiss
  //         </IonButton>
  //       </div>
  //     </ContentWithBackground>
  //   </IonPopover>
  // );

  /*****************************************************************************
   * Name: updateCustomerDetailsWithLoginInfo
   * Description: Callback triggered post SignIn/SignUp. This will update the local
   *              customerDetails variable from the updated cookies that are now set
   ******************************************************************************/
  const updateCustomerDetailsWithLoginInfo = async (status: boolean) => {
    try {
      return; //disabling this code as it allows ppl to hijack other ppls login rights
      if (!status) {
        present({
          message: "Could not login / signup the user. Please retry",
          position: "middle",
          duration: 1500,
        });
        return;
      }

      //Successful login, update the session variables
      let sessionDetails = getSessionDetails();
      id = sessionDetails.id;
      email = sessionDetails.email;
      token = sessionDetails.token;
      role = sessionDetails.role;
      schoolId = sessionDetails.schoolId;

      if (!!id && !schoolId && role === "SHOP_OWNER") {
        //trigger the route to associate the shop with the shop owner
        const res = await axios.post(
          `${IDIGIZEN_BACKEND_URL}/${associateShopWithUser}`,
          JSON.stringify({}),
          {
            headers: { "Content-Type": "application/json" },
            params: {
              pathName: location.pathname,
              userId: id,
              role,
              Authorization: API_SECURE_KEY,
            },
          }
        );
        storeSessionDetails({ schoolId: res.data.data.schoolId });
      }

      //set the customer details from the fetched in session details
      if (!!id && role === "CUSTOMER") {
        //user is logged in fetch the details and set them
        const res = await axios.get(
          `${IDIGIZEN_BACKEND_URL}/${userInfoRouter}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
            params: {
              Authorization: API_SECURE_KEY,
              id,
              token,
              email,
            },
          }
        );
        const customerDetails = {
          id: res.data.data.id,
          address: res.data.data.address,
          email: email,
          name: res.data.data.name,
          phone: res.data.data.phoneNumber,
        };

        setCustomerDetails((prevState) => {
          return { ...prevState, ...customerDetails };
        });

        // setIsLoggedIn(true);
        setCustomerLoginDetails(customerDetails);
      }
      setUserDetailsAreValid(true);
      setLoading(false);
    } catch (err) {
      console.log("Error in updateCustomerDetailsWithLoginInfo ", err);
      presentToast(err);
      setLoading(false);
    }
  }; //End of updateCustomerDetailsWithLoginInfo

  const [isOpenCard, setIsOpenCard] =
    useState<BussinessHomeCardData>(undefined);
  // const modal = useRef<HTMLIonModalElement>(null);

  const handleOpenCloseCard = async (id) => {
    // setIsOpenCard(id);
    for (const cat of prodCategories) {
      const prod = cat.products.find((ci) => ci.id === id);
      if (prod) {
        const cardData: BussinessHomeCardData = {
          advertising: prod.advertising,
          variant: prod.variant,
          id: prod.id,
          imagePath: prod.imagePath,
          text: prod.description,
          title: prod.name,
          domain: prod.domain ? prod.domain : "",
          productList: prod.productList,
          isSpecial: prod.isSpecial,
          isNotListed: prod.isNotListed,
          subscriptionType: prod?.subscriptionType,
        };
        console.log("Card expand data ", cardData);
        setIsOpenCard(cardData);
        break;
      }
    }
  };

  const handleChildvariant = (variantName) => {
    setVariantName(variantName);
  };
  const handleChildAddToCart = (type, firstTime, id, variantName, price) => {
    if (type === "add") {
      addCart(firstTime, id, variantName, price);
    } else {
      removeCart(id, variantName, price);
    }
  };

  const expandCardJsx = (
    <BhpExpandCardView
      addRemoveCartCallBack={handleChildAddToCart}
      cartItems={cartItems}
      theme={theme}
      open={!!isOpenCard}
      onDismiss={() => {
        setIsOpenCard(undefined);
      }}
      search={search}
      textCartItems={textCartItems}
      cardData={isOpenCard}
      addItemizedFromText={addItemizedFromText}
      addOrderItemized={addOrderItemized}
      openCloseCard={handleOpenCloseCard}
      parentDomain={bussinessDetailsDB.domainName}
      marketListing={marketNotFound}
      variantIdCallback={handleChildvariant}
      openExpandImg={(filename, index) => {
        expandingImgOpen({
          fileName: filename,
          index: index,
          open: true,
        });
      }}
      isMarket={bussinessDetailsDB.isMarket}
      advanceCustomization={advanceCustomization}
    />
  );

  //Validate all the fields of the order form. Pre-validtion before we submit the order
  const [orderImage, setOrderImage] = useState<FileBundleType>({
    id: "",
    name: "",
    type: undefined,
  });
  const [orderNotes, setOrderNotes] = useState("");
  const [orderDate, setOrderDate] = useState("");
  const [orderTime, setOrderTime] = useState("");
  const [loyaltyRedeem, setLoyaltyRedeem] = useState(false);
  const [openAddItem, setOpenAddItem] = useState<{
    open: boolean;
    addMode: boolean;
    item?: string;
    details?: string;
    count?: number;
    img?: FileBundleType;
    nameEditable?: boolean;
    qty?: string;
    isQuery?: boolean;
  }>({ open: false, addMode: true });

  const addToCartPopoverJsx = (
    <BhpAddToCartCard
      isQuery={
        bussinessDetailsDB.subscriptionType !== "TIER-II" || openAddItem.isQuery
      }
      open={openAddItem.open}
      addMode={openAddItem.addMode}
      onDismiss={() => {
        setOpenAddItem({ open: false, addMode: true });
      }}
      enableQtyInput={bussinessDetailsDB.enableQtyOrder}
      img={{
        val: {
          url:
            openAddItem.img && openAddItem.img.url ? openAddItem.img.url : "",
        },
        setFunc: (img) => {
          setOpenAddItem((prevState) => {
            const retVal = deepCopy(prevState);
            retVal.img = img;
            return retVal;
          });
        },
      }}
      qtyInput={{
        val: openAddItem.qty,
        setFunc: (text: string, idx: number) => {
          setOpenAddItem((prevState) => {
            const retVal = deepCopy(prevState);
            retVal.qty = text;
            return retVal;
          });
        },
      }}
      notes={{
        val: openAddItem.details,
        setFunc: (notes: string, idx: number) => {
          setOpenAddItem((prevState) => {
            const retVal = deepCopy(prevState);
            retVal.details = notes;
            return retVal;
          });
        },
      }}
      item={{
        val: openAddItem.item,
        disableEdit: !openAddItem.nameEditable,

        setFunc: (item: string, idx: number) => {
          setOpenAddItem((prevState) => {
            const retVal = deepCopy(prevState);
            retVal.item = item;
            return retVal;
          });
        },
      }}
      count={{
        val: openAddItem.count,
        setFunc: (num: number, idx: number) => {
          setOpenAddItem((prevState) => {
            const retVal = deepCopy(prevState);
            retVal.count = num;
            return retVal;
          });
        },
      }}
      editCartItem={() => {
        checkoutOpen({
          mode: "itemized-order",
          open: true,
          filter: openAddItem.item,
        });
        setOpenAddItem({ open: false, addMode: true });
      }}
      addItemExec={() => {
        const uid = getCurrentTime();
        setTextCartItems((prevState) => {
          const retVal: TextCartItemType[] = deepCopy(prevState);
          retVal.push({
            count: openAddItem.count,
            img: openAddItem.img,
            name: openAddItem.item,
            uid: uid,
            notes: openAddItem.details,
            nameEditable: openAddItem.nameEditable,
            unit: openAddItem?.qty,
          });
          return retVal;
        });
        setOpenAddItem({ open: false, addMode: true });
        present({
          message: "Add to cart",
          color: "dark",
          duration: 1500,
          position: "middle",
        });
      }}
    />
  );

  const [adQuery, setAdQuery] = useState<AdvertisingDetailsType>(undefined);

  const [isDelivery, setIsDelivery] = useState(true);

  const checkOutModalJsx = (
    <>
      {bussinessDetailsDB.subscriptionType === "TIER-II" &&
        checkout.mode === "itemized-order" && (
          <BhpOrderModal
            adQuery={adQuery}
            orderSent={() => {
              setAlert({
                header: "Thank You!",
                message: `Your order has been sent to ${bussinessDetailsDB.name}. You will get a Whatsapp message once the order is accepted.`,
                open: true,
              });
              setCartItems([]);
              setOrderImage({
                id: "",
                name: "",
                type: undefined,
              });
              setOrderNotes("");
              setCustomerDetails({
                id: 0,
                address: "",
                email: "",
                name: "",
                phone: 0,
              });
              setAdQuery(undefined);
            }}
            enableSelDeliveryTime={bussinessDetailsDB.enableTimeSel}
            shopDomain={companyNameResolved}
            setOpenSignInSignUpModal={(inp) => {
              setOpenSignInSignUpModal(inp);
            }}
            updateCustomerDetailsWithLoginInfo={
              updateCustomerDetailsWithLoginInfo
            }
            setLoading={(inp) => {
              setLoading(inp);
            }}
            bussinessDetailsDB={bussinessDetailsDB}
            companyName={companyNameResolved}
            isLoggedIn={!!userInfo.id}
            setCustomerLoginDetails={(inp) => {
              setCustomerLoginDetails(inp);
            }}
            setUserDetailsAreValid={(inp) => {
              setUserDetailsAreValid(inp);
            }}
            userDetailsAreValid={userDetailsAreValid}
            loading={loading}
            customerDetails={customerDetails}
            writeToCustomerData={writeToCustomerData}
            customerLoginDetails={customerLoginDetails}
            setAlert={setAlert}
            enableQtyInput={bussinessDetailsDB.enableQtyOrder}
            open={checkout.open}
            onDismiss={() => {
              setAdQuery(undefined);
              checkoutClose();
            }}
            mode={checkout.mode}
            loyaltyCashRedeem={{
              val: loyaltyRedeem,
              setFunc: (val: boolean) => {
                setLoyaltyRedeem(val);
              },
            }}
            time={{
              val: orderTime,
              setFunc: (time) => {
                setOrderTime(time);
              },
            }}
            date={{
              val: orderDate,
              setFunc: (date) => {
                setOrderDate(date);
              },
            }}
            item={{
              val: orderNotes,
              setFunc: (text, idx) => {
                setOrderNotes(text);
              },
            }}
            orderImage={orderImage}
            img={{
              val: { url: orderImage.url },
              setFunc: (img) => {
                setOrderImage(img);
              },
            }}
            cartItems={cartItems}
            setCartItems={setCartItems}
            products={prodCategories}
            deleteCartEntry={(idx: number, isTextCart: boolean) => {
              setExecAlert({
                message: "Are you sure you want to delete this entry?",
                open: true,
                executeFunc: deleteCartItem,
                funcInputs: { isTextCart: isTextCart, idx: idx },
              });
            }}
            textCartItems={textCartItems}
            setTextCartItems={setTextCartItems}
            checkoutFilter={checkout.filter}
            isDelivery={isDelivery}
            updateDeliveryType={(val) => {
              setIsDelivery(val);
            }}
          />
        )}
      {!(
        bussinessDetailsDB.subscriptionType === "TIER-II" &&
        checkout.mode === "itemized-order"
      ) && (
        <BhpCartModal
          adQuery={adQuery}
          orderSent={() => {
            setAlert({
              header: "Thank You!",
              message: `Your query has been sent to ${bussinessDetailsDB.name}. We will get back to you shortly.`,
              open: true,
            });
            setCartItems([]);
            setOrderImage({
              id: "",
              name: "",
              type: undefined,
            });
            setOrderNotes("");
            setCustomerDetails({
              id: 0,
              address: "",
              email: "",
              name: "",
              phone: 0,
            });
            setAdQuery(undefined);
          }}
          enableSelDeliveryTime={bussinessDetailsDB.enableTimeSel}
          shopDomain={companyNameResolved}
          setOpenSignInSignUpModal={(inp) => {
            setOpenSignInSignUpModal(inp);
          }}
          updateCustomerDetailsWithLoginInfo={
            updateCustomerDetailsWithLoginInfo
          }
          setLoading={(inp) => {
            setLoading(inp);
          }}
          bussinessDetailsDB={bussinessDetailsDB}
          companyName={companyNameResolved}
          isLoggedIn={!!userInfo.id}
          setCustomerLoginDetails={(inp) => {
            setCustomerLoginDetails(inp);
          }}
          setUserDetailsAreValid={(inp) => {
            setUserDetailsAreValid(inp);
          }}
          userDetailsAreValid={userDetailsAreValid}
          loading={loading}
          customerDetails={customerDetails}
          writeToCustomerData={writeToCustomerData}
          customerLoginDetails={customerLoginDetails}
          setAlert={setAlert}
          enableQtyInput={bussinessDetailsDB.enableQtyOrder}
          open={checkout.open}
          onDismiss={() => {
            setAdQuery(undefined);
            checkoutClose();
          }}
          mode={checkout.mode}
          loyaltyCashRedeem={{
            val: loyaltyRedeem,
            setFunc: (val: boolean) => {
              setLoyaltyRedeem(val);
            },
          }}
          time={{
            val: orderTime,
            setFunc: (time) => {
              setOrderTime(time);
            },
          }}
          date={{
            val: orderDate,
            setFunc: (date) => {
              setOrderDate(date);
            },
          }}
          item={{
            val: orderNotes,
            setFunc: (text, idx) => {
              setOrderNotes(text);
            },
          }}
          orderImage={orderImage}
          img={{
            val: { url: orderImage.url },
            setFunc: (img) => {
              setOrderImage(img);
            },
          }}
          cartItems={cartItems}
          setCartItems={setCartItems}
          products={prodCategories}
          deleteCartEntry={(idx: number, isTextCart: boolean) => {
            setExecAlert({
              message: "Are you sure you want to delete this entry?",
              open: true,
              executeFunc: deleteCartItem,
              funcInputs: { isTextCart: isTextCart, idx: idx },
            });
          }}
          textCartItems={textCartItems}
          setTextCartItems={setTextCartItems}
          checkoutFilter={checkout.filter}
        />
      )}
    </>
  );

  // const screenWidth = useAppSelector((state) => state.screenWidth).width;
  // const isMob =
  //   useAppSelector((state) => state.screenWidth).width < mobileWidthBreakpoint;
  // const isTab =
  //   useAppSelector((state) => state.screenWidth).width < tabWidthBreakpoint;
  // const inputElem = useRef(null);

  // const [logonOpen, setLogonOpen] = useState<boolean>(false);
  const [openSearchPopup, setOpenSearchPopup] = useState<boolean>(false);
  const [visitCounter, setVisitCounter] = useState<{
    shopVisits?: number;
    marketVisits: number;
  }>({ marketVisits: 0 });
  // const [couponIsOpen, setCouponIsOpen] = useState<boolean>(false);

  const handleScroll = (val, isCentre = false) => {
    const element = document.getElementById(val);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: isCentre ? "center" : "start",
      });
    }
    console.log(" input clicked ", element);
  };

  const hamburgerMenuId = "bhp-hamburger-menu-id";

  const orderNowExec = (isQuery: boolean = false) => {
    if (bussinessDetailsDB.orderMode == "booking") {
      checkoutOpen({ mode: "booking", open: true });
      // checkoutOpen({ isPicOnly: true, open: true });
    } else if (bussinessDetailsDB.orderMode === "query") {
      checkoutOpen({ mode: "enquiry", open: true });
    } else {
      setOpenAddItem({
        open: true,
        count: 1,
        details: "",
        item: search,
        img: { id: "", name: "", type: undefined },
        addMode: true,
        nameEditable: true,
        qty: "",
        isQuery: isQuery,
      });
    }
  };

  // const noCatalogueOrderingMenuJsx = (
  //   <IonGrid>
  //     <IonRow>
  //       <IonCol size="12">
  //         <IonButton
  //           color={"dark"}
  //           expand="block"
  //           size="small"
  //           fill="solid"
  //           onClick={() => {
  //             orderNowExec();
  //           }}
  //         >
  //           {bussinessDetailsDB?.orderMode === "booking"
  //             ? "Book Now"
  //             : bussinessDetailsDB?.orderMode === "query"
  //             ? "Enquire Now"
  //             : "Order Now"}
  //         </IonButton>
  //       </IonCol>
  //     </IonRow>
  //   </IonGrid>
  // );

  const getParamsUrlForHome = (isMid: boolean): string => {
    if (vypzeePage) return "";
    let paramUrl: string = isMid ? "&" : "?";
    paramUrl =
      paramUrl +
      `marketDomain=${
        bussinessDetailsDB.isMarket
          ? bussinessDetailsDB.domainName
          : bussinessDetailsDB.marketDomain
      }`;
    if (!bussinessDetailsDB.isMarket) {
      paramUrl = paramUrl + `&shopDomain=${bussinessDetailsDB.domainName}`;
    }
    return paramUrl;
  };
  // const [login, setLogin] = useState(false);

  const [openCatSel, setOpenCatSel] = useState(false);
  const [openCatSelInModal, setOpenCatSelInModal] = useState(false);
  const [openFeedback, setOpenFeedback] = useState(false);
  const [feedbackOpen, feedbackClose] = useModalController(
    "feedbackOpen",
    setOpenFeedback,
    () => {
      setOpenFeedback(false);
    }
  );
  const [paintFeedbackBtn, setPaintFeedbackBtn] = useState(false);

  // const [openCatSelection, closeCatSelection] = useModalController(
  //   "catSel",
  //   setOpenCatSel,
  //   () => {
  //     setOpenCatSel(false);
  //   }
  // );
  // const [catSearch, setCatSearch] = useState("");
  const [openDetailsId, setOpenDetailsId] = useState<{
    id: string | number;
    category: string;
    mode: "AD" | "PROD";
  }>(undefined);
  const [openDetails, closeDetails] = useModalController(
    "details",
    setOpenDetailsId,
    () => {
      setOpenDetailsId(undefined);
    }
  );

  const categoriesSelectionJsx = (
    <BhpCategoriesSelection
      open={openCatSel}
      dismiss={() => {
        setOpenCatSel(false);
      }}
      bussinessDetailsDB={bussinessDetailsDB}
      categoryCardClick={(category: string) => {
        // if (searchModal.open || !bussinessDetailsDB.isMarket) {
        recordAction({
          action: userActionsTable.categoryClick,
          pageId: bussinessDetailsDB.id,
          pageSection: "CATEGORY_EXPAND_MAIN",
          pageType: getPageType(
            bussinessDetailsDB.isMarket,
            bussinessDetailsDB.marketType
          ),
          notes: category,
        });
        setTimeout(() => handleScroll(category), 500);
        // } else {
        //   openSearchModal({
        //     category: category,
        //     open: true,
        //   });
        // }
        setOpenCatSel(false);
      }}
      prodCategories={prodCategories}
      advanceCustomization={advanceCustomization}
    />
  );

  // const handleClearClick = () => {
  //   setSearch("");
  // };
  const [pageHeaderRef, pageHeaderInView] = useInView();
  const [makeSubheaderVisible, setMakeSubheaderVisible] = useState(false);

  // const subHeaderJsx = (
  //   <>
  //     <div className="bussiness-home-subheader-top">
  //       <div
  //         className="bussiness-home-subheader-top-right"
  //         style={{
  //           width: "100%",
  //         }}
  //       >
  //         <div className="search-container">
  //           <div className="search-icon">
  //             {" "}
  //             <IonIcon icon={searchOutline} />
  //           </div>

  //           <input
  //             type="text"
  //             className={`search-input
  //               ${moveToTopVisible ? "search-input-scroll-override" : ""}
  //               `}
  //             placeholder="Search"
  //             value={search}
  //             onChange={(e) => {
  //               if (!search && e.target.value) {
  //                 scrollToTop(true);
  //               }
  //               setSearch(e.target.value);
  //             }}
  //             onFocus={() => {
  //               openSearchModal({ open: true, category: "" });
  //             }}
  //           />
  //           {search && (
  //             <span className="clear-button" onClick={handleClearClick}>
  //               &#10006;
  //             </span>
  //           )}
  //         </div>
  //       </div>
  //     </div>
  //   </>
  // );
  const [openMenubar, setOpenMenubar] = useState(false);
  // const isM3M = styleId === 1;
  // const isM3M =
  //   companyNameResolved === "ggnm3mifc" ||
  //   (!!companyNameResolved &&
  //     companyNameResolved.split("-")[0] === "ggnm3mifc");

  const menuBarPopoverJsx = (
    <BhpMenuPopover
      changePassword={() => {
        setsigninupModal({ isSignup: false, open: true, changePassword: true });
      }}
      reducedMode={styleData.reducedDrawerMenu === "true"}
      triggerId={`popover-button-${bussinessDetailsDB.id}-${bussinessDetailsDB.isMarket}`}
      onDidDismiss={() => {
        setOpenMenubar(false);
      }}
      open={openMenubar}
      onClickLogin={setOpenSignInSignUpModal.bind(this, true)}
      isLoggedIn={!!userInfo.id}
      companyName={companyNameResolved}
      bussinessDetailsDB={bussinessDetailsDB}
      getParamsUrlForHome={getParamsUrlForHome}
      handleScroll={handleScroll}
    />
  );

  // const menuBarJsx = (
  //   <>
  //     <div
  //       id={`popover-button-${bussinessDetailsDB.id}-${bussinessDetailsDB.isMarket}`}
  //       style={{
  //         display: "flex",
  //         justifyContent: "center",
  //         alignItems: "center",
  //       }}
  //       onClick={setOpenMenubar.bind(this, true)}
  //     >
  //       <IonIcon icon={menuOutline} className="menu-bar-icon" />
  //     </div>
  //   </>
  // );

  const addCart = (
    firstTime: boolean,
    id: string,
    variantName: string,
    price: number
  ) => {
    // console.log(
    //   "Add cart inputs ",
    //   firstTime,
    //   " id ",
    //   id,
    //   " variant ",
    //   variantName,
    //   " price ",
    //   price
    // );
    if (firstTime) {
      recordAction({
        action: userActionsTable.addRemoveProd,
        pageId: bussinessDetailsDB.id,
        pageSection: "MAIN",
        pageType: getPageType(
          bussinessDetailsDB.isMarket,
          bussinessDetailsDB.marketType
        ),
        popId: id,
        popType: "PROD",
        notes: "add",
      });
    }
    setCartItems((prevState) => {
      const retVal = deepCopy(prevState);
      if (firstTime)
        retVal.push({
          id: id,
          count: 1,
          variantName: variantName,
          price: price,
        });
      else {
        const item = retVal.find(
          (ci) => ci.id === id && ci.variantName === variantName
        );
        item.count++;
      }
      return retVal;
    });
  };

  const removeCart = (id: string, variantName: string, price: number) => {
    let removed = false;
    setCartItems((prevState) => {
      const retVal = deepCopy(prevState);
      const itemIdx = retVal.findIndex(
        (ci) => ci.id === id && ci.variantName === variantName
      );
      retVal[itemIdx].count--;
      if (!retVal[itemIdx].count) {
        removed = true;
        retVal.splice(itemIdx, 1);
      }
      return retVal;
    });
    if (removed) {
      recordAction({
        action: userActionsTable.addRemoveProd,
        pageId: bussinessDetailsDB.id,
        pageSection: "MAIN",
        pageType: getPageType(
          bussinessDetailsDB.isMarket,
          bussinessDetailsDB.marketType
        ),
        popId: id,
        popType: "PROD",
        notes: "remove",
      });
    }
  };

  // const contentID = "landing-page-content-id";
  const [variantName, setVariantName] = useState("");

  const loginLogo = bussinessDetailsDB.logo
    ? `${IDIGIZEN_BACKEND_URL}/${getFileThumbnailDB}?fileName=${bussinessDetailsDB.logo}&percentage=40&Authorization=${API_SECURE_KEY}&`
    : getLogo(true);

  const [testimonial, setTestimonial] = useState<BusinessTestimonialDetails[]>(
    []
  );

  useEffect(() => {
    if (!bussinessDetailsDB.id) return;
    axios
      .get(`${IDIGIZEN_BACKEND_URL}/${getVisitCountDB}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: API_SECURE_KEY,
        },
        params: {
          shopId: !bussinessDetailsDB.isMarket ? bussinessDetailsDB.id : 0,
          marketId: bussinessDetailsDB.isMarket
            ? bussinessDetailsDB.id
            : bussinessDetailsDB.marketId,
        },
      })
      .then((res) => {
        console.log("Got the visits count ", res);
        setVisitCounter(res.data.data);
      })
      .catch((e) => {});
  }, [bussinessDetailsDB.id, bussinessDetailsDB?.isMarket]);

  useEffect(() => {
    const getTestimonialData = async () => {
      try {
        let data = await axios.get(
          `${IDIGIZEN_BACKEND_URL}/${getBhpTestimonialsDetailsDB}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: API_SECURE_KEY,
            },
            params: {
              domainName: companyNameResolved,
              Authorization: API_SECURE_KEY,
            },
          }
        );
        console.log("Got testimonial data ", data.data.data);

        setTestimonial(data.data.data.data);
      } catch (e) {
        presentToast(e);
      }
    };
    if (
      !!bussinessDetailsDB.id &&
      !(
        bussinessDetailsDB.isMarket &&
        bussinessDetailsDB.marketType === "VYPZEE"
      )
    )
      getTestimonialData();
  }, [bussinessDetailsDB]);

  // const [query, setQuery] = useState<{
  //   name: string;
  //   phone: string;
  //   email: string;
  //   query: string;
  // }>({ name: "", email: "", phone: "", query: "" });

  // const saveQuery = (
  //   key: "email" | "name" | "phone" | "query",
  //   value: string
  // ) => {
  //   setQuery((prevState) => {
  //     const retVal = deepCopy(prevState);
  //     retVal[key] = value;
  //     return retVal;
  //   });
  // };

  // const submitQuery = async () => {
  //   try {
  //     const res = await axios.post(
  //       `${IDIGIZEN_BACKEND_URL}/${saveBhpCustomerQueryDB}`,
  //       JSON.stringify(query),
  //       {
  //         headers: { "Content-Type": "application/json" },
  //         params: {
  //           schoolIdQ: isInternal ? schoolId : 0,
  //           domainName: companyNameResolved,
  //           Authorization: API_SECURE_KEY,
  //         },
  //       }
  //     );
  //     setLogin(false);
  //     setAlert({ message: "Your query is submitted. Thank You!", open: true });
  //   } catch (e) {}
  // };
  const saveVcard = useSaveVcard();

  const [vCardDownloaded, setVCardDownloaded] = useState(false);
  const [vCardDownloadAlert, setVCardDownloadAlert] = useState("");
  const [downloadAlertIsOpen, setDownloadAlertIsOpen] = useState(false);
  // const params = getParamsFromSearchString(location.search);

  const downloadFunction = (value) => {
    setVCardDownloaded(true);
    setVCardDownloadAlert("something");
    setDownloadAlertIsOpen(true);
  };

  const bhpPromoLoaded = useAppSelector(
    (state) => state.loginInfoSelection.bhpPromoLoaded
  );

  useEffect(() => {
    if (
      bussinessDetailsDB.isMarket &&
      bussinessDetailsDB.marketType === "MARKET" &&
      !bhpPromoLoaded
    ) {
      const searchParams = getParamsFromSearchString(window.location.search);
      if (!searchParams.promptFeedbackNDirection) {
        setOpenSearchPopup(true);
      }
      dispatch(loginInfoActions.updatePromoLoaded({ loaded: true }));
    }
  }, [bussinessDetailsDB]);

  // const openSearchPopupJsx = (
  //   <BhpPromoModal
  //     name={bussinessDetailsDB.name}
  //     open={openSearchPopup}
  //     bgImg={logoImgData}
  //     onDismiss={() => {
  //       setOpenSearchPopup(false);
  //     }}
  //     onClick={() => {
  //       recordAction({
  //         action: userActionsTable.search,
  //         pageId: bussinessDetailsDB.id,
  //         pageSection: "MAIN",
  //         pageType: getPageType(
  //           bussinessDetailsDB.isMarket,
  //           bussinessDetailsDB.marketType
  //         ),
  //         notes: "Popup prompt",
  //       });
  //       setOpenSearchPopup(false);
  //       hotKeyFunctions["openSearch"]({ bypass: true });
  //     }}
  //   />
  // );

  // const VcDownloadAlertJsx = (
  //   <>
  //     <IonAlert
  //       isOpen={downloadAlertIsOpen}
  //       header="Alert"
  //       subHeader="Important message"
  //       message="Shop Vcard has been downloaded. Add to your contacts to redeem your voucher later."
  //       buttons={["OK"]}
  //       onDidDismiss={() => setDownloadAlertIsOpen(false)}
  //     ></IonAlert>
  //   </>
  // );

  // const couponPromoJsx = (
  //   <BhpCouponPromoModal
  //     open={couponIsOpen}
  //     onDismiss={() => {
  //       setCouponIsOpen(false);
  //     }}
  //     customerDetails={customerDetails}
  //     onShopNow={() => {
  //       setCouponIsOpen(false);
  //     }}
  //     onSaveForLater={async () => {
  //       const x = await saveVcard(
  //         params.shop ? params.shop : "",
  //         false,
  //         params,
  //         false
  //       );
  //       if (x) {
  //         downloadFunction(x);
  //       }
  //     }}
  //   />
  // );

  const saveContactRef = useRef(null);

  const removeContactSaveParamFromUrl = () => {
    // Get the current URL
    const currentURL = window.location.href;

    // Remove the query parameter
    const updatedURL = currentURL.replace(/\?promptContactSave=true/g, "");

    // Replace the current state in the history without triggering a reload
    window.history.replaceState({}, document.title, updatedURL);
    setPromptedContactSave(true);
  };

  const showShopCatList: boolean = useMemo(() => {
    if (editMode) {
      return true;
    }
    if (bussinessDetailsDB.isMarket && bussinessDetailsDB.marketType === "USER")
      return false;
    if (!bussinessDetailsDB.isMarket && prodCategories.length === 1)
      return false;
    if (prodCategories && prodCategories.length) {
      for (const cat of prodCategories) {
        if (!!cat.catImgObj?.fileName) return true;
      }
    }
    return false;
  }, [prodCategories, bussinessDetailsDB, editMode]);
  // const marketAboutSectionJsx = (
  //   <BhpMarketIntroCard
  //     description={bussinessDetailsDB.shortDescription}
  //     imgBg={logoImgData}
  //     name={bussinessDetailsDB.name}
  //     saveClick={() => {
  //       hotKeyFunctions["saveContact"]({ notes: "From BizCard" });
  //     }}
  //     searchClick={() => {
  //       hotKeyFunctions["openSearch"]({ notes: "From BizCard" });
  //     }}
  //     detailsClick={() => {
  //       hotKeyFunctions["aboutUs"]();
  //     }}
  //   />
  // );
  const logoImg: { fileName: string; rotation: number; imgCss: string } =
    useMemo(() => {
      if (bussinessDetailsDB.logo) {
        return convertImgJsonToObj(bussinessDetailsDB.logo);
      } else {
        return { fileName: "", imgCss: "", rotation: 0 };
      }
    }, [bussinessDetailsDB]);

  const storeAboutSectionJsx = (
    <BhpAdvStoreIntroCard
      visitCount={visitCounter}
      expandImage={() => {
        expandingImgOpen({
          fileName: bussinessDetailsDB.images,
          index: 0,
          open: true,
        });
      }}
      openQr={() => {
        qrOpen(true);
      }}
      businessDetails={bussinessDetailsDB}
      review={{
        score: bussinessDetailsDB.reviewScore,
        count: testimonial.length,
      }}
      save={() => {
        hotKeyFunctions["saveContact"]({ notes: "From Biz Card Contact Us" });
      }}
      marketLogoJson={bussinessDetailsDB?.marketLogo}
      name={bussinessDetailsDB.name}
      address={bussinessDetailsDB?.address}
      bhpEditLinks={bussinessDetailsDB.bhpEditLinks}
      editMode={editMode}
      imgData={bussinessDetailsDB?.images}
      // imgData={logoImgData}
      // imgCss={logoImg.imgCss}
      id={bussinessDetailsDB.id}
      marketName={bussinessDetailsDB?.marketName}
      marketType={bussinessDetailsDB?.marketType}
      onDirection={() => {
        console.log("Called direction");
        hotKeyFunctions["combinedDirection"]();
      }}
      phones={bussinessDetailsDB.contactPersonPhoneNums}
      recordUserInteraction={true}
      shortDescription={bussinessDetailsDB?.description}
      detailsClick={() => {
        hotKeyFunctions["aboutUs"]();
      }}
      advanceCustomization={advanceCustomization}
    />
  );

  const showBizCard = useMemo(() => {
    if (styleData?.dontShowBizCard === "true") return false;
    if (loadingCompany) return false;
    if (marketNotFound) return false;
    // if (isM3M && bussinessDetailsDB.isMarket) return false;
    // if (!!styleId) {
    if (bussinessDetailsDB.isMarket) {
      if (bussinessDetailsDB.marketType === "USER") return true;
      else return false;
    } else {
      return false;
    }
    // } else {
    //   return true;
    // }
  }, [
    loadingCompany,
    marketNotFound,
    bussinessDetailsDB,
    prodCategories,
    styleData,
  ]);

  const bizCardCollapsed = useMemo(() => {
    if (promptContactSave) return false;
    if (
      bussinessDetailsDB.isMarket &&
      (bussinessDetailsDB.marketType === "RWA" ||
        bussinessDetailsDB.marketType === "USER")
    ) {
      if (bussinessDetailsDB.subType === "BNI-CHAPTER") return true;
      return false;
    }
    if (!bussinessDetailsDB.isMarket) return false;
    return true;
  }, [prodCategories, bussinessDetailsDB, promptContactSave, prodCategories]);

  const residentBizCard = useMemo(() => {
    if (
      !(bussinessDetailsDB.isMarket && bussinessDetailsDB.marketType === "RWA")
    )
      return undefined;
    if (!prodCategories || !prodCategories.length) return undefined;
    for (const category of prodCategories) {
      const resident = category.products.find((el) => el.id == id);
      if (resident) {
        return {
          id: resident.id,
          profession: `${category.category}${
            resident.description ? `, ${resident.description}` : ""
          }`,
          name: resident.name,
          phones: resident.phoneNumbers ? [resident.phoneNumbers] : undefined,
        };
      }
    }
  }, [id, prodCategories, bussinessDetailsDB]);

  const [createBizCard, setCreateBizCard] = useState(false);
  const [openCreateBizCard, closeCreateBizCard] = useModalController(
    "createBiz",
    setCreateBizCard,
    () => {
      setCreateBizCard(false);
    }
  );

  const bizCardJsx = (
    <BhpBizCard
      save={() => {
        hotKeyFunctions["saveContact"]({ notes: "From Biz Card Contact Us" });
      }}
      vypzeePage={vypzeePage}
      editMode={editMode}
      bhpEditLinks={bussinessDetailsDB.bhpEditLinks}
      subType={bussinessDetailsDB.subType}
      highlightButton={
        !bussinessDetailsDB?.subType?.startsWith("BNI-CHAPTER") &&
        bussinessDetailsDB.isMarket &&
        bussinessDetailsDB.marketType === "MARKET"
          ? {
              icon: searchOutline,
              name: !bussinessDetailsDB?.subType?.startsWith("BNI-CHAPTER")
                ? "Search In Market"
                : "Search",
              onClick: () => {
                // Bypass the recording as the biz card is already recording it
                hotKeyFunctions["openSearch"]({ bypass: true });
              },
            }
          : !bussinessDetailsDB.isMarket
          ? {
              icon: navigate,
              name: "Directions To Store",
              onClick: () => {
                // Bypass the recording as the biz card is already recording it
                hotKeyFunctions["combinedDirection"]();
              },
            }
          : undefined
      }
      shortDescription={
        !bussinessDetailsDB.isMarket
          ? bussinessDetailsDB?.address
          : bussinessDetailsDB?.shortDescription
      }
      recordUserInteraction={true}
      namePrefix={
        bussinessDetailsDB.isMarket &&
        bussinessDetailsDB.marketType === "MARKET"
          ? "Explore Market Online"
          : undefined
      }
      isMarket={bussinessDetailsDB.isMarket}
      marketType={bussinessDetailsDB.marketType}
      id={bussinessDetailsDB.id}
      isPersonal={bussinessDetailsDB.marketType === "USER"}
      catImg={
        vypzeePage
          ? JSON.parse(cityData.cityImage)?.fileName
          : bussinessDetailsDB.categoryImg?.fileName
      }
      imgData={
        residentBizCard
          ? "assets/profile.avif"
          : vypzeePage
          ? undefined
          : logoImgData
      }
      name={
        residentBizCard
          ? residentBizCard.name
          : vypzeePage
          ? cityData.cityName
          : bussinessDetailsDB.name
      }
      marketName={bussinessDetailsDB.marketName}
      onClick={() => {
        saveVcardExec();
        setPromptSaveContact(true);
      }}
      phones={
        residentBizCard
          ? residentBizCard.phones
          : bussinessDetailsDB.contactPersonPhoneNums
      }
      address={
        vypzeePage
          ? cityData.stateName
          : !residentBizCard
          ? bussinessDetailsDB?.isMarket
            ? bussinessDetailsDB?.address
            : bussinessDetailsDB?.shortDescription
          : undefined
      }
      profession={!residentBizCard ? undefined : residentBizCard.profession}
      isCollapsed={bizCardCollapsed}
      paddingBottomPx={showShopCatList ? 0 : 10}
      disableCollapseExpand={
        (bussinessDetailsDB.isMarket &&
          bussinessDetailsDB.marketType !== "USER") ||
        vypzeePage
      }
      disableSave={vypzeePage}
      disableContactUs={
        (bussinessDetailsDB.isMarket &&
          bussinessDetailsDB.marketType !== "USER" &&
          !floors?.length &&
          !vypzeePage) ||
        (styleData.headerStyle === "CARD_ICON" &&
          !(
            bussinessDetailsDB.isMarket &&
            bussinessDetailsDB.marketType === "VYPZEE"
          ))
      }
      buttonOverrideContactUs={
        vypzeePage
          ? {
              exec: () => {
                setAlert({
                  message:
                    "We are only in Delhi-NCR for now. More cities comming soon!",
                  open: true,
                });
              },
              name: "Select City",
            }
          : bussinessDetailsDB.isMarket &&
            bussinessDetailsDB.marketType !== "USER" &&
            floors.length
          ? {
              name:
                bussinessDetailsDB.isMarket &&
                bussinessDetailsDB.domainName == "ggnqutubplaza"
                  ? "Path Finder"
                  : "Floor Select",
              exec: () => {
                if (
                  bussinessDetailsDB.isMarket &&
                  bussinessDetailsDB.domainName === "ggnqutubplaza"
                )
                  window.location.assign(
                    `https://vypzee.com/maps?marketId=24&floorId=8`
                  );
                else setSelectFloors(true);
              },
            }
          : undefined
      }
      buttonOverrideSave={
        bussinessDetailsDB.isMarket && bussinessDetailsDB.marketType === "RWA"
          ? {
              exec: () => {
                window.location.assign(bhpRwaPersonalDetailsUrl);
              },
              name: "Edit Profile",
            }
          : undefined
      }
      buttonOverrideShare={
        bussinessDetailsDB.isMarket && bussinessDetailsDB.marketType === "RWA"
          ? {
              exec: () => {
                openCreateBizCard(true);
              },
              name: "Create My Business Card",
            }
          : undefined
      }
      whatsappInfo={
        (styleData.headerStyle === "CIRCLE_ICON" &&
          !promptContactSave &&
          !vypzeePage) ||
        (styleData.headerStyle === "CARD_ICON" &&
          bussinessDetailsDB.isMarket &&
          bussinessDetailsDB.marketType === "USER")
          ? {
              domainName: bussinessDetailsDB.domainName,
              isMarket: bussinessDetailsDB.isMarket,
              name: bussinessDetailsDB.name,
              marketDomain: bussinessDetailsDB.marketDomain,
              marketType: bussinessDetailsDB.marketType,
              seoDetails: bussinessDetailsDB.seoUrlDetails,
            }
          : undefined
      }
    />
  );

  const bookTableJsx = (
    <TableBookingModal
      open={bookingModal}
      onDismiss={() => {
        closeBooking();
      }}
      merchantId={bussinessDetailsDB.id}
      bizCardJsx={bizCardJsx}
      couponId={couponId}
    />
  );

  const generateDiscountJsx = (
    <BhpGenerateDiscount
      storeName={bussinessDetailsDB.name}
      storeId={bussinessDetailsDB.id}
      open={discountModal}
      onDismiss={() => {
        setDiscountModal(false);
      }}
      merchantId={bussinessDetailsDB.id}
      maxDiscountPercStr={bussinessDetailsDB.maxDiscountPerc}
      maxDiscountAmtStr={bussinessDetailsDB.maxDiscountAmt}
    />
  );

  const promptToSaveJsx = (
    <IonModal
      ref={saveContactRef}
      isOpen={promptContactSave}
      onDidDismiss={() => {
        setPromptContactSave(false);
        removeContactSaveParamFromUrl();
      }}
      className="bhp-save-contact-popover"
    >
      <BhpThemeHeaderWithBack
        title="Save To Contacts"
        onBack={() => {
          setPromptContactSave(false);
        }}
      />
      <ContentWithBackground>{bizCardJsx}</ContentWithBackground>
      <IonFooter>
        <div style={{ padding: "5px" }}>
          <IonButton
            expand="block"
            onClick={() => {
              saveVcard(
                companyNameResolved,
                bussinessDetailsDB.isMarket &&
                  bussinessDetailsDB?.marketType !== "USER",
                "",
                bussinessDetailsDB?.marketType === "RWA",
                bussinessDetailsDB.isMarket &&
                  bussinessDetailsDB?.marketType === "USER"
                  ? bussinessDetailsDB.id
                  : 0
              );
              saveContactRef.current.dismiss();
            }}
          >
            Save
          </IonButton>
          <IonButton
            color={"secondary"}
            expand="block"
            fill="clear"
            onClick={() => {
              saveContactRef.current.dismiss();
            }}
          >
            Skip
          </IonButton>
        </div>
      </IonFooter>
    </IonModal>
  );

  const [selectedShop, setSelectedShop] =
    useState<BussinessHomeCardData>(undefined);

  useEffect(() => {
    // const scrollToShop = () => {
    //   const params = getParamsFromSearchString(location.search);
    //   if (params.shop) {
    //     setSelectedShop(params.shop);
    //     handleScroll(`business-home-page-market-domain-${params.shop}`, true);
    //   }
    // };
    // setTimeout(scrollToShop, 750);
    const params = getParamsFromSearchString(location.search);
    // if (params.shop) {
    //   let el: BussinessCatalogueProducts = undefined;
    //   for (const cat of prodCategories) {
    //     if (bussinessDetailsDB.isMarket) {
    //       el = cat.products.find((el) => el.domain === params.shop);
    //     } else {
    //       el = cat.products.find((el) => el.id == params.shop);
    //     }
    //     console.log("Shop found ", el, " in the cat ", cat);
    //     if (el) break;
    //   }
    //   if (el) {
    //     const cardData: BussinessHomeCardData = {
    //       stockImage: el?.stockImage,
    //       advertising: el?.advertising,
    //       variant: el.variant,
    //       id: el.id,
    //       imagePath: el.imagePath,
    //       text: el.description,
    //       title: el.name,
    //       domain: el.domain,
    //       productList: el.productList,
    //       isSpecial: el.isSpecial,
    //       isNotListed: el.isNotListed,
    //       subscriptionType: el?.subscriptionType,
    //     };
    //     setSelectedShop(cardData);
    //   } else {
    //     setSelectedShop(undefined);
    //   }
    // } else {
    //   setSelectedShop(undefined);
    // }

    if (params.feedbackBtn) {
      setPaintFeedbackBtn(true);
    }

    // if (params.editMode) {
    //   // setEditMode(true);
    //   dispatch(loginInfoActions.updateBhpEditMode({ loaded: true }));
    // }
  }, [location, prodCategories, bussinessDetailsDB]);

  const bannerButtonClick = (url?: string) => {
    if (url) {
      window.location.assign(url);
      return;
    }
    orderNowExec();
  };

  const setSigninSignUpSelectionCbk = (isSignUp: boolean, msg?: string) => {
    console.log("setSigninSignUpSelectionCbk isSignUp =", isSignUp);
    setsigninupModal({ isSignup: isSignUp, open: true, msg: msg });
    setOpenSignInSignUpModal(false);
  };

  const orderModeSelRef = useRef(null);

  const ionContentRefScroll = useRef(null);
  function scrollToTop(noDelay: boolean = false) {
    // Passing a duration to the method makes it so the scroll slowly
    // goes to the top instead of instantly
    ionContentRefScroll.current?.scrollToTop(!noDelay ? 500 : 0);
  }

  // function handleScrollOffer() {
  //   console.log("scroll in view ", pageHeaderInView);
  //   if (!prodCategories.length) {
  //     setMoveToTopVisible(false);
  //     return;
  //   }
  //   if (!pageHeaderInView) {
  //     setMoveToTopVisible(true);
  //   } else {
  //     setMoveToTopVisible(false);
  //   }
  // }

  // useEffect(() => {
  //   handleScrollOffer();
  // }, [pageHeaderInView, prodCategories]);

  const [showAllPromos, setShowAllPromos] = useState<boolean>(false);
  const [showAllPromosTrends, setShowAllPromosTrends] = useState(false);
  const [openShowAllPromos, closeShowAllPromo] = useModalController(
    "allPromo",
    setShowAllPromos,
    () => {
      setShowAllPromos(false);
    }
  );

  useEffect(() => {
    ionContentRefScroll.current.scrollToTop(500);
  }, []);

  // console.log("dd : ", prodCategories);
  const [scrollHeaderCol, setScrollHeaderCol] = useState(false);
  // useEffect(() => {
  //   if (!search) {
  //     return setScrollHeaderCol(moveToTopVisible);
  //   }
  // }, [search, moveToTopVisible]);

  const selectedShopJsx = (
    <BhpSelectedShop
      bussinessDetailsDB={bussinessDetailsDB}
      handleCheckoutOpen={handleCheckoutOpen}
      cartItems={cartItems}
      handleChildAddToCart={handleChildAddToCart}
      handleChildvariant={handleChildvariant}
      handleOpenCloseCard={handleOpenCloseCard}
      marketNotFound={marketNotFound}
      selectedShop={selectedShop}
      textCartItems={textCartItems}
      openExpandImg={(filename, index) => {
        expandingImgOpen({
          fileName: filename,
          index: index,
          open: true,
        });
      }}
      advanceCustomization={advanceCustomization}
    />
  );

  // const trendsSectionJsx = (
  //   <BusinessHomePageSection
  //     // disableMargin={{ top: bussinessDetailsDB.isMarket ? false : true }}
  //     subHeaderText={`Latest in ${bussinessDetailsDB.name}`}
  //     enableSubheaderStickyScroll={false}
  //     subHeaderNoBg={true}
  //     headingLine={true}
  //     subHeaderButtons={[
  //       {
  //         color: "dark",
  //         fill: "solid",
  //         name: "See All",
  //         onClick: () => {
  //           recordAction({
  //             action: userActionsTable.seeAll,
  //             pageId: bussinessDetailsDB.id,
  //             pageSection: "MAIN",
  //             pageType: getPageType(
  //               bussinessDetailsDB.isMarket,
  //               bussinessDetailsDB.marketType
  //             ),
  //             notes: "Trends",
  //           });
  //           openShowAllPromos(true);
  //           setShowAllPromosTrends(true);
  //         },
  //       },
  //     ]}
  //   >
  //     <BhpTrendsSection
  //       bussinessDetailsDB={bussinessDetailsDB}
  //       openTrendsExpand={(id) => {
  //         openDetails({ id: id, category: "", mode: "AD" });
  //       }}
  //       adData={trendsData}
  //       editMode={editMode}
  //       pageId={bussinessDetailsDB.id}
  //       pageSection="MAIN"
  //       recordUserInteraction={true}
  //     />
  //     {!!editMode && (
  //       <IonButton
  //         fill="solid"
  //         color={"tertiary"}
  //         expand="block"
  //         onClick={() => {
  //           history.push(
  //             bussinessDetailsDB.bhpEditLinks.addTrend.replace(
  //               "SCHOOL_ID",
  //               bussinessDetailsDB.id
  //             )
  //           );
  //         }}
  //       >
  //         <IonIcon icon={add} slot="start" />
  //         Add Latest Announcement
  //       </IonButton>
  //     )}
  //   </BusinessHomePageSection>
  // );

  const socialMediaJsx = (
    <IonPopover
      isOpen={openSocialHandle}
      onDidDismiss={() => {
        setOpenSocialHandle(false);
      }}
      dismissOnSelect={true}
    >
      <BhpThemeHeaderWithBack
        title="Social Media Handles"
        onBack={() => {
          setOpenSocialHandle(false);
        }}
      />
      <IonContent>
        {!bussinessDetailsDB?.socialMedia?.facebookLink &&
          !bussinessDetailsDB?.socialMedia?.instagramLink &&
          !bussinessDetailsDB?.socialMedia?.linkedinLink &&
          !bussinessDetailsDB?.socialMedia?.youtubeLink && (
            <div
              style={{ padding: "10px", textAlign: "center", color: "brown" }}
            >
              No Social Handles Listed!
            </div>
          )}
        {!!bussinessDetailsDB?.socialMedia?.facebookLink && (
          <IonButton
            fill="clear"
            expand="block"
            className="bhp-sm-btn-facebook"
            onClick={() => {
              recordAction({
                action: userActionsTable.socialMedia,
                pageId: bussinessDetailsDB.id,
                pageSection: "MAIN",
                pageType: getPageType(
                  bussinessDetailsDB.isMarket,
                  bussinessDetailsDB.marketType
                ),
                notes: "Facebook",
              });
              window.location.assign(
                bussinessDetailsDB.socialMedia?.facebookLink
              );
            }}
          >
            <IonIcon icon={logoFacebook} slot="start" />
            Facebook
          </IonButton>
        )}
        {!!bussinessDetailsDB?.socialMedia?.instagramLink && (
          <IonButton
            fill="clear"
            expand="block"
            className="bhp-sm-btn-instagram"
            onClick={() => {
              recordAction({
                action: userActionsTable.socialMedia,
                pageId: bussinessDetailsDB.id,
                pageSection: "MAIN",
                pageType: getPageType(
                  bussinessDetailsDB.isMarket,
                  bussinessDetailsDB.marketType
                ),
                notes: "Instagram",
              });
              window.location.assign(
                bussinessDetailsDB.socialMedia?.instagramLink
              );
            }}
          >
            <IonIcon icon={logoInstagram} slot="start" />
            Instagram
          </IonButton>
        )}
        {!!bussinessDetailsDB?.socialMedia?.youtubeLink && (
          <IonButton
            fill="clear"
            expand="block"
            className="bhp-sm-btn-youtube"
            onClick={() => {
              recordAction({
                action: userActionsTable.socialMedia,
                pageId: bussinessDetailsDB.id,
                pageSection: "MAIN",
                pageType: getPageType(
                  bussinessDetailsDB.isMarket,
                  bussinessDetailsDB.marketType
                ),
                notes: "Youtube",
              });
              window.location.assign(
                bussinessDetailsDB.socialMedia?.youtubeLink
              );
            }}
          >
            <IonIcon icon={logoYoutube} slot="start" />
            Youtube
          </IonButton>
        )}
        {!!bussinessDetailsDB?.socialMedia?.linkedinLink && (
          <IonButton
            fill="clear"
            expand="block"
            className="bhp-sm-btn-linkedin"
            onClick={() => {
              recordAction({
                action: userActionsTable.socialMedia,
                pageId: bussinessDetailsDB.id,
                pageSection: "MAIN",
                pageType: getPageType(
                  bussinessDetailsDB.isMarket,
                  bussinessDetailsDB.marketType
                ),
                notes: "Youtube",
              });
              window.location.assign(
                bussinessDetailsDB.socialMedia?.linkedinLink
              );
            }}
          >
            <IonIcon icon={logoLinkedin} slot="start" />
            LinkedIn
          </IonButton>
        )}
      </IonContent>
    </IonPopover>
  );

  const displayAdData: AdvertisingDetailsType[] = useMemo(() => {
    return advertisingBannerData.filter(
      (el) => el.exportToMarket === "YES" || !bussinessDetailsDB.isMarket
    );
  }, [advertisingBannerData, bussinessDetailsDB]);

  const marketAboutSectionJsx = (
    <BusinessHomePageSection
      // disableMargin={{ top: bussinessDetailsDB.isMarket ? false : true }}
      subHeaderText={`About ${bussinessDetailsDB.name}`}
      enableSubheaderStickyScroll={false}
      subHeaderNoBg={true}
      headingLine={true}
      subHeaderButtons={[
        {
          color: "dark",
          fill: "solid",
          name: "See More",
          onClick: () => {
            hotKeyFunctions["aboutUs"]();
          },
        },
      ]}
    >
      <div style={{ padding: "5px 10px", fontSize: "0.8rem" }}>
        {bussinessDetailsDB.shortDescription}
        {!!category && (
          <div style={{ paddingTop: "5px" }}>
            <IonButton
              expand="block"
              color={"secondary"}
              onClick={() => {
                window.location.assign(
                  getSeoUrl(bussinessDetailsDB.seoUrlDetails)
                );
              }}
            >
              <IonIcon icon={arrowForward} slot="end" />
              Explore Full Directory
            </IonButton>
          </div>
        )}
      </div>
    </BusinessHomePageSection>
  );

  const promoSectionJsx = (
    <BusinessHomePageSection
      // disableMargin={{ top: bussinessDetailsDB.isMarket ? false : true }}
      subHeaderText="Hot Offers & Events"
      enableSubheaderStickyScroll={false}
      subHeaderNoBg={true}
      headingLine={true}
      subHeaderButtons={[
        {
          color: "dark",
          fill: "solid",
          name: "See All",
          onClick: () => {
            recordAction({
              action: userActionsTable.seeAll,
              pageId: bussinessDetailsDB.id,
              pageSection: "MAIN",
              pageType: getPageType(
                bussinessDetailsDB.isMarket,
                bussinessDetailsDB.marketType
              ),
              notes: "ADs",
            });
            openShowAllPromos(true);
            setShowAllPromosTrends(true);
          },
        },
      ]}
    >
      <BhpTrendsSection
        bussinessDetailsDB={bussinessDetailsDB}
        openTrendsExpand={(id) => {
          openDetails({ id: id, category: "", mode: "AD" });
        }}
        adData={displayAdData}
        editMode={editMode}
        pageId={bussinessDetailsDB.id}
        pageSection="MAIN"
        recordUserInteraction={true}
        advanceCustomization={advanceCustomization}
      />
      {/* <Swiper
        modules={[]}
        slidesPerView={"auto"}
        zoom={true}
        pagination={{
          clickable: true,
        }}
        onSwiper={setSwiperRef}
      >
        {displayAdData.map((el, idx) => {
          return (
            <SwiperSlide key={idx} className="bhp-slider-width">
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <BhpAdBannerWrapper
                  contextIsShop={!bussinessDetailsDB.isMarket}
                  editMode={editMode}
                  idx={idx}
                  key={idx}
                  adData={el}
                  logoImgData={logoImgData}
                  domainName={bussinessDetailsDB.domainName}
                  marketDomain={
                    !bussinessDetailsDB.isMarket
                      ? bussinessDetailsDB.marketDomain
                      : ""
                  }
                  marketName={
                    !bussinessDetailsDB.isMarket
                      ? bussinessDetailsDB.marketName
                      : bussinessDetailsDB.name
                  }
                  marketType={bussinessDetailsDB.marketType}
                  pageId={bussinessDetailsDB.id}
                  pageSection={"MAIN"}
                  recordUserInteraction={true}
                />
              </div>
              {editMode && (
                <IonButton
                  size="small"
                  color={"tertiary"}
                  onClick={() => {
                    history.push(
                      bussinessDetailsDB.bhpEditLinks.editOffer
                        .replace("%offerId%", el.id)
                        .replace("%SCHOOL_ID%", bussinessDetailsDB.id)
                    );
                  }}
                >
                  <IonIcon icon={pencil} />
                </IonButton>
              )}
            </SwiperSlide>
          );
        })}
      </Swiper> */}
      {editMode && (
        <IonButton
          expand="block"
          fill="solid"
          color={"tertiary"}
          onClick={() => {
            history.push(
              bussinessDetailsDB.bhpEditLinks[
                bussinessDetailsDB.isMarket ? "addMarketOffer" : "addOffer"
              ].replace("%SCHOOL_ID%", bussinessDetailsDB.id)
            );
          }}
        >
          <IonIcon icon={add} slot="start" />
          Add
        </IonButton>
      )}
      {!advertisingBannerData.length && openAdMode && (
        <div
          style={{
            color: "var(--ion-color-medium)",
            textAlign: "center",
            fontSize: ".9rem",
          }}
        >
          No Promotions active!
        </div>
      )}
    </BusinessHomePageSection>
  );

  useEffect(() => {
    if (
      total === 1 &&
      !(
        bussinessDetailsDB.subscriptionType === "TIER-II" &&
        checkout.mode === "itemized-order"
      )
    ) {
      checkoutOpen({ mode: "itemized-order", open: true });
    }
  }, [total]);

  const cartFooterJsx = (
    <IonFooter>
      <div
        style={{
          padding: "10px 5px",
        }}
        onClick={() => {
          // setCheckout(true);
          checkoutOpen({ mode: "itemized-order", open: true });
        }}
      >
        <div className="bhp-cart-button-footer">
          <div style={{ fontSize: "1rem" }}>
            {total}
            {bussinessDetailsDB.subscriptionType !== "TIER-II" && (
              <> Query Added</>
            )}
            {bussinessDetailsDB.subscriptionType === "TIER-II" && (
              <> Item(s) Added</>
            )}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <span
              style={{
                marginRight: "10px",
              }}
            >
              {bussinessDetailsDB.subscriptionType !== "TIER-II" && (
                <>Place Query</>
              )}
              {bussinessDetailsDB.subscriptionType === "TIER-II" && (
                <>View Cart</>
              )}
            </span>
            <IonIcon icon={arrowForwardOutline} slot="end" />
          </div>
        </div>
      </div>
    </IonFooter>
  );

  // const getHotKey = () => {
  //   if (isM3M && bussinessDetailsDB.isMarket) return "M3MMarket";
  //   if (
  //     isM3M &&
  //     !bussinessDetailsDB.isMarket &&
  //     bussinessDetailsDB.orderMode !== "booking"
  //   )
  //     return "M3MShop";
  //   if (
  //     isM3M &&
  //     !bussinessDetailsDB.isMarket &&
  //     bussinessDetailsDB.orderMode === "booking"
  //   )
  //     return "M3MResturant";
  //   if (!bussinessDetailsDB.isMarket) {
  //     if (bussinessDetailsDB.orderMode === "booking") return "resturant";
  //     else return "shop";
  //   } else {
  //     if (bussinessDetailsDB.marketType === "USER") return "user";
  //     else if (bussinessDetailsDB.marketType === "VYPZEE") return "vypzee";
  //     else return "market";
  //   }
  // };

  const shopCatDisplayJsx = (
    <BusinessHomePageSection
      subHeaderText={
        bussinessDetailsDB.isMarket
          ? bussinessDetailsDB.marketType === "MARKET"
            ? "Shop Categories"
            : bussinessDetailsDB.marketType === "VYPZEE"
            ? "Explore Markets"
            : bussinessDetailsDB?.subType?.startsWith("BNI-CHAPTER")
            ? "Week-wise Give / Asks"
            : `${bussinessDetailsDB.name} - Directory`
          : "Categories"
      }
      enableSubheaderStickyScroll={false}
      subHeaderNoBg={true}
      headingLine={true}
      subHeaderButtons={[
        {
          color: "dark",
          fill: "solid",
          name: "See All",
          onClick: () => {
            recordAction({
              action: userActionsTable.categoryExpand,
              pageId: bussinessDetailsDB.id,
              pageSection: "MAIN",
              pageType: getPageType(
                bussinessDetailsDB.isMarket,
                bussinessDetailsDB.marketType
              ),
              notes: "See All Category Section",
            });
            setOpenCatSel(true);
          },
        },
      ]}
    >
      <div
        className="bhp-category-card-container"
        style={{ paddingBottom: "15px" }}
      >
        {prodCategories &&
          !!prodCategories.length &&
          prodCategories.map((el, idx) => {
            if (
              el.category.toLowerCase() === "featured" &&
              bussinessDetailsDB.isMarket
            ) {
              return <div key={idx}></div>;
            } else {
              return (
                <div key={idx} style={{ flexShrink: 0, marginRight: "10px" }}>
                  <BhpCategoryCard
                    shape="square"
                    sizeInPx={100}
                    iconMode={true}
                    catNum={
                      advanceCustomization?.hideCategoryNumbers
                        ? undefined
                        : el.numProducts
                        ? el.numProducts
                        : el.products.length
                    }
                    catNumCeiling={99}
                    imgFile={el.catImgObj?.fileName}
                    name={el.category}
                    onClick={() => {
                      recordAction({
                        action: userActionsTable.categoryClick,
                        pageId: bussinessDetailsDB.id,
                        pageSection: "MAIN",
                        pageType: getPageType(
                          bussinessDetailsDB.isMarket,
                          bussinessDetailsDB.marketType
                        ),
                        notes: el.category,
                      });
                      // setOpenCatSel(true);
                      setTimeout(() => handleScroll(el.category), 300);
                    }}
                    advanceCustomization={advanceCustomization}
                    marketName={
                      bussinessDetailsDB?.isMarket &&
                      !vypzeePage &&
                      bussinessDetailsDB?.name
                    }
                  />
                  {editMode && !bussinessDetailsDB.isMarket && (
                    <IonButton
                      disabled={el.id == 667}
                      size="small"
                      color={"tertiary"}
                      onClick={() => {
                        history.push(
                          bussinessDetailsDB.bhpEditLinks.editCategory
                            .replace("%storeId%", bussinessDetailsDB.id)
                            .replace("%catName%", el.category)
                        );
                      }}
                    >
                      <IonIcon icon={pencil} />
                      {/* <div style={{ padding: "10px" }}>
                    <IonIcon color="danger" icon={trashBin} />
                  </div> */}
                    </IonButton>
                  )}
                </div>
              );
            }
          })}
      </div>
      {!!(editMode && !bussinessDetailsDB.isMarket) && (
        <IonButton
          color={"tertiary"}
          fill="solid"
          expand="block"
          onClick={() => {
            history.push(
              bussinessDetailsDB.bhpEditLinks.addCategory.replace(
                "%storeId%",
                bussinessDetailsDB.id
              )
            );
          }}
        >
          <IonIcon icon={add} slot="start" /> Add Category
        </IonButton>
      )}
    </BusinessHomePageSection>
  );

  const [showProdShowList, setShowProdShowList] = useState(false);

  useEffect(() => {
    if (
      !bussinessDetailsDB.isMarket ||
      (bussinessDetailsDB.isMarket &&
        bussinessDetailsDB.marketType === "USER") ||
      (bussinessDetailsDB.isMarket &&
        (bussinessDetailsDB.marketType === "VYPZEE" ||
          (!!category && bussinessDetailsDB.marketType === "MARKET") ||
          bussinessDetailsDB.marketType === "MARKET_CLUSTER" ||
          bussinessDetailsDB.marketType === "RWA"))
    )
      setShowProdShowList(true);
    else setShowProdShowList(false);
  }, [bussinessDetailsDB.isMarket, category]);

  const [productOpened, setProductOpened] = useState(false);

  useEffect(() => {
    if (!productOpened && prodCategories.length) {
      const params = getParamsFromSearchString(location.search);
      if (params.productId) {
        let productId = undefined;
        let categoryName = "";
        for (const category of prodCategories) {
          const prod = category.products.find(
            (el) => el.id == params.productId
          );
          if (prod) {
            categoryName = category.category;
            productId = prod.id;
            break;
          }
        }
        if (!!categoryName) {
          recordAction({
            action: userActionsTable.openProduct,
            pageId: bussinessDetailsDB.id,
            pageSection: "MAIN",
            pageType: getPageType(
              bussinessDetailsDB.isMarket,
              bussinessDetailsDB.marketType
            ),
            popId: productId,
            popType: "PROD",
            notes: "From Share",
          });
          openDetails({ id: productId, category: categoryName, mode: "PROD" });
          setProductOpened(true);
        }
      }
    }
  }, [prodCategories, location]);

  const searchModalJsx = (
    <BhpSearchModalWraper
      categoryMode={!!category}
      openQuery={() => {
        closeSearchModal();
        setTimeout(() => {
          handleCheckoutOpen();
        }, 800);
      }}
      refreshingData={loadingProducts}
      navigate={(
        location: { obj?: PositionType; url?: string },
        shopId: string,
        shopName: string
      ) => {
        hotKeyFunctions["combinedDirection"]({
          location,
          shopId,
          shopName: shopName,
        });
      }}
      expandDetails={(id, category, mode) => {
        console.log("Expand details ", id, " :: ", category, " ", mode);
        openDetails({ id, category, mode: mode ? mode : "PROD" });
      }}
      searchText={searchModal?.searchText}
      pageSection="SEARCH"
      recordUserInteractions={true}
      styleData={styleData}
      open={searchModal.open}
      adMaker={adMaker}
      onDidDismiss={() => {
        closeSearchModal();
      }}
      searchCategoryClick={(category) => {
        setTimeout(() => {
          handleScroll(category);
        }, 300);
      }}
      hasProducts={!!prodCategories.length}
      onAddFreeTextOrder={() => {
        setOpenAddItem({
          open: true,
          count: 1,
          details: "",
          item: search,
          img: { id: "", name: "", type: undefined },
          addMode: true,
          nameEditable: true,
          qty: "",
        });
        // setSearch("");
      }}
      categoriesSel={{
        open: openCatSelInModal,
        setOpen: setOpenCatSelInModal,
      }}
      onClickCatBtn={() => {
        setOpenCatSelInModal(true);
      }}
      addOrderItemized={addOrderItemized}
      advertisingBannerData={advertisingBannerData}
      bussinessDetailsDB={bussinessDetailsDB}
      cartFooterJsx={cartFooterJsx}
      logoImgData={logoImgData}
      prodCategories={prodCategories}
      searchModal={searchModal}
      total={total}
      vypzeePage={vypzeePage}
      addItemizedFromText={addItemizedFromText}
      bannerButtonClick={bannerButtonClick}
      buttonOverride={
        bussinessDetailsDB.isMarket && bussinessDetailsDB.marketType === "RWA"
          ? {
              onClick: openResidentDetails,
              name: "Details",
            }
          : undefined
      }
      cartItems={cartItems}
      customerDetails={customerDetails}
      expandingImgOpen={expandingImgOpen}
      floors={floors}
      handleCheckoutOpen={handleCheckoutOpen}
      handleChildAddToCart={handleChildAddToCart}
      handleChildvariant={handleChildvariant}
      handleOpenCloseCard={handleOpenCloseCard}
      logoImg={logoImg}
      textCartItems={textCartItems}
      getMarketShowGetAllData={async (
        id: string,
        idx: number,
        block: string
      ) => {
        console.log("Called from here!");
        getProductDetails([{ id: id, index: idx, maxElements: -1 }], block);
      }}
      getMarketBlockData={async (block: string) => {
        console.log("Called from here!");
        getProductDetails(undefined, block, true);
      }}
      advanceCustomization={advanceCustomization}
    />
  );

  // const subheaderWithCartJsx = (
  //   <div
  //     style={{
  //       width: "100%",
  //       display:
  //         bussinessDetailsDB.subscriptionType === "VCARD" ? "none" : "flex",
  //       alignItems: "center",
  //       justifyContent: "space-between",
  //     }}
  //   >
  //     <div
  //       style={{
  //         width: !!headerCartJsx ? "85%" : "100%",
  //       }}
  //     >
  //       {subHeaderJsx}
  //     </div>
  //     {!!headerCartJsx && (
  //       <div
  //         style={{
  //           fontSize: "2rem",
  //           display: "flex",
  //           justifyContent: "center",
  //           alignItems: "center",
  //           paddingRight: "15px",
  //           color: "var(--ion-color-dark)",
  //         }}
  //       >
  //         {headerCartJsx}
  //       </div>
  //     )}
  //   </div>
  // );
  // const shopActionButtonsJsx = (
  //   <div>
  //     <IonGrid>
  //       <IonRow>
  //         {vypzeeHotKeys.map((el, idx) => {
  //           return (
  //             <IonCol size="3" key={idx}>
  //               <div>
  //                 <BhpCategoryCard
  //                   imgFile={el.imgFileName}
  //                   name={el.name}
  //                   horizontalMode={true}
  //                   //  iconMode={true}
  //                   //  iconBlockMode={true}

  //                   onClick={() => {
  //                     hotKeyFuncLookup[el.name.toLowerCase()]();
  //                   }}
  //                 />
  //               </div>
  //             </IonCol>
  //           );
  //         })}
  //       </IonRow>
  //     </IonGrid>
  //   </div>
  // );

  const [promptSaveContact, setPromptSaveContact] = useState(false);

  const saveBusinessCardNotesJsx = (
    <BhpSaveBusinessCardNotes
      open={promptSaveContact}
      onDidDismiss={() => {
        setPromptSaveContact(false);
      }}
    />
  );

  const [openOnlineHealth, setOpenOnlineHealth] = useState<{
    open: boolean;
    mode: "CUSTOMER_EX" | "ONLINE_HEALTH";
  }>({ mode: "CUSTOMER_EX", open: false });
  const [onlineHealthOpen, onlineHealthClose] = useModalController(
    "online-health",
    setOpenOnlineHealth,
    () => {
      setOpenOnlineHealth({ mode: "CUSTOMER_EX", open: false });
    }
  );

  const [openDashboard, setOpenDashboard] = useState(false);
  const [dashboardOpen, dashboardClose] = useModalController(
    "dashboard",
    setOpenDashboard,
    () => {
      setOpenDashboard(false);
    }
  );
  // useEffect(() => {
  //   // dashboardOpen(true);
  //   setOpenOnlineHealth({ mode: "ONLINE_HEALTH", open: true });
  // }, []);

  const dashboardJsx = (
    <BhpStoreOwnerDashboard
      open={openDashboard}
      onDismiss={dashboardClose}
      name={bussinessDetailsDB.name}
      marketName={bussinessDetailsDB.marketName}
      marketId={bussinessDetailsDB.marketId}
      isMarket={bussinessDetailsDB.isMarket}
      storeId={bussinessDetailsDB.id}
    />
  );

  const onlineHealthJsx = (
    <BhpOnlineHealth
      open={openOnlineHealth.open}
      mode={openOnlineHealth.mode}
      onDismiss={onlineHealthClose}
      marketName={bussinessDetailsDB?.marketName}
      clickNext={() => {
        onlineHealthClose();
        setTimeout(() => {
          dashboardOpen(true);
        }, 1000);
      }}
      websiteStrength={bussinessDetailsDB?.websiteStrength}
    />
  );

  // const [openCustomerLoyalty, setOpenCustomerLoyalty] = useState(false);

  // const customerLoyaltyPromptJsx = (
  //   <IonPopover
  //     isOpen={openCustomerLoyalty}
  //     onDidDismiss={() => {
  //       setOpenCustomerLoyalty(false);
  //     }}
  //   >
  //     <BhpThemeHeaderWithBack title="Enroll In Rewards Program" />
  //     <ContentWithBackground>
  //       <Card>
  //         <div>Welcome to {bussinessDetailsDB.name} Rewards Program</div>
  //         <div>Get 5% cashback on every order</div>
  //       </Card>
  //     </ContentWithBackground>
  //     <IonFooter>
  //       <div style={{ padding: "5px" }}>
  //         <IonButton>Enroll Now</IonButton>
  //       </div>
  //     </IonFooter>
  //   </IonPopover>
  // );

  const [openTerms, setOpenTerms] = useState<{
    open: boolean;
    disableButtons?: boolean;
  }>({ open: false });
  const [termsMerchantMode, setTermsMerchantMode] = useState(false);
  const userPage =
    bussinessDetailsDB.isMarket && bussinessDetailsDB.marketType === "USER";

  const subheaderOnScrollJsx = (
    <div
      className={`bhp-subheader-on-scroll ${
        (!pageHeaderInView && userPage) || (makeSubheaderVisible && !userPage)
          ? "bhp-subheader-on-scroll-visible"
          : "bhp-subheader-on-scroll-invisible"
      }`}
      style={{
        borderBottom: `1px solid lightgray`,
        background: "var(--ion-color-bhp-white)",
      }}
    >
      {/* {subheaderWithCartJsx} */}
      <div
        style={{
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
        }}
      >
        <BhpMenuButton
          noBg={true}
          styleData={styleData}
          popoverId={`popover-button-${bussinessDetailsDB.id}-${bussinessDetailsDB.isMarket}`}
          onClick={setOpenMenubar.bind(this, true)}
        />
        <div
          className="bussiness-home-page-hdr-mkt-name"
          style={{
            paddingLeft: "10px",
            color: styleData?.headerFontColor
              ? styleData?.headerFontColor
              : "var(--ion-color-bhp-vypzee-dark)",
            fontFamily:
              "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif",
          }}
        >
          <div>{bussinessDetailsDB.name}</div>
          {bussinessDetailsDB.isMarket &&
            bussinessDetailsDB.marketType === "MARKET" && (
              <div
                style={{
                  fontSize: "0.6rem",
                  fontWeight: "normal",
                  color: "var(--ion-color-bhp-gray)",
                }}
              >
                {bussinessDetailsDB.address}
              </div>
            )}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <IonButton
          color={"medium"}
          size="small"
          fill="clear"
          onClick={() => {
            qrOpen(true);
          }}
        >
          <IonIcon icon={qrCodeOutline} />
        </IonButton>
        <IonButton
          color={"medium"}
          size="small"
          fill="clear"
          onClick={() => {
            recordAction({
              action: userActionsTable.search,
              pageId: bussinessDetailsDB.id,
              pageSection: "MAIN",
              pageType: getPageType(
                bussinessDetailsDB.isMarket,
                bussinessDetailsDB.marketType
              ),
              notes: "Search Icon Button",
            });
            openSearchModal({
              open: true,
            });
          }}
        >
          <IonIcon icon={searchSharp} />
        </IonButton>
        {/* <div
          style={{
            height: "30px",
            width: "30px",
            // borderRadius: "50%",
            background: "none",
            // boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            // border: props.styleData.headerBaseColor,
            // color: "#e4e1b8",
            color: styleData.headerBaseColorHighlight,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "22px",
            overflow: "hidden",
            flexDirection: "column",
            flexShrink: 0,
            marginRight: "5px",
          }}
          onClick={() => {
            qrOpen(true);
          }}
        >
          <IonIcon icon={qrCodeOutline} />
        </div> */}
        {/* <BhpSearchIconButton
          styleData={styleData}
          onClick={() => {
            scrollToTop();
          }}
          icon={chevronUp}
        />
        <div style={{ width: "10px" }}></div> */}
        {/* <BhpSearchIconButton
          styleData={styleData}
          onClick={() => {
            recordAction({
              action: userActionsTable.search,
              pageId: bussinessDetailsDB.id,
              pageSection: "MAIN",
              pageType: getPageType(
                bussinessDetailsDB.isMarket,
                bussinessDetailsDB.marketType
              ),
              notes: "Search Icon Button",
            });
            openSearchModal({
              open: true,
            });
          }}
        /> */}
      </div>
    </div>
  );

  const fabButtonsJsx = (
    <IonFab horizontal="end" vertical="bottom" slot="fixed">
      <IonFabButton
        onClick={() => {
          scrollToTop();
          // hotKeyFunctions["openSearch"]({ notes: "Fab Button" });
        }}
        size="small"
        className="bhp-fab-button-top"
      >
        {/* <IonIcon icon={searchOutline} /> */}
        <IonIcon icon={chevronUp} />
        {/* <IonImg src="assets/category.png" /> */}
      </IonFabButton>
      <IonFabButton
        onClick={() => {
          recordAction({
            action: userActionsTable.categoryExpand,
            pageId: bussinessDetailsDB.id,
            pageSection: "MAIN",
            pageType: getPageType(
              bussinessDetailsDB.isMarket,
              bussinessDetailsDB.marketType
            ),
            notes: "Fab Button",
          });
          setOpenCatSel(true);
        }}
        className="bhp-fab-button"
      >
        <IonIcon icon={grid} />
        {/* <IonImg src="assets/category.png" /> */}
      </IonFabButton>
    </IonFab>
  );

  const vypzeeContactMeJsx = (
    <div
      style={{
        backgroundColor: "var(--ion-color-bhp-footer)",
        color: "white",
      }}
      className="home-version-text"
    >
      <div
        style={{
          textAlign: "center",
        }}
      >
        Powered by{" "}
        <a href="https://vypzee.com" style={{ marginLeft: "5px" }}>
          {" "}
          Vypzee
        </a>
      </div>
      <div
        style={{
          color: "dark",
          paddingTop: "10px",
          fontWeight: "bold",

          textAlign: "center",
        }}
      >
        Get your market / shop online. Advertise.{" "}
        <span
          onClick={contactSupport.bind(this, "Hello team VypZee")}
          style={{
            padding: "5px",
            background: "var(--ion-color-primary)",
            color: "white",
            borderRadius: "5px",
          }}
        >
          Contact Us
        </span>
      </div>
      <div style={{ height: "10px" }}></div>
    </div>
  );

  const downloadShopQRExec = async () => {
    let { id, schoolId } = getSessionDetails();
    try {
      const res = await axios.get(
        `${IDIGIZEN_BACKEND_URL}/${downloadRawQrForShop}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: API_SECURE_KEY,
          },
          params: {
            id,
            shopId: bussinessDetailsDB.id,
            isMarket: bussinessDetailsDB.isMarket,
            searchParams: getParamsFromSearchString(location.search),
          },
          responseType: "arraybuffer",
        }
      );
      await promptFileDownload(res);
    } catch (err) {
      setAlert({ message: "QR is not assigned yet for this shop", open: true });
    }
  };

  const [card, setCard] = React.useState<PrivilegeCardType>(undefined);
  useEffect(() => {
    const fetchCards = async () => {
      try {
        const res = await axios.get(
          `${IDIGIZEN_BACKEND_URL}/${getPrivilegeCardTypesDB}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: API_SECURE_KEY,
            },
            params: {
              marketId: bussinessDetailsDB.id,
              role,
              id,
              customerMode: true,
            },
          }
        );
        //   console.log("Return data ", res.data.data);
        if (res.data.data.data.length) setCard(res.data.data.data[0]);
      } catch (err) {
        // props.setAlert("QR is not assigned yet for this shop");
        presentToast(err);
      }
    };
    if (id && role === "CUSTOMER" && bussinessDetailsDB.isMarket) fetchCards();
  }, [bussinessDetailsDB, role, id]);

  const privilegeCardJsx = (
    <BusinessHomePageSection
      subHeaderText="My Privilege Card"
      headingLine={true}
    >
      <div
        style={{ padding: "10px", display: "flex", justifyContent: "center" }}
      >
        <BhpLoyaltyCard
          onClick={() => {
            history.push(`/loyalty?marketId=${bussinessDetailsDB.id}`);
          }}
          cardNumber={card?.cardNumber}
          cardType={card?.label}
          memberName={userInfo?.name}
          memberProfilePic={card?.memberPhotoFileName}
          memberSince={getPrintDateDDMMYYYY(card?.memberSince)}
          tinyUrlQr={card?.tinyUrlQr}
          type={card?.theme}
          marketLogo={bussinessDetailsDB.logoImgObj?.fileName}
          // memberProfilePic={userInfo?.}
        />
      </div>
    </BusinessHomePageSection>
  );

  ///*********** Experimental code for google translate ***********/
  // const googleTranslateElementInit = () => {
  //   new window.google.translate.TranslateElement(
  //     {
  //       pageLanguage: "en", // The source language of your page
  //       includedLanguages: "hi", // Target language (Hindi)
  //       layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
  //     },
  //     "google_translate_element"
  //   );
  // };

  // useEffect(() => {
  //   // Define a function to load the Google Translate script
  //   const loadGoogleTranslateScript = () => {
  //     const script = document.createElement("script");
  //     script.src =
  //       "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
  //     script.async = true;
  //     document.body.appendChild(script);
  //   };

  //   // Define the callback function for when the script is loaded
  //   window.googleTranslateElementInit = googleTranslateElementInit;

  //   // Load the script
  //   loadGoogleTranslateScript();

  //   // Cleanup function to remove the script if needed
  //   return () => {
  //     const script = document.querySelector(
  //       'script[src*="translate.google.com"]'
  //     );
  //     if (script) {
  //       document.body.removeChild(script);
  //     }
  //   };
  // }, [bussinessDetailsDB]);
  // //End of Experimental code for google translate
  // const [openSendQuery, setOpenSendQuery] = useState(false);
  // const [sendQueryText, setSendQueryText] = useState("");
  // const [sendQueryPhone, setSendQueryPhone] = useState("");
  // const [sendQueryName, setSendQueryName] = useState("");

  // const sendQuery = async () => {
  //   try {
  //     const text = sendQueryText.trim();
  //     const phone = sendQueryPhone.trim();
  //     if (!text.trim() || text.length < 5) {
  //       setAlert({ message: "Please enter a valid query", open: true });
  //       return;
  //     }
  //     if (!phone.length && phone.length !== 10) {
  //       setAlert({ message: "Please enter a valid phone", open: true });
  //       return;
  //     }
  //     let merchantPhone = "";
  //     for (const number of bussinessDetailsDB.contactPersonPhoneNums) {
  //       if (isMobileNumber(number)) {
  //         merchantPhone = number;
  //       }
  //     }
  //     const res = await axios.post(
  //       `${IDIGIZEN_BACKEND_URL}/${sendQueryForProductInfo}`,
  //       {
  //         businessId: bussinessDetailsDB.id,
  //         userId: id,
  //         message: sendQueryText,
  //         phoneNumber: sendQueryPhone,
  //         name: sendQueryName,
  //         merchantPhone,
  //       },
  //       {
  //         headers: { Authorization: API_SECURE_KEY },
  //         params: {
  //           storeId: bussinessDetailsDB.id,
  //           userId: id,
  //         },
  //       }
  //     );
  //     setAlert({
  //       header: "Thank You!",
  //       message: `Your query has been sent to ${bussinessDetailsDB.name}. We will get back to you shortly.`,
  //       open: true,
  //     });
  //     setOpenSendQuery(false);
  //   } catch (e) {
  //     presentToast(e);
  //   }
  // };

  // const sendCustomerQueryJsx = (
  //   <IonModal
  //     className="bhp-send-query-modal"
  //     isOpen={openSendQuery}
  //     onDidDismiss={() => {
  //       setOpenSendQuery(false);
  //       setSendQueryName("");
  //       setSendQueryPhone("");
  //       setSendQueryText("");
  //     }}
  //   >
  //     <BhpThemeHeaderWithBack
  //       title="Request Product"
  //       onBack={() => {
  //         setOpenSendQuery(false);
  //       }}
  //     />
  //     <IonContent>
  //       <IonItem>
  //         <IonLabel position="stacked" color={"primary"}>
  //           Your Query
  //           <span style={{ color: "var(--ion-color-secondary)" }}>*</span>
  //         </IonLabel>
  //         <IonTextarea
  //           autoGrow={true}
  //           value={sendQueryText}
  //           onIonChange={(e) => {
  //             setSendQueryText(e.detail.value);
  //           }}
  //           placeholder="Enter Query Here"
  //           rows={5}
  //         />
  //       </IonItem>
  //     </IonContent>
  //     <IonFooter>
  //       <div
  //         style={{
  //           padding: "10px",
  //           textAlign: "center",
  //           borderTop: "1px solid var(--ion-color-medium)",
  //           borderBottom: "1px solid var(--ion-color-medium)",
  //           color: "var(--ion-color-dark)",
  //           background: "lightgray",
  //         }}
  //       >
  //         Your Details
  //       </div>
  //       <IonItem>
  //         <IonLabel position="stacked" color={"primary"}>
  //           Phone (10 digit)
  //           <span style={{ color: "var(--ion-color-secondary)" }}>*</span>
  //         </IonLabel>
  //         <IonInput
  //           value={sendQueryPhone}
  //           maxlength={10}
  //           onIonChange={(e) => {
  //             setSendQueryPhone(e.detail.value);
  //           }}
  //           placeholder="Enter Phone Here"
  //         />
  //       </IonItem>
  //       <IonItem>
  //         <IonLabel position="stacked" color={"primary"}>
  //           Name{" "}
  //           <span
  //             style={{
  //               paddingLeft: "5px",
  //               color: "var(--ion-color-medium)",
  //             }}
  //           >
  //             (Optional)
  //           </span>
  //         </IonLabel>
  //         <IonInput
  //           value={sendQueryName}
  //           onIonChange={(e) => {
  //             setSendQueryName(e.detail.value);
  //           }}
  //           placeholder="Enter Name Here"
  //         />
  //       </IonItem>
  //       <div style={{ padding: "5px" }}>
  //         <IonButton color={"primary"} expand="block" onClick={sendQuery}>
  //           Send Query
  //         </IonButton>
  //       </div>
  //     </IonFooter>
  //   </IonModal>
  // );

  const logoutRedirectUrl = useMemo(() => {
    // Get the current URL
    let currentUrl = window.location.href;

    // Check if the URL already has query parameters
    if (currentUrl.includes("?")) {
      // If query parameters exist, append with an '&'
      currentUrl += "&signIn=1";
    } else {
      // If no query parameters exist, add the first one with a '?'
      currentUrl += "?signIn=1";
    }

    // Update the URL (optional: replace `window.location.href` to navigate)
    console.log(currentUrl); // Prints the updated URL
    return currentUrl;
  }, [window.location.href]);

  // const handleRefresh = (event: CustomEvent) => {
  //   // Trigger a full browser refresh
  //   window.location.reload();

  //   // Complete the refresher animation after the page reloads
  //   event.detail.complete();
  // };

  // const [openSendQuery, set]
  const isPageAdmin =
    !!id &&
    (schoolId == bussinessDetailsDB.id ||
      superEditor ||
      bussinessDetailsDB?.subType?.startsWith("BNI-CHAPTER"));

  // console.log("Highlighted product ", highlightProduct);

  const [faq, setFaq] = useState<
    { id: number; question: string; answer: string }[]
  >([]);

  const campaignAdData = useMemo(() => {
    if (!campaign.id) return [];
    return advertisingBannerData.filter((ad) => ad.campaignId === campaign.id);
  }, [advertisingBannerData, campaign.id]);

  // useEffect(() => {
  //   const fetchFaq = async () => {
  //     try {
  //       const res = await axios.get(`${IDIGIZEN_BACKEND_URL}/${getFaqDB}`, {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: API_SECURE_KEY,
  //         },
  //         params: {
  //           entityId: bussinessDetailsDB.id,
  //           isMarket: bussinessDetailsDB.isMarket,
  //         },
  //       });
  //       setFaq(res.data.data.data);
  //     } catch (err) {
  //       presentToast(err);
  //     }
  //   };
  //   if (!!bussinessDetailsDB.id) fetchFaq();
  // }, [bussinessDetailsDB.id]);

  return (
    <>
      {/* <TranslateModal openModal={true} /> */}
      <Suspense fallback={<LazyLoaderSpinner />}>
        {!!subscribePrompt && (
          <BhpSubscribeModal
            domain={companyNameResolved}
            popoverPromo={subscribePrompt}
            openTermsAndConditions={() => {
              setOpenTerms({ open: true, disableButtons: true });
            }}
            isOpen={!!subscribePrompt}
            onDidDismiss={() => {
              setSubscribePrompt(undefined);
            }}
            openPrompt={(inp) => {
              setAlert({
                message: inp,
                open: true,
              });
            }}
          />
        )}
      </Suspense>
      <Suspense fallback={<LazyLoaderSpinner />}>
        {createBizCard && (
          <BhpCreateBizCardModal
            isOpen={createBizCard}
            onDidDismiss={closeCreateBizCard}
          />
        )}
      </Suspense>
      <Suspense fallback={<LazyLoaderSpinner />}>
        {openFeedback && (
          <BhpTestimonialModal
            vypzeePage={vypzeePage}
            id={bussinessDetailsDB.id}
            isMarket={bussinessDetailsDB.isMarket}
            marketType={bussinessDetailsDB.marketType}
            name={bussinessDetailsDB.name}
            reviewNotAutoApprove={bussinessDetailsDB.reviewNotAutoApprove}
            onDismiss={(recordId) => {
              feedbackClose();
              let additionalReviewPath =
                bussinessDetailsDB?.additionalReviewPath;
              setTimeout(() => {
                if (additionalReviewPath && recordId) {
                  //replace the recordId as it is encoded as a searchparam
                  additionalReviewPath = additionalReviewPath.replaceAll(
                    "%recordId%",
                    `${recordId}`
                  );
                  console.log(
                    `Assigning : ${additionalReviewPath} to window.location.assign`
                  );
                  window.location.assign(additionalReviewPath);
                }
              }, 500);
            }}
            open={openFeedback}
            onDidReviewDone={() => {
              const params = getParamsFromSearchString(location.search);
              if (params.generateDiscount) {
                setDiscountModal(true);
                return;
              }
            }}
          />
        )}
      </Suspense>
      <Suspense fallback={<LazyLoaderSpinner />}>
        {openTerms && (
          <TermsAndConditions
            merchantPhone={merchantPhone}
            merchantMode={termsMerchantMode}
            shopDomain={bussinessDetailsDB.domainName}
            open={openTerms.open}
            disableButtons={openTerms.disableButtons}
            onDidDismiss={() => {
              setOpenTerms({ open: false });
            }}
          />
        )}
      </Suspense>
      <Suspense fallback={<LazyLoaderSpinner />}>
        {residentDetails.open && residentCardJsx}
      </Suspense>
      {/* {sendCustomerQueryJsx} */}
      <Suspense fallback={<LazyLoaderSpinner />}>
        {changePassword && changePasswordJsx}
      </Suspense>
      <Suspense fallback={<LazyLoaderSpinner />}>
        {promptContactSave && promptToSaveJsx}
      </Suspense>
      <Suspense fallback={<LazyLoaderSpinner />}>
        {showAllPromos && (
          <BhpShowAllPromoModal
            title={!showAllPromosTrends ? campaign.campaignName : undefined}
            openTrendsExpand={(id) => {
              openDetails({ id: id, category: "", mode: "AD" });
            }}
            logoImgData={logoImgData}
            theme={theme}
            expandAdImage={(filename) => {
              expandingImgOpen({
                fileName: filename,
                index: 0,
                open: true,
              });
            }}
            allShops={prodCategories}
            bannerButtonClick={bannerButtonClick}
            customerDetails={customerDetails}
            logoImg={logoImg}
            open={showAllPromos}
            onDismiss={() => {
              closeShowAllPromo();
            }}
            advertisingBannerData={
              !showAllPromosTrends ? campaignAdData : advertisingBannerData
              // advertisingBannerData
            }
            bussinessDetailsDB={bussinessDetailsDB}
            floating={!bussinessDetailsDB.isMarket}
            advanceCustomization={advanceCustomization}
          />
        )}
      </Suspense>
      <Suspense fallback={<LazyLoaderSpinner />}>
        {alert.open && (
          <AlertWithoutExec openAlert={alert} setOpenAlert={setAlert} />
        )}
        {openExpandImg.open && (
          <ViewImage
            modalControls={openExpandImg}
            onDismissModal={() => {
              expandingImgClose();
            }}
          />
        )}
        {!!openDetailsId && (
          <BhpViewExpandedProd
            direction={(
              shopId: string,
              shopName: string,
              location: { obj?: PositionType; url?: string },
              notes: string
            ) => {
              hotKeyFunctions["combinedDirection"]({
                location: location,
                shopId: shopId,
                shopName: shopName,
                notes: notes,
              });
            }}
            onAdQuery={(ad) => {
              setAdQuery(ad);
              handleCheckoutOpen();
            }}
            adData={displayAdData}
            cartItems={cartItems}
            addRemoveCartCallback={handleChildAddToCart}
            businessDetailsDb={bussinessDetailsDB}
            businessName={bussinessDetailsDB.name}
            bhpCategories={prodCategories}
            onContact={(msg) => {
              whatsappMessage(
                msg,
                bussinessDetailsDB.contactPersonPhoneNums[0]
              );
            }}
            onDismiss={() => {
              closeDetails();
            }}
            openId={openDetailsId?.id}
            openCategory={openDetailsId?.category}
            mode={openDetailsId.mode}
            advanceCustomization={advanceCustomization}
          />
        )}
      </Suspense>
      {/* <IonPopover
        isOpen={logonOpen}
        onDidDismiss={() => {
          setLogonOpen(false);
        }}
      >
        <IonHeader>
          <IonToolbar>
            <IonAvatar>
              <IonImg src={getLogo(true)} />
            </IonAvatar>
            <IonButtons slot="end">
              <IonButton size="small" fill="clear">
                Login
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonItem>
            <IonLabel color={"primary"} position="stacked">
              Phone / Email
            </IonLabel>
            <IonInput placeholder="10 digit phone / email" />
          </IonItem>
          <IonItem>
            <IonLabel color={"primary"} position="stacked">
              Password
            </IonLabel>
            <IonInput />
          </IonItem>
        </IonContent>
        <IonFooter>
          <IonButton expand="block">Login</IonButton>
        </IonFooter>
      </IonPopover> */}
      {/* {menuHamburgerJsx} */}
      {/* <Suspense fallback={<LazyLoaderSpinner />}>
        {openSearchPopup && openSearchPopupJsx}
      </Suspense> */}
      {/* <Suspense fallback={<LazyLoaderSpinner />}>
        {couponIsOpen && couponPromoJsx}
      </Suspense> */}
      {/* {VcDownloadAlertJsx} */}
      {!!openMenubar && menuBarPopoverJsx}
      {socialMediaJsx}
      <Suspense fallback={<LazyLoaderSpinner />}>
        {!!openQr && (
          <OpenQrCode
            logoImg={logoImgData}
            businessDetails={bussinessDetailsDB}
            open={openQr}
            onDismiss={qrClose}
            downloadQr={downloadShopQRExec}
          />
        )}
      </Suspense>
      <Suspense fallback={<LazyLoaderSpinner />}>
        {promptContactSave && saveBusinessCardNotesJsx}
      </Suspense>
      {/* {couponDownloadThankyouJsx} */}
      <IonPage className="bussiness-home-page-root" id="main-content">
        {searchModal.open && searchModalJsx}
        <Suspense fallback={<LazyLoaderSpinner />}>
          {openAddItem.open && addToCartPopoverJsx}
          {/* {createLoginTypeModalJsx} */}
        </Suspense>

        {/* {!!isInternal && (
          <IonHeader>
            <LandingPageHeader name={userInfo.name} />
          </IonHeader>
        )} */}
        {!!bussinessDetailsDB.id &&
          ((!pageHeaderInView && userPage) ||
            (makeSubheaderVisible && !userPage)) && (
            <IonHeader>{subheaderOnScrollJsx}</IonHeader>
          )}

        <IonContent
          className={"bussiness-home-page-content"}
          scrollEvents={true}
          // onIonScrollStart={handleScrollStart}
          // onIonScroll={handleScrollOffer}
          // onIonScrollEnd={handleScrollEnd}
          ref={ionContentRefScroll}
        >
          {/* <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
            <IonRefresherContent />
          </IonRefresher> */}
          <GlobalPageRefresher />

          {loadingCompany && (
            <div
              style={{
                height: "100%",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <IonSpinner color={"dark"} />
            </div>
          )}
          <div style={{ display: loadingCompany ? "none" : undefined }}>
            {/* {subheaderOnScrollJsx} */}
            {bussinessDetailsDB.isMarket &&
              bussinessDetailsDB.marketType === "USER" && (
                <Suspense fallback={<LazyLoaderSpinner />}>
                  <BussinessHomeHeader
                    openQR={() => {
                      qrOpen(true);
                    }}
                    verifyMode={verifyMode}
                    editMode={editMode}
                    styleData={styleData}
                    categoryImgFileName={
                      bussinessDetailsDB?.categoryImg?.fileName
                    }
                    logoImg={bussinessDetailsDB.logo}
                    logoImgData={logoImgData}
                    name={marketNotFound ? "VypZee" : bussinessDetailsDB.name}
                    bussinessDetailsDB={bussinessDetailsDB}
                    onMenuClick={setOpenMenubar.bind(this, true)}
                    onSearchClick={() => {
                      openSearchModal({ open: true, category: "" });
                    }}
                    hotKeys={hotKeys}
                    clickHotKey={(funcName: string) => {
                      hotKeyFunctions[funcName]();
                    }}
                    nameVerified={checkList?.shopName}
                    changeNameVerified={(val) => {
                      updateChecklist("shopName", val);
                    }}
                  />
                </Suspense>
              )}
            {!!(
              vypzeePage ||
              !(
                bussinessDetailsDB.isMarket &&
                bussinessDetailsDB.marketType === "USER"
              )
            ) && (
              <BhpFirstFoldPage
                visitCount={visitCounter}
                openQR={() => {
                  qrOpen(true);
                }}
                openSearch={() => {
                  hotKeyFunctions["openSearch"]();
                }}
                footerOverride={styleData?.showVypzeeFooterOverride}
                bannerCtaBtnDisable={styleData.bannerCtaBtnDisable === "true"}
                marketCluster={
                  bussinessDetailsDB.isMarket &&
                  bussinessDetailsDB.marketType === "MARKET_CLUSTER"
                }
                ctaBtnBg={styleData.ctaBtnBg}
                ctaBtnColor={styleData.ctaBtnColor}
                hideFooter={styleData.noBannerSubtext === "true"}
                headerFontColor={styleData.headerFontColor}
                logoMode={styleData.headerLogoMode === "true"}
                setSubheaderVisible={(val) => {
                  setMakeSubheaderVisible(val);
                }}
                vypzeePage={vypzeePage}
                businessDetails={bussinessDetailsDB}
                logoImgData={logoImgData}
                onClickHeaderCTA={() => {
                  if (bussinessDetailsDB.isMarket) {
                    if (!vypzeePage) hotKeyFunctions["openVypzee"]();
                    else hotKeyFunctions["aboutUs"]();
                  } else {
                    hotKeyFunctions["backToMarket"]();
                  }
                }}
                disableHeaderCta={styleData.disableHeaderCta === "true"}
                onMenuClick={setOpenMenubar.bind(this, true)}
                onSearchClick={(val) => {
                  openSearchModal({
                    category: "",
                    open: true,
                    fullMarketDir: true,
                    searchText: val,
                  });
                }}
                onPrimaryButtonClick={() => {
                  hotKeyFunctions["openSearch"]();
                }}
                onSecondaryButtonClick={() => {
                  if (
                    vypzeePage ||
                    (bussinessDetailsDB.isMarket &&
                      bussinessDetailsDB.marketType === "MARKET_CLUSTER")
                  ) {
                    // setAlert({
                    //   message:
                    //     "Vypzee is in Delhi NCR for now. Stay tuned for more Cities for come",
                    //   open: true,
                    //   header: "Coming Soon!",
                    // });
                    hotKeyFunctions["openAllTrends"]();
                  } else {
                    hotKeyFunctions["combinedDirection"]();
                  }
                }}
                onShare={() => {
                  hotKeyFunctions["share"]();
                }}
                adData={campaignAdData}
                campaignData={campaign}
                openAllCampaignPromo={() => {
                  hotKeyFunctions["openAllTrends"]({
                    campaign: campaign.campaignName,
                  });
                }}
              />
            )}
            <div ref={pageHeaderRef}> </div>
            <Suspense fallback={<LazyLoaderSpinner />}>
              {!!card && privilegeCardJsx}
            </Suspense>
            {showBizCard && bizCardJsx}
            {!loadingCompany &&
              styleData.showFloorSelector === "true" &&
              bussinessDetailsDB.isMarket && <BhpFloorSelector />}

            {loadingProducts && !loadingCompany && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingTop: "10px",
                }}
              >
                <IonSpinner color={"dark"} />
                <div
                  style={{
                    paddingLeft: "10px",
                    color: "black",
                    fontSize: "1rem",
                    fontWeight: "bold",
                  }}
                >{`Loading ${
                  bussinessDetailsDB.isMarket ? "Directory" : ""
                } ...`}</div>
              </div>
            )}
            {/* <Suspense fallback={<LazyLoaderSpinner />}>
              {bussinessDetailsDB.isMarket &&
                bussinessDetailsDB.marketType === "MARKET" &&
                marketAboutSectionJsx}
            </Suspense> */}
            <Suspense fallback={<LazyLoaderSpinner />}>
              {!bussinessDetailsDB.isMarket && storeAboutSectionJsx}
            </Suspense>
            {(!!displayAdData.length || editMode || openAdMode) &&
              !bussinessDetailsDB.subType?.startsWith("BNI-CHAPTER") &&
              promoSectionJsx}
            {bussinessDetailsDB.isMarket &&
              bussinessDetailsDB.marketType === "MARKET" &&
              !!bussinessDetailsDB?.shortDescription &&
              marketAboutSectionJsx}

            {/* {(!!trendsData.length || (editMode && superEditor)) &&
              trendsSectionJsx} */}
            <Suspense fallback={<LazyLoaderSpinner />}>
              {showShopCatList &&
                styleData.headerStyle === "CARD_ICON" &&
                bussinessDetailsDB.isMarket &&
                !category &&
                shopCatDisplayJsx}
            </Suspense>
            <Suspense fallback={<LazyLoaderSpinner />}>
              {(showShopCatList || (editMode && superEditor)) &&
                !(
                  styleData.headerStyle === "CARD_ICON" &&
                  bussinessDetailsDB.isMarket
                ) &&
                shopCatDisplayJsx}
            </Suspense>
            <Suspense fallback={<LazyLoaderSpinner />}>
              {!!openOnlineHealth && onlineHealthJsx}
              {!!highlightProduct.length && !category && (
                <BhpHighlightProduct
                  vypzeePage={vypzeePage}
                  businessDetails={bussinessDetailsDB}
                  highlightProducts={highlightProduct}
                  productCategories={prodCategories}
                  advanceCustomization={advanceCustomization}
                />
              )}
              {!!openDashboard && dashboardJsx}
            </Suspense>

            <Suspense fallback={<LazyLoaderSpinner />}>
              {!!selectedShop && selectedShopJsx}
            </Suspense>
            {/* {!bussinessDetailsDB.isMarket &&
              !prodCategories.length &&
              !editMode && (
              )} */}
            <Suspense fallback={<LazyLoaderSpinner />}>
              {bussinessDetailsDB.isMarket &&
                bussinessDetailsDB.marketType === "RWA" &&
                !styleData?.dontShowBanner && (
                  <BhpRetargetBanner
                    hasProductsOrBusinesses={!!prodCategories.length}
                    isMarket={bussinessDetailsDB.isMarket}
                    subscriptionType={bussinessDetailsDB.subscriptionType}
                    marketName={bussinessDetailsDB.marketName}
                    marketDomain={bussinessDetailsDB.marketDomain}
                    marketType={bussinessDetailsDB.marketType}
                    marketSubType={bussinessDetailsDB.subType}
                    seoUrlDetails={bussinessDetailsDB.seoUrlDetails}
                  />
                )}
            </Suspense>

            <Suspense fallback={<LazyLoaderSpinner />}>
              {editMode && (
                <BusinessHomePageSection
                  subHeaderText={
                    bussinessDetailsDB.isMarket
                      ? "Add/ Edit Shop"
                      : bussinessDetailsDB?.subType?.startsWith("BNI-CHAPTER")
                      ? "Add Give / Ask"
                      : "Add New Product"
                  }
                >
                  <div style={{ padding: "5px" }}>
                    <IonButton
                      expand="block"
                      color={"tertiary"}
                      fill="solid"
                      onClick={() => {
                        let { schoolId } = getSessionDetails();
                        if (schoolId != bussinessDetailsDB.id && !superEditor) {
                          console.log(
                            `schoolId = ${schoolId} :: ${bussinessDetailsDB.id}`
                          );
                          present({
                            message:
                              "You can only edit your own Gives/Asks 123",
                            position: "middle",
                            duration: 1500,
                          });
                          return;
                        }
                        const url = bussinessDetailsDB.isMarket
                          ? bhpEditLinks.addShop
                          : bussinessDetailsDB.bhpEditLinks.addProduct;
                        history.push(
                          url.replace("%SCHOOL_ID%", bussinessDetailsDB.id)
                        );
                      }}
                    >
                      + Add
                    </IonButton>
                    {bussinessDetailsDB.isMarket &&
                      bussinessDetailsDB.marketType === "MARKET" && (
                        <IonButton
                          expand="block"
                          color={"tertiary"}
                          fill="outline"
                          onClick={() => {
                            openSearchModal({
                              open: true,
                            });
                          }}
                        >
                          <IonIcon icon={pencil} slot="start" />
                          Search & Edit Shop Details
                        </IonButton>
                      )}
                  </div>
                </BusinessHomePageSection>
              )}
              {!loadingCompany && !loadingProducts && showProdShowList && (
                // getProductShopCatDisplayJsx("", "", false, "59px")
                <BhpSearchModal
                  pageLocation={"MAIN"}
                  expandDetails={(id, category) => {
                    openDetails({ id, category, mode: "PROD" });
                  }}
                  logoImgData={logoImgData}
                  buttonOverride={
                    bussinessDetailsDB.isMarket &&
                    bussinessDetailsDB.marketType === "RWA"
                      ? {
                          onClick: openResidentDetails,
                          name: "Details",
                        }
                      : undefined
                  }
                  listModeListing={bussinessDetailsDB.listModeListing}
                  onAddFreeTextOrder={() => {
                    setOpenAddItem({
                      open: true,
                      count: 1,
                      details: "",
                      item: search,
                      img: { id: "", name: "", type: undefined },
                      addMode: true,
                      nameEditable: true,
                      qty: "",
                    });
                    // setSearch("");
                  }}
                  hasProducts={!!prodCategories.length}
                  addOrderItemized={addOrderItemized}
                  bussinessDetailsDB={bussinessDetailsDB}
                  controls={{ fetchMode: false }}
                  prodCategories={prodCategories}
                  addItemizedFromText={addItemizedFromText}
                  cartItems={cartItems}
                  catFilter=""
                  expandingImgOpen={expandingImgOpen}
                  handleCheckoutOpen={handleCheckoutOpen}
                  handleChildAddToCart={handleChildAddToCart}
                  handleChildvariant={handleChildvariant}
                  handleOpenCloseCard={handleOpenCloseCard}
                  idAdder=""
                  vypzeePage={vypzeePage}
                  search={search}
                  onlineOnly={false}
                  subheaderTopOffsetPx={subheaderTopOffset}
                  textCartItems={textCartItems}
                  advanceCustomization={advanceCustomization}
                />
              )}
            </Suspense>
            {!bussinessDetailsDB.isMarket && (
              <BusinessHomePageSection
                subHeaderText="Request Product Info"
                headingLine={true}
              >
                <div style={{ padding: "10px", paddingTop: 0 }}>
                  <div
                    style={{
                      paddingBottom: "10px",
                      paddingTop: "5px",
                      fontSize: prodCategories.length ? "0.8rem" : "1.2rem",
                      // textAlign: "center",
                      color: prodCategories.length
                        ? "var(--ion-color-bhp-font-color)"
                        : "var(--ion-color-secondary)",
                    }}
                  >
                    {prodCategories.length
                      ? "Didn't find what you are looking for?"
                      : "No Products Listed!"}
                  </div>
                  <IonButton
                    expand="block"
                    color={"dark"}
                    onClick={() => {
                      // setAlert({ message: "Comming Soon!", open: true });
                      // setOpenSendQuery(true);
                      handleCheckoutOpen();
                    }}
                  >
                    + Add Product Query
                  </IonButton>
                </div>
              </BusinessHomePageSection>
            )}
            {/* <Suspense fallback={<LazyLoaderSpinner />}>
              {bussinessDetailsDB.isMarket &&
                bussinessDetailsDB.marketType === "MARKET" &&
                marketCategoryHighlightsJsx}
            </Suspense> */}
            {/* <Suspense fallback={<LazyLoaderSpinner />}>
            {bussinessDetailsDB.isMarket &&
              bussinessDetailsDB.marketType === "MARKET" &&
              hotKeysRemainingJsx}
          </Suspense> */}
            <Suspense fallback={<LazyLoaderSpinner />}>
              {bussinessDetailsDB.isMarket &&
                bussinessDetailsDB.marketType === "MARKET" &&
                marketDirectoryHeaderJsx}
              {bussinessDetailsDB.isMarket &&
                bussinessDetailsDB.marketType === "MARKET" &&
                !category &&
                marketCategoryRestJsx}
              {bussinessDetailsDB.isMarket &&
                bussinessDetailsDB.marketType === "MARKET" &&
                !!category && (
                  <div style={{ padding: "5px" }}>
                    <IonButton
                      expand="block"
                      color={"secondary"}
                      onClick={() => {
                        window.location.assign(
                          getSeoUrl(bussinessDetailsDB.seoUrlDetails)
                        );
                      }}
                    >
                      Explore Full Directory{" "}
                      <IonIcon icon={arrowForward} slot="end" />
                    </IonButton>
                  </div>
                )}
            </Suspense>
            <Suspense fallback={<LazyLoaderSpinner />}>
              {(!bussinessDetailsDB.isMarket ||
                (bussinessDetailsDB.isMarket &&
                  bussinessDetailsDB.marketType === "USER")) &&
                styleData?.dontShowBanner === "false" && (
                  <BhpRetargetBanner
                    hasProductsOrBusinesses={!!prodCategories.length}
                    isMarket={bussinessDetailsDB.isMarket}
                    subscriptionType={bussinessDetailsDB.subscriptionType}
                    marketName={bussinessDetailsDB.marketName}
                    marketDomain={bussinessDetailsDB.marketDomain}
                    marketType={bussinessDetailsDB.marketType}
                    seoUrlDetails={bussinessDetailsDB.seoUrlDetails}
                  />
                )}
            </Suspense>
            <Suspense fallback={<LazyLoaderSpinner />}>
              {(!!testimonial.length || editMode) && (
                <Testimonial
                  isSuperEditor={superEditor}
                  ratings={testimonial}
                  reviewScore={bussinessDetailsDB.reviewScore}
                  id={bussinessDetailsDB.id}
                  isMarket={bussinessDetailsDB.isMarket}
                />
              )}
            </Suspense>
            <Suspense fallback={<LazyLoaderSpinner />}>
              {bussinessDetailsDB.isMarket &&
                bussinessDetailsDB.marketType === "RWA" &&
                bussinessDetailsDB.subType !== "BNI-CHAPTER" && (
                  <BhpRwaOfficeBearers />
                )}
            </Suspense>
            {!loadingProducts && (
              <>
                {faq.length !== 0 && <BhpFaq faq={faq} />}
                <div id="bhp-footer-id">
                  <ProductPageFooter
                    updateChecklist={updateChecklist}
                    checkList={{
                      shopName: checkList.shopName,
                      shopAddress: checkList.shopAddress,
                      shopDealsIn: checkList.shopDealsIn,
                      shopPhone: checkList.shopPhone,
                    }}
                    verifyMode={verifyMode}
                    directionExec={() => {
                      hotKeyFunctions["combinedDirection"]();
                    }}
                    businessDetails={bussinessDetailsDB}
                    website={bussinessDetailsDB.website}
                    companyName={companyNameResolved}
                    deliveryNotes={bussinessDetailsDB.deliveryNotes}
                    vcardMode={false}
                    name={bussinessDetailsDB.name}
                    tagline={bussinessDetailsDB.tagline}
                    description={bussinessDetailsDB.description}
                    vypzeeMode={marketNotFound}
                    images={
                      bussinessDetailsDB.subscriptionType !== "VCARD"
                        ? bussinessDetailsDB.images
                        : undefined
                    }
                    socialMedia={bussinessDetailsDB.socialMedia}
                    openImageArray={
                      bussinessDetailsDB.images && !marketNotFound
                        ? () => {
                            expandingImgOpen({
                              fileName: bussinessDetailsDB.images,
                              index: 0,
                              open: true,
                            });
                          }
                        : undefined
                    }
                    phones={bussinessDetailsDB.contactPersonPhoneNums}
                    email={bussinessDetailsDB.contactPersonEmail}
                    address={bussinessDetailsDB.address}
                    vCardPromo={bussinessDetailsDB.vCardPromo}
                  />
                </div>

                {styleData.showVypzeeFooter === "true" && (
                  <VypzeeFooter
                    marketDomain={bussinessDetailsDB.marketDomain}
                    getParamsUrlForHome={getParamsUrlForHome}
                  />
                )}

                {vypzeeContactMeJsx}
              </>
            )}
          </div>
          {!!prodCategories.length &&
            !pageHeaderInView &&
            !(
              bussinessDetailsDB.isMarket &&
              bussinessDetailsDB.marketType === "USER"
            ) &&
            fabButtonsJsx}
        </IonContent>
        <IonFooter>
          {!editMode && (
            <div
              style={{
                padding: "5px",
                textAlign: "center",
                color: "var(--ion-color-medium)",
                fontSize: "0.7rem",
              }}
              onClick={() => {
                setOpenTerms({ open: true });
              }}
            >
              View Terms & Conditions
            </div>
          )}
          {(!!bussinessDetailsDB.id || noPageFound) &&
            !editMode &&
            !bussinessDetailsDB?.subType?.startsWith("BNI-CHAPTER") && (
              <div style={{ padding: "5px", display: "flex" }}>
                <div style={{ width: isPageAdmin ? "70%" : "100%" }}>
                  <IonButton
                    // size="small"
                    color={"dark"}
                    expand="block"
                    onClick={() => {
                      if (vypzeePage) {
                        window.location.assign(
                          "https://vypzee.com/shopping-list"
                        );
                        return;
                      }
                      reviewStore();
                    }}
                  >
                    {!!vypzeePage && <>Build Your Family Shopping List</>}
                    {!vypzeePage && (
                      <>
                        Review{" "}
                        {bussinessDetailsDB.isMarket ? "Market" : "Store"}
                      </>
                    )}
                  </IonButton>
                </div>
                {isPageAdmin && (
                  <>
                    <div style={{ width: "15%" }}>
                      <IonButton
                        expand="block"
                        color={!editMode ? "tertiary" : "secondary"}
                        fill={!editMode ? "solid" : "clear"}
                        onClick={() => {
                          let { schoolId } = getSessionDetails();
                          if (!schoolId && !superEditor) {
                            present({
                              message: "Please login to edit.",
                              position: "middle",
                              duration: 1500,
                            });
                          }
                          if (
                            schoolId == bussinessDetailsDB.id ||
                            superEditor
                          ) {
                            dispatch(
                              loginInfoActions.updateBhpEditMode({
                                loaded: !editMode,
                              })
                            );
                          } else {
                            present({
                              message: "You can only edit your own store",
                              position: "middle",
                              duration: 1500,
                            });
                          }
                        }}
                      >
                        <IonIcon icon={pencil} />
                      </IonButton>
                    </div>
                    <div style={{ width: "15%" }}>
                      <IonButton
                        expand="block"
                        color={
                          checkList?.status === "PHASE2-COMPLETE"
                            ? "success"
                            : checkList?.status === "REJECTED-PRODUCTS" ||
                              checkList?.status === "REJECTED-VERIFICATION" ||
                              checkList?.status === "REJECTED-QR"
                            ? "danger"
                            : "medium"
                        }
                        fill={!editMode ? "solid" : "clear"}
                        onClick={() => {
                          if (role === "SHOP_OWNER") {
                            dashboardOpen(true);
                          } else {
                            setOpenNotes(true);
                            if (checkList.id === -1) {
                              updateChecklist("shopName", checkList.shopName);
                            }
                          }
                        }}
                      >
                        <IonIcon
                          icon={role === "SHOP_OWNER" ? analytics : hammer}
                        />
                      </IonButton>
                    </div>
                  </>
                )}
              </div>
            )}
          {/* {!bussinessDetailsDB.isMarket && superEditor && (
            <div style={{ display: "flex" }}>
              <div style={{ width: "50%" }}>
                <IonButton
                  expand="block"
                  fill="solid"
                  color={
                    shopVerified ? "success" : verifyMode ? "warning" : "medium"
                  }
                  onClick={() => {
                    if (shopVerified) {
                      setChecklistNotes((val) => !val);
                      return;
                    }
                    dispatch(
                      loginInfoActions.updateBhpVerify({
                        loaded: !verifyMode,
                      })
                    );
                  }}
                >
                  {shopVerified
                    ? "Verified - Add/ Edit Notes"
                    : verifyMode
                    ? "Verifing"
                    : "Verify"}
                </IonButton>
              </div>
              <div style={{ width: "50%" }}>
                <IonButton
                  expand="block"
                  fill="solid"
                  color={"secondary"}
                  onClick={downloadShopQRExec}
                >
                  Download QR
                </IonButton>
              </div>
            </div>
          )} */}
          {!!id &&
            superEditor &&
            role !== "MARKETADMIN" &&
            bussinessDetailsDB?.isMarket && (
              <IonButton
                expand="block"
                color={"secondary"}
                onClick={async () => {
                  const res = await axios.get(
                    `${IDIGIZEN_BACKEND_URL}/${assignBhpStockImagesDB}`,
                    {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: API_SECURE_KEY,
                      },
                      params: {
                        marketId: bussinessDetailsDB.id,
                      },
                    }
                  );
                  stringToast("Saved");
                }}
              >
                Assign Stock Img
              </IonButton>
            )}
          <Suspense fallback={<LazyLoaderSpinner />}>
            {!!isPageAdmin && (
              <BhpAdminShopChecklist
                openDashboard={() => {
                  dashboardOpen(true);
                  setOpenNotes(false);
                }}
                openHealthEval={() => {
                  setOpenNotes(false);
                  onlineHealthOpen({
                    mode: "ONLINE_HEALTH",
                    open: true,
                  });
                }}
                open={openNotes}
                onDismiss={() => {
                  setOpenNotes(false);
                }}
                refreshChecklist={() => {
                  setRefreshChecklist((val) => !val);
                }}
                addNotes={checklistNotes}
                businessDetails={bussinessDetailsDB}
                editMode={editMode}
                hasAds={!!advertisingBannerData.length}
                products={prodCategories}
                hasImg={!!logoImgData}
                checkList={checkList}
                updateChecklist={updateChecklist}
              />
            )}
          </Suspense>
          {!!id &&
            (((schoolId == bussinessDetailsDB.id || superEditor) &&
              !!editMode) ||
              bussinessDetailsDB?.subType?.startsWith("BNI-CHAPTER")) && (
              <IonButton
                expand="block"
                color={!editMode ? "primary" : "secondary"}
                fill={!editMode ? "solid" : "clear"}
                onClick={() => {
                  let { schoolId } = getSessionDetails();
                  if (!schoolId && !superEditor) {
                    present({
                      message: "Please login to edit.",
                      position: "middle",
                      duration: 1500,
                    });
                  }

                  if (bussinessDetailsDB?.subType === "BNI-CHAPTER") {
                    //on the chapter page on click trigger member specific Give/Ask
                    history.push(
                      bussinessDetailsDB.bhpEditLinks.addProduct.replace(
                        "%SCHOOL_ID%",
                        schoolId
                      )
                    );
                  } else {
                    if (schoolId == bussinessDetailsDB.id || superEditor) {
                      dispatch(
                        loginInfoActions.updateBhpEditMode({
                          loaded: !editMode,
                        })
                      );
                    } else {
                      present({
                        message: "You can only edit your own store",
                        position: "middle",
                        duration: 1500,
                      });
                    }
                  }
                }}
              >
                {bussinessDetailsDB?.subType === "BNI-CHAPTER" && (
                  <> Add Give / Ask</>
                )}
                {bussinessDetailsDB?.subType !== "BNI-CHAPTER" && !editMode && (
                  <>Edit Page</>
                )}
                {!!editMode &&
                  bussinessDetailsDB?.subType !== "BNI-CHAPTER" && (
                    <>Done Editing</>
                  )}
              </IonButton>
            )}
        </IonFooter>
        {/* {compositeNavJsx} */}
        <Suspense fallback={<LazyLoaderSpinner />}>
          {openContactMe && contactCardJsx}
        </Suspense>
        <Suspense fallback={<LazyLoaderSpinner />}>
          {!!total && cartFooterJsx}
        </Suspense>
        {/* <Suspense fallback={<LazyLoaderSpinner />}>
          {!!openNavRedirect.open && (
            <BhpPopoverCustom
              body={{
                text: `Redirecting to ${bussinessDetailsDB.name} navigation page`,
                subText: openNavRedirect?.shopName
                  ? `Find directions to ${openNavRedirect.shopName}`
                  : undefined,
              }}
              buttons={[
                {
                  onClick: () => {
                    if (!openNavRedirect?.shopId) {
                      hotKeyFunctions["pathFinder"]();
                    } else {
                      history.push(
                        `/maps?marketId=${bussinessDetailsDB.id}&floorId=${bussinessDetailsDB.floorId}&shopId=${openNavRedirect.shopId}`
                      );
                    }
                  },
                  autoTriggerSec: 5,
                  color: "secondary",
                  fill: "clear",
                  icon: navigateSharp,
                  text: "Market Navigator",
                },
                {
                  onClick: () => {
                    setOpenNavRedirect({ open: false });
                  },
                  color: "primary",
                  icon: enterOutline,
                  fill: "solid",
                  text: "Explore Market",
                },
              ]}
              header={{ title: "Path Finder" }}
              onDismiss={() => {
                setOpenNavRedirect({ open: false });
              }}
              open={openNavRedirect.open}
              backdropDismiss={false}
            />
          )}
        </Suspense> */}
        <Suspense fallback={<LazyLoaderSpinner />}>
          {openCatSel && categoriesSelectionJsx}
        </Suspense>
        <Suspense fallback={<LazyLoaderSpinner />}>
          {!!bookingModal && bookTableJsx}
        </Suspense>
        <Suspense fallback={<LazyLoaderSpinner />}>
          {!!discountModal && generateDiscountJsx}
        </Suspense>

        <Suspense fallback={<LazyLoaderSpinner />}>
          {checkout.open && checkOutModalJsx}
        </Suspense>
        <Suspense fallback={<LazyLoaderSpinner />}>
          {!!isOpenCard && expandCardJsx}
        </Suspense>
        {/* <Suspense fallback={<LazyLoaderSpinner />}>
          {openCouponRedeem.open && redeemCouponJsx}
        </Suspense> */}
        <Suspense fallback={<LazyLoaderSpinner />}>
          {selectFloors && floorSelectorJsx}
        </Suspense>
        <Suspense fallback={<LazyLoaderSpinner />}>
          {selCallWhatsapp && callWhatsappSelJsx}
        </Suspense>

        <Suspense fallback={<LazyLoaderSpinner />}>
          {openSignInSignUpModal && (
            <SignInSignUpSelector
              selectionCallback={setSigninSignUpSelectionCbk}
              openModal={openSignInSignUpModal}
              onDidDismiss={() => {
                setOpenSignInSignUpModal(false);
              }}
            />
          )}
        </Suspense>
        <Suspense fallback={<LazyLoaderSpinner />}>
          {signinupModal.open && (
            <SignInSignUpModal
              logoutRedirectUrl={logoutRedirectUrl}
              changePassword={signinupModal?.changePassword}
              prompt={signinupModal?.msg}
              bhpTheme={true}
              mode="popover"
              openModal={signinupModal}
              navCallback={(inp) => {
                setsigninupModal(inp);
                return false;
              }}
              email={customerEmail}
              postLoginHandler={updateCustomerDetailsWithLoginInfo}
              cssClassName={
                isMobile
                  ? "bussiness-home-page-modal-full"
                  : "bussiness-home-page-modal-half"
              }
              role="CUSTOMER"
              disableSelector={false}
              onDidDismiss={() => {
                setsigninupModal({ isSignup: false, open: false });
              }}
            />
          )}
        </Suspense>
        <Suspense fallback={<LazyLoaderSpinner />}>
          {execAlert.open && (
            <AlertWithExec openAlert={execAlert} setOpenAlert={setExecAlert} />
          )}
        </Suspense>
      </IonPage>
    </>
  );
}; //End of BussinessHomePage

const SubHeader: React.FC<{
  noBg?: boolean;
  bgStyle?: string;
  bg?: string;
  text: string;
  isSpecial: boolean;
  enableStickyScroll: boolean;
  topOffsetPx?: number;
  headingLine?: boolean;
  buttons?: SubheaderButtonType[];
  subheader?: string;
  listModeListing?: boolean | number;
  img?: { fileName: string };
  textColor?: string;
  textWeight?: "normal" | "bold";
  enableAvatar?: boolean;
  darkMode?: boolean;
  rightJsx?: any;
  enableSearchBar?: {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
  };
}> = (props) => {
  const loginLogo = `${IDIGIZEN_BACKEND_URL}/${getFileThumbnailDB}?fileName=${props.img?.fileName}&percentage=40&Authorization=${API_SECURE_KEY}&`;
  const scrollCss = props.enableStickyScroll ? "subheader-sticky-scroll" : "";
  const fontCss = "subheader-font-mob";
  const nonListModeJsx = (
    <div
      className={
        props.isSpecial
          ? `subheader ${scrollCss} ${fontCss}`
          : `subheader ${scrollCss} ${fontCss}`
      }
      style={{
        background: props.noBg
          ? "none"
          : props.bgStyle
          ? props.bgStyle
          : props?.darkMode
          ? `var(--ion-color-bhp-hdr-dark)`
          : "var(--ion-color-bhp-white)",
        top: props.topOffsetPx ? `${props.topOffsetPx}px` : 0,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {props?.enableAvatar && !!props?.img && (
          <div
            style={{
              height: "35px",
              width: "35px",
              border: "2px solid var(--ion-color-bhp-lightgray)",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              marginLeft: "10px",
              borderRadius: "50%",
              overflow: "hidden",
            }}
          >
            <img src={loginLogo} alt="" style={{ objectFit: "cover" }} />
          </div>
        )}
        <h2
          className={
            props.listModeListing ? "subheader-text-listmode" : "subheader-text"
          }
          style={{
            color: props?.textColor
              ? props.textColor
              : props?.darkMode
              ? "var(--ion-color-light)"
              : undefined,
            fontWeight: props?.textWeight,
            margin: 0,
            paddingLeft: props?.enableAvatar ? "5px" : undefined,
          }}
          id={`sub-header-${props.text}`}
        >
          {props.text}
        </h2>
        {props.headingLine && (
          <div
            style={{
              height: "1px",
              background: props?.darkMode
                ? "linear-gradient(to right, var(--ion-color-light), var(--ion-color-medium))"
                : "linear-gradient(to right, var(--ion-color-medium), var(--ion-color-bhp-base))",
              flexGrow: "1",
              marginRight: "10px",
              marginLeft: "10px",
            }}
          ></div>
        )}
        {!!props.rightJsx && <div>{props.rightJsx}</div>}
        {!!props.buttons &&
          props.buttons.map((el, idx) => {
            return (
              <div
                key={idx}
                color={el.color}
                className="subheader-button"
                style={{
                  background:
                    el.color === "none"
                      ? "none"
                      : `var(--ion-color-${el.color})`,
                  fontSize: el.fontSize ? el.fontSize : undefined,
                }}
                onClick={el.onClick}
                id={`sub-header-buttons-${props.text}-${el.name}`}
              >
                {el.name}
              </div>
            );
          })}
      </div>
      {!!props.enableSearchBar && (
        <IonSearchbar
          value={props.enableSearchBar.value}
          onIonChange={(e) => {
            props.enableSearchBar.onChange(e.detail.value || "");
          }}
          placeholder={props.enableSearchBar?.placeholder || "Search"}
        />
      )}
    </div>
  );

  const listModeJsx = (
    <div
      style={{
        width: "100%",
        height: "80px",
        // border: "1px solid red",
        display: "flex",
        justifyContent: "end",
        top: props.topOffsetPx ? `${props.topOffsetPx}px` : 0,
        position: scrollCss ? undefined : "relative",
      }}
      className={"subheader-list-mode-header " + scrollCss}
    >
      <img
        src={loginLogo}
        alt="login logo"
        style={{ height: "100%", width: "60%", objectFit: "cover" }}
        loading="lazy"
      />
      <div className="subheader-list-mode-header-bg">
        <h2
          style={{
            margin: 0,
            textAlign: "center",
            fontSize: "1.2rem",
            fontWeight: "bold",
            color: "var(--ion-color-bhp-footer)",
          }}
        >
          {props.text}
        </h2>
        {!!props.buttons?.length && (
          <div
            style={{
              fontSize: ".7rem",
              marginTop: "5px",
              padding: "5px 8px",
              background: "var(--ion-color-bhp-footer)",
              color: "white",
              boxShadow: "0px 5px 45px -18px rgba(0,0,0,0.71)",
              borderRadius: "5px",
            }}
            onClick={props.buttons[0].onClick}
          >
            {props.buttons[0].name}
          </div>
        )}
      </div>
    </div>
  );

  return (
    <>
      {!props.listModeListing && nonListModeJsx}
      {!!props.listModeListing && listModeJsx}
      {!!props.subheader && (
        <div
          style={{
            padding: "0 10px",
            paddingBottom: "10px",
            fontSize: "0.8rem",
            color: props.darkMode
              ? "lightgray"
              : "var(--ion-color-bhp-font-color)",
            textAlign: props.listModeListing ? "center" : "start",
          }}
        >
          {props.subheader}
        </div>
      )}
    </>
  );
};

export default BussinessHomePage;
export { SubHeader };
export type {
  BusinessDetailsType,
  AdvertisingDetailsType,
  ColorThemeInterface,
  BussinessHomeCardData,
  OrderModeType,
  TextCartItemType,
  BusinessProductCategoryWithProducts,
  SubscriptionType,
  BussinessCatalogueProducts,
  CustomerDetailsType,
  ResidentDetailsType,
  BhpMarketTypes,
  PopoverPromoType,
  BhpHotKeysType,
  StyleDataType,
  SeoUrlDetailsType,
  BusinessTestimonialDetails,
  MarketShopStatusDataType,
  MarketShopStatusHistoryDataType,
  BhpShopStatusType,
  // BhpMarketBlocksType,
};

export {
  BusinessHomePageSection,
  BhpThemeHeaderWithBack,
  theme,
  BhpSearchButton,
};
